/* eslint-disable no-useless-escape */
/* eslint-disable max-len */
const en = {
  statuses: {
    OK: 'OK',
    SPOT_NOT_SUPPORTED: 'Spot not supported',
    STACK_NOT_SUPPORTED: 'Stack not supported',
    NO_GTO_SOLUTION: 'No GTO solution',
    UNSUPPORTED_PLAYERS: 'Unsupported players',
    ZERO_PERCENT_ACTION: 'Zero percent action',
    ERROR: 'Error',
    LIMIT_REACHED: 'Limit reached',
    PROCESSING: 'Processing',
  },
  filter_categories: {
    general: 'General',
    score: 'Score',
    blinds: 'Blinds',
    board: 'Board',
    hands: 'Hands',
    colors: 'Colors',
    date: 'Date',
    other: 'Other',
    advanced: 'Advanced',
    applied_filters: 'Applied filters',
    // general: 'General',
    // date: 'Date',
    cards: 'Cards',
    game: 'Game',
    players: 'Players',
    stats: 'Stats',
  },
  common: {
    aggressor: 'Preflop Raiser',
    defender: 'Preflop Caller',
    clear_all: 'Clear all',
    calculate: 'Calculate',
    unknown: 'Unknown',
    graph: 'Graph',
    of: 'of',
    or: 'or',
    choose_rake: 'Choose rake',
    choose_tournament_structure: 'Choose tournament structure',
    rakes: 'Rakes',
    min: 'Min',
    max: 'Max',
    color: 'Color',
    solution_name: 'Solution name',
    copy_whole_range: 'Whole range',
    basic: 'Basic',
    current_ev: 'Current EV',
    previous_ev: 'Previous EV',
    current: 'Current',
    previous: 'Previous',
    summary: 'Summary',
    id: 'ID',
    stacks: 'Stacks',
    pot: 'Pot',
    overwrite: 'Overwrite',
    apply_xxx: 'Apply: {name}',
    no_results: 'No results',
    days: 'Days',
    hours: 'Hours',
    minutes: 'Minutes',
    seconds: 'Seconds',
    create_drill: 'Create drill',
    play_against_gto: 'Play against GTO',
    see_how_it_works: 'See how it works',
    postflop: 'Postflop',
    how_it_works: 'How it works',
    // introducing: 'Introducing  GTO Wizard AI',
    watch_video: 'Watch video',
    open_video: 'Open video',
    video_available: 'Video available',
    reports: 'Reports',
    link_text: '<a href="{url}" target="_blank" class="{cssClass}">{text}</a>',
    // custom_solution: 'AI solution',
    custom_solution: 'Custom solution',
    custom_solution_settings: 'Solution settings',
    elite: 'Elite',
    rename: 'Rename',
    save_tree_settings: 'Save tree settings',
    steps_xxx: '{str} steps',
    always: 'Always',
    never: 'Never',
    weight: 'Weight',
    count: 'Count',
    add_size: 'Add size',
    remove_size: 'Remove size',
    flops_singular: 'Flop',
    high_cards_singular: 'High card',
    suits_singular: 'Suit',
    pairing_singular: 'Pairing',
    connectedness_singular: 'Connectedness',
    turns_singular: 'Turn',
    card_ranks_singular: 'Card',
    nodelock: 'Nodelock',

    // paint_custom: 'Set strategy',
    // paint_erase: 'Eraser',
    // paint_lock: 'Lock',
    // paint_unlock: 'Unlock',
    // paint_frequency: 'Frequency',
    painter: 'Set strategy',
    frequency: 'Set frequency',
    locker: 'Lock / Unlock',

    // TODO review these keys and possible delete
    lock: 'Lock',
    manual: 'Manual',
    // paint_gto: 'Paint GTO',
    detail: 'Detail',

    ip: 'IP',
    oop: 'OOP',
    oop1: 'OOP+1',
    new: 'New',
    add: 'Add',
    remove: 'Remove',
    reports_xxx: 'Reports: {str}',
    hands_uploaded: 'Uploaded hands',
    trainer_range_compare: 'Compare ranges',
    visible_filters: 'Visible filters',
    available_preflop_strategy_options: 'Available Preflop options:',
    // choose_all_hands: 'Select all',
    // all_combos: 'All combos',
    examples_is: 'Examples:',
    pot_odds: 'Pot odds',
    pot_odds_is: 'Pot odds:',
    pot_odds_xxx: 'Pot odds: {str}',
    suited: 'Suited',
    offsuited: 'Offsuit',
    exclude_suited: 'Exc. Suited',
    exclude_offsuited: 'Exc. Offsuit',
    help_center: 'Help center',
    help_center_sub: 'Tips & Tricks for GTO Wizard',
    // any_card: 'Any suit',
    // first_or_second_card: 'First and second suit',
    favorite_videos: 'Favorite videos',
    favorite: 'Favorite',
    // not_favorite: 'Not favorite',
    watched_videos: 'Watched videos',
    // watched: 'Watched',
    not_watched: 'Not watched',
    show: 'Show',
    hide: 'Hide',
    first_card: 'First card',
    second_card: 'Second card',
    see_all_hands: 'See all hands',
    trainer_session: 'Trainer session',
    // tasks: 'Tasks',
    steps: 'Steps',
    learn_more: 'Learn more',
    resources: 'Resources',
    see_all_coachings: 'See all coachings',
    all_coachings: 'All coachings',
    socials: 'Socials',
    follow_us: 'Follow us',
    trainer_stats: 'Trainer stats',
    analyzer_stats: 'Analyzer stats',
    bounties: 'Bounties',
    content: 'Content',
    bubble_factor_abbr: 'Bubble',
    bubble_factor: 'Bubble factor',
    highlight: 'Highlight',
    view_as: 'View as',
    // filter_by_any_tags: 'Filter by any',
    // filter_by_all_tags: 'Filter by combination',
    _3bet_xxx: '3b: {str}',
    full_match: 'Full match',
    clear_board: 'Clear board',
    clear_hand: 'Clear hand',
    manage: 'Manage',
    summary_tab: `Summary tab`,
    remove_tag: 'Remove tag',
    filtered: 'Filtered',
    usage_examples: 'Usage examples',
    no_description: 'No description',
    manage_drills: 'Manage drills',
    all_drills: 'All Drills',
    favorite_drills: 'Favorite Drills',
    go_to_xxx: 'Go to {name}',
    decrease_lowercase: 'decrease',
    increase_lowercase: 'increase',
    xxx_minutes: '{n}min | {n}min',
    xxx_hours: '{n}hr | {n}hrs',
    xxx_hours_xxx_minutes: '{xxx_hours} {xxx_minutes}',
    xxx_days: '{n}day | {n}days',
    drill_type: 'Drill type',
    public_drills: 'GTO Wizard Drills',
    my_drills: 'My Drills',
    xxx_selected_items: '{num} selected items',
    tags: 'Tags',
    create: 'Create',
    solution_selector: 'Solution selector',
    payouts: 'Payouts',
    avg_stack_bb: 'Avg. {stack}<span class="text-smallest" style="line-height: 1">bb</span>',
    stack_bb: '{stack}<span class="text-smallest" style="line-height: 1">bb</span>',
    stack_bb_str: '{stack}<span class="text-smallest" style="line-height: 1">bb ({str}str)</span>',
    stack_str: '{str}str',
    reports_flop_filter: 'Reports flop filter',
    reports_flop_filters: 'Reports flop filters',
    reports_turn_filter: 'Reports turn filter',
    filters_saved_filters: 'Saved filters',
    filters_saved_trees: 'Saved solutions',
    filters_saved_ranges: 'Saved ranges',
    drill_filter: 'Drill filter',
    stack_big: 'Big',
    stack_short: 'Short',
    select_new_solution: 'Select new solution',
    select_postflop_spot: 'Select postflop spot',
    stop_timebank: 'Stop timebank',
    timebank: 'Timebank',
    streak: 'Streak',
    colored: 'Colored',
    blank: 'Blank',
    none: 'None',
    noname: 'Noname',
    stats: 'Stats',
    need_help: 'Need help?',
    coming_soon: 'Coming soon',
    more_stats: 'More stats',
    date_shortcuts: 'Shortcuts',
    close_session: 'Close session',
    avg: 'Avg.',
    info: 'Info',
    see_results: 'See results',
    randomize: 'Randomize',
    random_v2: 'Random',
    select_random_card: 'Select random card',
    shuffle: 'Shuffle',
    bb: 'bb',
    bb_hand: 'bb/hand',
    pot_hand: '%pot/hand',
    percent_hand: '%/hand',
    bb_mistake: 'bb/mistake',
    pot_mistake: '%pot/mistake',

    num_situations: '{n} situation | {n} situations',
    num_selected: '{n} selected',
    num_selected_from_num_situations: '{num_selected} from {num_situations}',
    skipped_situations: '({n} skipped)',

    show_on_entering_study: 'Show on entering Study mode',
    description: 'Description',

    effective_stack: 'Effective stack',
    average_stack: 'Average stack',
    avg_stack: 'Avg. stack',
    hand_num: 'Hand num.',

    google_calendar: 'Google calendar',
    ios_calendar: 'Apple calendar',
    google: 'Google',
    ios: 'Apple',

    filter_description: 'Filter description',
    filter_name: 'Filter name',

    // selected_num_situations: 'Selected {num} situations',
    // exceeded_trainer_selected_stacks_limit: 'Exceeded number of custom situations for a session. First {limit} situations will be used.',
    // links_to_guide: 'Links to this guide:',

    saved_filters: 'Saved filters',

    key_shift: '{key} + Shift',
    ArrowUp: 'Arrow Up',
    ArrowDown: 'Arrow Down',
    ArrowLeft: 'Arrow Left',
    ArrowRight: 'Arrow Right',

    arrow_up_down: 'Up / Down',
    // arrow_up_down: 'Arrow Up/Down',

    note: 'Note',
    name: 'Name',
    mistakes: 'Mistakes',
    worst_hand: 'Worst hand',
    best_hand: 'Best hand',
    totals: 'Totals',
    only_starred: 'Only starred',
    expand_collapse_history: 'Expand / Collapse History',
    inverted: 'Inverted',
    default: 'Default',
    num_players: '{num} players',
    num_hands_session: '{n} hand session | {n} hands session',
    preferred_seat: 'Preferred seat',
    back_to_themes: 'Back to themes',
    preview: 'Preview',
    trainer_themes: 'Trainer themes',
    gameformat_session: '{gmf} session',
    show_hands: 'Show hands',

    from: 'From',
    to: 'To',
    _1: 'One',
    _2: 'Two',
    _3: 'Three',
    _4: 'Four',
    // _1_th: 'First',
    // _2_th: 'Second',
    // _3_th: 'Third',
    // _4_th: 'Fourth',

    _1_th: '1st',
    _2_th: '2nd',
    _3_th: '3rd',
    _4_th: '4th',

    trainer: 'Trainer',
    'trainer_tra/alpha_th': '1st',
    'trainer_tra/beta_th': '2nd',
    'trainer_tra/gamma_th': '3rd',
    'trainer_tra/delta_th': '4th',

    'trainer_table_tra/alpha': '1st table',
    'trainer_table_tra/beta': '2nd table',
    'trainer_table_tra/gamma': '3rd table',
    'trainer_table_tra/delta': '4th table',

    clear_key: 'Clear <span class="keyboardkey_key clr-white">{key}</span>',
    close_key: 'Close <span class="keyboardkey_key clr-white">{key}</span>',
    close_focusmode_key: 'Exit Focus mode <span class="keyboardkey_key clr-white">{key}</span>',
    close_focusmode: 'Exit Focus mode',

    single_table: 'Single',
    tables: 'Tables',
    table: 'Table',
    trainer_tables: '{num} tables',
    specific_board: 'Specific board',
    press_hotkey_to_switch: 'Press <span class="keyboardkey_key">{key}</span> to switch',
    other: 'Other',
    range_table_cell: 'Range matrix',
    hand_table_cell: 'Hand matrix',
    colors: 'Colors',
    cards: 'Cards',
    // appearance: 'Appearance',
    youtube_channel: 'Our YouTube',
    themes: 'Themes',
    score: 'Score',
    good_moves: 'Good Moves',
    bad_moves: 'Bad Moves',
    session_hands: 'Session {n} hand | Session {n} hands',
    low: 'Low',
    high: 'High',
    todays_coaching: 'Upcoming coaching',
    supported_browser_version_list: 'See all supported browsers',
    tips_tricks: 'Tips & Tricks',
    import_drill: 'Import drill',
    import_palette: 'Import theme',
    import_setting: 'Import setting',
    export_setting: 'Export setting',
    theory: 'Theory',
    coaches: 'Coaches',
    formats: 'Formats',
    waiting: 'Waiting...',
    ev_player: 'EV {player}',
    ev: 'EV',
    eq: 'EQ',
    eqr: 'EQR',
    range: 'Range',
    varying_stacks: 'Mixed stacks',
    close_forever: 'Close forever',
    custom_preset: 'Custom drill',
    new_drill: 'New drill',
    custom_drills: 'My Drills',
    new_preset_name: 'Drill name',
    new_preset_description: 'Drill description (optional)',

    new_tree_name: 'Settings name',
    // new_tree_description: 'Solution description (optional)',

    new_range_name: 'Range name',
    // new_range_description: 'Range description (optional)',

    new_solution_name: 'Solution name',
    // new_solution_description: 'Solution description (optional)',

    newest: 'Newest',
    oldest: 'Oldest',

    asc: 'Ascending',
    desc: 'Descending',

    single_spot: 'Single spot',
    moves: 'Moves',
    gto_score: 'GTOW Score',

    display: 'Display',
    game: 'Game',
    modes: 'Modes',
    ev_loss: 'EV Loss',
    drills: 'Drills',
    configure_session: 'Configure session',
    live: 'Live',
    presets: 'Presets',

    // new_session: 'Next hand',
    // repeat_session: 'Repeat hand',
    stop_session: 'Stop session',
    start_session: 'Start session',
    restart_session: 'Restart session',

    equity: 'Equity',
    hand_strength: 'Hand strength',
    hand_strength_short: 'Strength',

    accuracy: 'Accuracy',
    show_opponent_range: 'Show opponent range',
    show_hero_range: 'Show hero range',
    show_hero_strategy: 'Show hero strategy',
    show_players_ranges: 'Show ranges',
    // show_players_range_tooltip: 'Show range',

    gg_short: 'GG',
    gg_long: 'Good game',
    gg_ai_turn_reports: 'Custom Turn Reports <br> are coming soon.',

    controls: 'Controls',
    total_combos: 'Total combos',
    will_be_hands: 'Select which hands you want to be dealt',
    versus_short: 'vs.',
    oop_vs_ip: '{oop} vs {ip}',
    // custom_solution: 'Custom solution',
    situation: 'Situation',
    hand: 'Hand',
    board: 'Board',
    preferences: 'Preferences',
    main: 'Main',
    hints: 'Hints',
    feedback: 'Feedback',
    session: 'Session',
    overview: 'Overview',
    heros: 'Heros',
    opponents: 'Opponents',
    all: 'All',
    rules: 'Rules',
    select_situation: 'Starting spot',
    more_settings: 'More settings',
    real_game: 'Real game',
    // custom_spot: 'Custom spot',
    custom_spot: 'Custom',
    any_bet: 'Any Bet',
    standoff: 'Standoff',
    preflop: 'Preflop',
    from_start: 'From start',
    flop: 'Flop',
    turn: 'Turn',
    river: 'River',
    solutions: 'Solutions',
    hands_filter: 'Hands filter',
    analyzed_hands_filter: 'Analyzed hands filter',
    practice_hands_filter: 'Practice hands filter',
    sessions_filter: 'Sessions filter',
    hands_filters: 'Hands filters',
    analyzed_hands_filters: 'Analyzed hands filters',
    practice_hands_filters: 'Practice hands filters',
    sessions_filters: 'Sessions filters',
    rng: 'RNG',
    players: 'Players',
    player: 'Player',
    street: 'Street',
    start_spot: 'Start spot',
    variable_depths: 'Variable depths',
    gto: 'GTO',
    opponent: 'Opponent',
    gto_opponent: 'GTO - Opponent',
    hero: 'Hero',
    folded: 'Folded',
    non_folded: 'Active',
    gameformat: 'Gameformat',
    postflop_only: 'Postflop only',
    saved_spots: 'Saved spots',
    current_spot: 'Current spot',
    correct: 'Correct',
    wrong: 'Wrong',
    best: 'Best',
    worst: 'Worst',
    total: 'Total',
    difficulty: 'Difficulty',
    format: 'Format',
    mode: 'Mode',
    spots: 'Spots',
    simple: 'Simple',
    easy: 'Easy',
    medium: 'Medium',
    advanced: 'Advanced',
    hard: 'Hard',
    undo: 'Undo',
    redo: 'Redo',
    combos: 'Combos',
    affiliate: 'Affiliate',
    on: 'On',
    off: 'Off',
    date: 'Date',
    time: 'Time',
    date_shortut: 'Date shortcuts',
    finish: 'Finish',
    read_more_here: 'Read more here.',
    read_more: 'Read more',
    read_more_info: 'Read more info',
    click_here: 'Click here',
    confirm: 'confirm',
    go_premium: 'go premium',
    go_elite: 'go elite',
    random: 'Any',
    custom: 'Custom',
    change: 'Change',
    any: 'Any',

    soon: 'soon',
    // soon_tra01: 'Soon',
    beta_lowercase: 'beta',
    beta: 'Beta',
    help: 'Help',
    tutorial: 'Tutorial',
    get_help_discord: 'Get help on Discord',
    disable_tips: 'Show tips',
    hands: 'Hands',
    draws: 'Draws',
    eq_buckets: 'Equity buckets',
    eq_buckets_advanced: 'Equity buckets - Advanced',
    equity_buckets: 'Equity buckets',
    equity_buckets_advanced: 'Equity buckets - Advanced',
    keep_waiting: 'Keep waiting.',
    starred: 'Starred',
    not_starred: 'Not starred',
    file: 'file',
    files: 'files',
    start_tour: 'Show me around',
    chat_with_us: 'Chat with us',
    contact_us_via_chat: 'Contact us via chat',
    chat: 'chat',
    here: 'here',
    make_a_suggestion: 'Make a suggestion',
    your_format: 'Your format:',
    select: 'Select',
    select_all: 'Select all',
    unselect_all: 'Unselect all',
    blog: 'Blog',
    daily_dose_of_gto: 'Daily dose of GTO',
    strategy: 'Strategy',
    sort_by: 'Sort by',
    grouping: 'Grouping',
    view: 'View',
    actions: 'Actions',
    filters: 'Filters',
    month: 'month',
    year: 'year',
    free: 'Free',
    search: 'Search',
    nothing_found: 'Nothing found!',
    global: 'Global',
    email: 'Email',
    install: 'Install',
    android: 'Android',
    iphone: 'Iphone',
    tablet: 'Tablet',
    uploads: 'Uploads',
    in_premium: 'in Premium',
    premium: 'Premium',
    settings: 'Settings',
    my_filters: 'My filters',
    filter: 'Filter',
    details: 'Detail',

    loading: 'Loading',
    used_by: 'Used by',
  },

  btn: {
    upload_hands: 'Upload hands',
    duplicate: 'Duplicate',
    retry: 'Retry',
    lock_all_and_continue: 'Lock all & continue',
    unlock_all: 'Unlock all',
    nodelock: 'Nodelock',
    upgrade_now: 'Upgrade now',
    play_now: 'Play now',
    edit_solution: 'Edit solution',
    disable: 'Disable',
    create: 'Create',
    next_step: 'Next step',
    detail: 'Detail',
    create_custom_solution: 'Create solution',
    new_custom_solution: 'New solution',
    create_custom_report: 'Create report',
    fork: 'Fork',
    copy: 'Copy',
    paste: 'Paste',
    save_filter: 'Save filter',
    see_results: 'See results',
    study: 'Study',
    replay: 'Replay',
    start_plan: 'Start plan',
    intro: 'Intro',
    play_video: 'Play video',
    see_all: 'See all',
    show_all: 'Show all',
    add_links: 'Add links',
    assign_tags: 'Assign tags',
    reload: 'Reload',
    my_filters: 'My filters',
    stop: 'Stop',
    learn_more: 'Learn more',
    show_hands: 'Show hands',
    edit_name: 'Edit name',
    delete: 'Delete',
    more: 'More',
    view_more: 'View more',
    show_more: 'Show more',
    clear_filter: 'Clear filter',
    filter: 'Filter',
    try_it_now: 'Try it now',
    edit: 'Edit',
    open: 'Open',
    go_premium: 'Go Premium',
    go_elite: 'Go Elite',
    premium: 'Premium',
    try_for_free: 'Try for free',
    apply_now: 'Apply Now',
    register_now: 'Register Now',
    your_email: 'Your email',

    normal: 'Normal',
    fast: 'Fast',
    turbo: 'Turbo',
    easy: 'Easy',
    medium: 'Medium',
    hard: 'Hard',
    copy_url: 'Copy url',
    show_history: 'Show history',
    history: 'History',
    end: 'End',
    end_session: 'End session',
    repeat_session: 'Repeat session',
    hide: 'Hide',
    continue_session: 'Continue session',
    play_session: 'Play session',
    new_session: 'New session',
    reset_session: 'Reset session',
    play_again: 'Play again',
    new: 'New',
    new_drill: 'New drill',
    refresh: 'Refresh',
    refresh_this_view: 'Refresh this view',
    refresh_table: 'Refresh table',

    repeat_hand: 'Repeat hand',
    next_hand: 'Next hand',
    stop_next_hand: 'Stop next hand',
    play_from_here: 'Play from here',
    play_as_hero: 'Play as hero',
    change_bot_action: 'Change opponent move',
    change_move: 'Change move',

    repeat_hand_abbr: 'Repeat',
    next_hand_abbr: 'Next',
    stop_next_hand_abbr: 'Stop next',
    play_from_here_abbr: 'Play',
    play_as_hero_abbr: 'Play',
    change_move_abbr: 'Change',

    start_drill: 'Start drill',
    settings: 'Settings',
    repeat: 'Repeat',
    return_to_game: 'Return to game',
    expand: 'Expand',
    collapse: 'Collapse',

    overwrite: 'Overwrite',
    confirm_overwrite: 'Confirm overwrite',
    cancel_overwrite: 'Cancel overwrite',

    start_new_game: 'Start new game',
    start_training: 'Start training',
    advanced_settings: 'Advanced settings',
    all_settings: 'All settings',

    pause: 'Pause',
    play: 'Play',
    // cancel_replay: 'Cancel replay',

    on: 'On',
    off: 'Off',
    save_as: 'Save as',
    save_as_new: 'Save as New',

    after_action: 'Action',
    after_mistake: 'Mistake',

    stop_hand: 'Stop hand',
    stop_after_mistake: 'After mistake',
    play_against_self: 'Play against self',
    // stop_after_action: 'Single spot',
    stop_after_action: 'Spot',
    stop_end_of_hand: 'Full hand',
    stop_end_of_street: 'Street',

    high_rng: `High RNG`,
    low_rng: `Low RNG`,
    trainer_frequency: 'Frequency',
    trainer_actions: 'Actions',
    hero_only: 'Hero only',
    '50_hands': '50 hands',
    '100_hands': '100 hands',
    '20_hands': '20 hands',
    // '5_sec': '5s',
    '0_sec': 'Instant',
    // '1_sec': 'Instant',
    '1_sec': '1s',
    '2_sec': '2s',
    '3_sec': '3s',
    '4_sec': '4s',
    '5_sec': '5s',
    '6_sec': '6s',
    '7_sec': '7s',
    '8_sec': '8s',
    '9_sec': '9s',
    '10_sec': '10s',
    '11_sec': '11s',
    '12_sec': '12s',
    '15_sec': '15s',
    '20_sec': '20s',
    '25_sec': '25s',
    '9999_sec': '9999s',

    start_game: 'Start Game',

    mode_specific_spot: 'Specific spot',
    mode_full_hand: 'Full hand',
    variable_stack_depth: 'Variable stack/depth',

    trainer_quick_result_enabled: 'Quick result',
    trainer_game_mode: 'Frequency mode',
    trainer_chart_total_freq: 'Show total solution frequency',
    trainer_show_frequency: 'Show frequency',
    trainer_op_frequency: 'Show opponent frequency',
    trainer_stop_stop_after_mistake: 'Stop after mistake',
    trainer_play_against_self: 'Play against yourself',
    trainer_apply_rng: 'Apply RNG',
    trainer_autoplay: 'Auto new hand',
    trainer_confirm_slider: 'Confirm slider',

    trainer_stats_session: 'Session',
    trainer_stats_all_time: 'All-time',

    join_coaching: 'Join coaching',
    contact_us_on_discord: 'Contact us on Discord',
    watch_now: 'Watch now',
    watch_video: 'Watch video',
    try_again: 'Try again',
    next_board: 'Next board',
    start_range_build: 'Start building',
    start_range_quiz: 'Start quiz',
    start_practice: 'Start practice',
    start: 'Start',
    select_board: 'Select board',
    generate_report: 'Generate report',
    reports: 'Reports',
    flop: 'Flop',
    turn: 'Turn',
    see_more: 'See more',
    read_more: 'Read more',
    all_info: 'All info',
    configure_new_game: 'Configure new game',
    join: 'Join',

    upgrade_join: 'Upgrade to join',
    upgrade_watch: 'Upgrade to watch',

    // upgrade_to_gametype_tier: 'Upgrade to {tier} {gametype}',

    save: 'Save',
    load: 'Load',
    save_table: 'Save table',
    save_spots: 'Save spots',

    update: 'Update',
    cancel: 'Cancel',
    next: 'Next',
    cancel_dont: `Don't cancel`,
    change: 'Change',
    back: 'Back',
    forward: 'Forward',
    back_abbr: 'BK',
    forward_abbr: 'FWD',
    step: 'Step',
    apply: 'Apply',
    close: 'Close',
    close_report: 'Close Report',
    close_all_other_reports: 'Close all other Reports',
    get_more_hands: 'Get more hands',
    get_started: 'Get started',
    upgrade: 'Upgrade',
    upgrade_to_ai_solving: 'Upgrade to unlock posflop AI solving',
    analyze: 'Analyze',
    upload_files: 'Upload files',
    upload_folder: 'Upload folder',
    btn_upload_files: 'Files',
    btn_upload_folder: 'Folder',
    select: 'Select',
    activate: 'Activate',
    confirm: 'Confirm',
    save_confirm: 'Save & confirm',
    reset: 'Reset',
    reset_default: 'Reset to default',
    clear: 'Clear',
    clear_all: 'Clear all',
    confirm_reset: 'Confirm reset',
    cancel_subscription: 'Cancel subscription',
    upload: 'Upload',
    stats: 'See statistics',
    continue: 'Continue',
    install_app: 'Install app',
    upgrade_plan: 'Upgrade plan',
    export_colors: 'Export theme',
    export: 'Export',
    import: 'Import',
    return: 'Return',
    apply_theme: 'Apply theme',
    select_postflop: 'Select postflop',
    read_more_here: 'Read more here',
    delete_selected_files: 'Delete files',
    delete_selected_file: 'Delete file',
    delete_selected_hands: 'Delete hands',
    delete_selected_hand: 'Delete hand',
    confirm_delete: 'Confirm delete',
    cancel_delete: 'Cancel delete',
    delete_selected: 'Delete selected',
    mark_selected: 'Mark selected',
    unmark_selected: 'Unmark selected',
    toggle_favorite: 'Toggle favorite',

    delete_selected_rows: 'Delete selected rows',
    delete_selected_row: 'Delete selected row',

    accept: 'Accept',
    decline: 'Decline',
    ranges: 'Ranges',
    // arrow_right:''
    // arrow_left:''
  },
  days: {
    mon: 'Monday',
    tue: 'Tuesday',
    wed: 'Wednesday',
    thur: 'Thursday',
    fri: 'Friday',
    sat: 'Saturday',
    sun: 'Sunday',
    today: 'Today',
    yesterday: 'Yesterday',
  },
  months: {
    jan: 'January',
    feb: 'February',
    mar: 'March',
    apr: 'April',
    may: 'May',
    jun: 'June',
    jul: 'July',
    aug: 'August',
    sep: 'September',
    oct: 'October',
    nov: 'November',
    dec: 'December',
  },
  solutions: {
    gwiz: 'Solutions library',
    custom: 'Custom solutions',
    custom_settings: 'Custom settings',
    // custom: 'AI solutions',
    custom_reports: 'Custom reports',
  },
  solfigr: {
    icm: {
      ev_converter: {
        CSTE: {
          title: 'Chip-Scaled Tournament Equity (CSTE)',
          description:
            'Your tournament equity, scaled by the total number of chips in the tournament. For example, if your ICM share of the prizes is 5% and there are 1000 chips in play, your CSTE would be 50.',
          benefits: `CSTE offers a normalized value that can be compared across different formats and tournament stages. It is especially useful for comparing ICM and Chip EV spots, or comparing $EV to the size of the pot.`,
          formula: 'CSTE = Total_Chips x $EV / Remaining_Prizes',
          note: 'Note that $EV is relative to folding = 0',
        },
        CSTE_Pot: {
          title: '(CSTE)/Pot',
          description: `Your (tournament equity adjusted) share of the pot as a percentage. This helps gauge the portion of the pot's value you are capturing.`,
          formula: 'CSTE/Pot = (Total_Chips x $EV / Remaining_Prizes) / Pot',
          note: 'Note that $EV is relative to folding = 0',
        },
        TEQ: {
          title: 'Table Equity (TEQ)',
          description:
            'Your share of tournament equity divided by the total tournament equity of all players at your table. TEQ provides a direct measurement of your relative strength against the other players at your table.',
          formula: 'TEQ = $EV / Table $EV',
          details: {
            title: 'Details:',
            items: {
              custom_solution: 'Custom solutions: Table $EV = IP $EV + OOP $EV',
              pre_solved_solution:
                'Pre-solved solutions: Table $EV includes every player at the table.',
              note: 'Note that $EV is relative to folding = 0',
            },
          },
        },
        Dollar_EV: {
          title: 'Dollar EV ($EV)',
          description:
            'The actual cash value of prizes and bounties you expect to win, according to ICM.',
          description_link: `The actual cash value of prizes and <a href="{url0}" target="_blank" class="{cssClass}">{text0}</a> you expect to win, according to <a href="{url1}" target="_blank" class="{cssClass}">{text1}</a>.`,
          text0: 'bounties',
          text1: 'ICM',
          importance: 'This is the most direct way to view your expected value.',
        },
      },
      stacks: 'Stacks',
      pokersite: 'Poker site',
      tournament_id: 'Tournament ID',
      select_site: 'Select site',
      choose_tournament_structure: 'Choose tournament structure',
      players_and_stacks: 'Tournament Stage',
      search_tournament_by_id: 'Find tournament',
      hand_details: 'Hand Details',

      model_type: 'Equity model',
      model_type_tooltip: `
      The equity model determines how chips are valued in tournaments. <br>
      <b>Chip EV</b>: Evaluates player decisions based solely on chip accumulation, without considering payout structures. <br>
      <b>ICM</b>: The value of chips is determined using the {linkText}, which consideres the tournament's payout structure to provide a more accurate assessment of a player's tournament equity.
      `,
      model_type_tooltip_link_text: 'Independent Chip Model',

      tournament_name_unknown: 'Custom tournament',

      tournament_structure: 'Payout Structure',
      tournament_type: 'Tournament Format',
      tournament_type_tooltip: 'Select between a regular tournament or a bounty tournament.',
      bounty_instant_percentage: 'Instant Payout %',
      bounty_instant_percentage_tooltip: `Determines the percentage of a captured bounty in PKO that is immediately credited to your account, with the remainder added to your own bounty in PKO tournaments.
       For example, a 60% instant payout indicates that 60% of an eliminated players bounty is immediately claimed, while the other 40% is added to your own head.`,
      bounty_type: 'Bounty Format',
      bounty_type_tooltip: `
      Select the bounty format for the tournament: KO, PKO, or TKO. <br>
      <b>KO (Knockout)</b>: A portion of each player's buy-in goes towards their bounty, and the rest goes into the regular prize pool. Eliminate a player to capture their bounty. Note that this format can also be used to model Mystery Bounties if the average bounty size is known. <br>
      <b>PKO (Progressive Knockout)</b>: When you eliminate a player, you capture a portion of their bounty (Instant Payout %), while the remainder is added to your own bounty. <br>
      <b>TKO (Total Knockout)</b>: A specialty format where all entry fees go to bounties. There is no regular prize pool, and you capture 100% of an eliminated player's bounty.`,
      num_of_players_remaining: 'Players Remaining',
      num_of_players_remaining_tooltip: `The total number of players remaining, (including yourself and your opponent).`,
      remaining_stacks: 'Stack Distribution',
      remaining_stacks_tooltip: `
      Set the stack sizes of players not in the hand, essential for ICM calculations. <br>
      <b>Automatic</b>: Enter the number of players remaining, the average stack size, and optionally the average total bounty. The system will automatically generate the stacks for all other players (excluding yourself and your opponent). <br>
      <b>Manual</b>: Set each remaining stack independently (excluding yourself and your opponent).
      `,
      avg_stack: 'Average Stack',
      avg_stack_tooltip: `The average stack size in big blinds of all players in the tournament.`,
      avg_bounty: 'Average Total Bounty',
      avg_bounty_tooltip: `Average Total Bounty: The average total bounty of players in the tournament. In PKO, this includes both the capturable portion (displayed) and the incapturable portion (added to your own bounty).`,
      pot_size: 'Pot Size',
      pot_size_tooltip: 'The starting pot size in big blinds.',
      stack: 'Stacks',
      stack_tooltip: 'The stack sizes for OOP and IP in big blinds.',
      bounty_instant: 'Instant Bounty',
      bounty_instant_tooltip: `The immediate amount of a player's bounty that can be captured upon their elimination.`,
      bounty_total: 'Total Bounty',
      bounty_total_tooltip: `The total bounty on a players head, including both the amount you can capture and the portion that adds to your own bounty.`,

      sdt_lognormal: 'Automatic',
      sdt_manual: 'Manual',

      no_tournament_found: 'No tournament found',
      no_tournament_found_subtitle: 'Check tournament ID and try again',

      tournament_search_daily_quota_depleted: 'Daily quota of {num} searches depleted',
      tournament_search_daily_quota_depleted_subtitle: 'Please try again tomorrow',

      use_advanced_options: 'Use advanced options',

      chipev: 'Chip EV',
      icm: 'ICM',
      prefill: 'Prefill',
      my_presets: 'My presets',
      save_tournament_preset: 'Save tournament preset',

      browse: 'Browse',
      browse_subtitle: `Prefill from a list of common tournament structures`,

      search: 'Search',
      search_subtitle: `Prefill using Tournament ID`,

      regular: 'Regular',
      bounty: 'Bounty',
      KO: 'KO <span style="font-size:0.8em">Knockout</span>',
      PKO: 'PKO <span style="font-size:0.8em">Progressive Knockout</span>',
      TKO: 'TKO <span style="font-size:0.8em">Total Knockout</span>',
      full_name_NORMAL: 'Regular',
      full_name_KO: 'Bounty - Knock-Out',
      full_name_PKO: 'Bounty - Progressive Knock-Out',
      full_name_TKO: 'Bounty - Total Knock-Out',

      add_row: 'Add row',
      clear_all_prices: 'Clear all prizes',
      place: 'Place',
      prize: 'Prize ($)',

      add_table: 'Add table',

      lognormal_deviation: 'Spread',

      save_as_preset: 'Save as preset',

      bb: 'bb',
      stack_percentile: 'Stack percentile',

      error_payout_zero_prize: 'Value must be greater than 0',
      error_payout_bigger_prize_than_preceding_prize:
        'Value must be smaller or equal than previous value',
    },

    xxx_in_bb: '{str} in bb',
    has_limps: 'With Limps',
    no_limps: 'No limps',
    has_rake: 'With rake',
    no_rake: 'No rake',
    load_xxx: 'Load: {name}',

    ante_distribution_method: {
      PER_PLAYER: 'Per player',
      TOTAL: 'Total',
      BB_ANTE: 'BB Ante',
    },
    solve_postflop_ai: 'Solve postflop with AI',
    restore_all: 'All settings',
    restore_betsizes_only: 'Only bet sizes',
    apply_betsize_only_tooltip: `
    <b>All settings</b>: All parameters will be loaded, including ranges, stacks, pot, and bet sizes. <br>
    <b>Only bet sizes</b>: Only the bet sizes will be loaded. Other parameters will stay the same.`,

    // load_tree_settings: 'Load tree settings',
    // save_tree_settings: 'Save tree settings',
    // load_tree_settings: 'Load settings',
    // save_tree_settings: 'Save settings',
    // load_tree_settings: 'Load',
    // save_tree_settings: 'Save',
    save_range: 'Save range',
    save_solution: 'Save solution',
    save_tree_settings: 'Save settings',
    // click_to_create_custom_solution: 'Click here to create new solution',
    lear_more_about_custom_solutions: 'Learn more about custom solutions',

    preflop_coming_soon: 'Preflop is coming soon!',
    auto_dyn_sizes_reduce: 'Automatic/Dynamic',
    auto_dyn_sizes_reduce_tooltip:
      'In Automatic or Dynamic, the optimal size(s) will be chosen from available actions',
    // auto_dyn_sizes_reduce: 'In Automatic or Dynamic, the optimal size(s) will be chosen from available actions',
    // auto_dyn_sizes_reduce_tooltip: 'Edit actions at each node to better customize your tree',

    tree_edit: 'Tree edit',

    oop_vs_ip: `{oop} <span class='text-smallest' style='line-height: 1'>vs.</span> {ip}`,
    vs: ` <span class='text-smallest' style='line-height: 1'>vs.</span> `,

    history: 'History',

    street_bet_sizes: 'Bet sizes',
    advanced_allin_options: 'Advanced options',
    player_ip: 'IP',
    player_oop: 'OOP',
    prefill_ranges: 'Prefill',
    prefill_rake: 'Choose Rake',
    ai_solve: 'AI solve',
    ai_solve_report: 'Solve report with AI',
    solution: 'Solution',

    rakeCap: 'Rake cap (bb)',
    rakeCap_tooltip: 'The maximum rake that can be taken from the pot in bb',
    rakePercent: 'Rake %',
    rakePercent_tooltip: 'The percentage of the pot that is taken as rake',

    preflopRakeType: 'Rake type',
    preflopRakeType_tooltip: `
    <div><b>No Flop, No Drop</b>: Rake is only charged on postflop pots.</div>
    <div><b>GG Network</b>: Rake is charged on preflop 3-bet pots and on any postflop pot. </div>
    <div><b>Full</b>: Rake is charged on all pots. </div>
    `,
    rake: {
      no_flop_no_drop: 'No Flop, No Drop',
      gg_network: 'GG Network',
      full: 'Full',
    },

    // saved_trees: 'Saved settings',
    help: {
      title: 'How to use Custom solving',

      custom_solving: `What is <span class='weight_700'>custom solving</span>?`,
      custom_solving_text: `
      <div>Custom solving is a revolutionary new poker tool that allows you to solve any situation in seconds! Unlike presolved solutions,
       custom solving allows you to edit the solving parameters.</div>

      <div class="mt-2 weight_700">With custom solving, you can:</div>
      <ul class="mt-1">
        <li>Change the player's ranges</li>
        <li>Change the stack and pot size</li>
        <li>Add or remove actions</li>
        <li>Customize the betting tree</li>
        <li>Automatically simplify and optimize your bet sizes</li>
      </ul>
      `,

      try_custom_solving: `How can I try custom solving for <span class='weight_700'>free</span>?`,
      try_custom_solving_text: `Anyone can solve the flop <span class='weight_700'>QsTs7h</span> to try all the features for <span class='weight_700'>free</span>!`,
      // try_custom_solving_text_link: 'Check out our {linkText} to solve all flops!', // link_text
      // try_custom_solving_text_link_text: 'ELITE Tier subscription',

      upcoming_features_and_limitations: `What are the <span class="weight_700">upcoming features</span> and current limitations of this solver?`,
      upcoming_features_and_limitations_text: `
      <div class="weight_700">Current Limitations:</div>
      <ul class="mt-1">
        <li>The first version of our solver (as of July 2023) is restricted to <b>two-player, postflop, chip EV spots only</b>. That means you cannot specify a rake structure, choose ICM scenarios, assign bounties, or solve multiway spots.</li>
        <li>{stackpot_ratio} is limited to a maximum of 100 in order to ensure that our solutions are accurate. This is enough to solve very deep spots, but not so much as to prevent our solutions from being accurate.</li>
      </ul>

      <div class="mt-2 weight_700">Features coming very soon:</div>
      <ul class="mt-1">
        <li>HU Preflop - Solve two-player preflop spots</li>
        <li>Edit presolved solutions - Customize and re-solve any postflop GTO Wizard spot</li>
        <li>Ultimate Training - Practice against GTO using whatever bet size you want</li>
      </ul>

      <div class="mt-2 weight_700">General Roadmap:</div>
      <ul class="mt-1">
        <li>Customized aggregate reports </li>
        <li>Customizable rake structures</li>
        <li>Solve any ICM structure</li>
        <li>Assign PKO bounties</li>
        <li>Multiway Preflop and postflop solving</li>
        <li>Custom PLO solving</li>
        <li>Translating solver outputs into human language to simplify the learning curve</li>
        <li>Building adaptive solutions that more closely match the player's level and that are easier to study</li>
      </ul>
      `,
      stackpot_ratio: 'The stack-to-pot ratio',

      choose_board_cards: `How do I choose the <span class='weight_700'>board cards</span>?`,
      choose_board_cards_text: `You will be prompted to choose board cards after you select "Create Solution" in Postflop Mode.`,
      // choose_board_cards_text_link: `Note that users without an {elite_sub}  can only solve <span class='weight_700'>QsTs7h</span>`, // link_text
      // elite_sub: `ELITE Tier subscription`,

      prefill_spot: `How do I <span class='weight_700'>prefill</span> a spot?`,
      prefill_spot_text: `
      <div>Rather than manually entering the ranges, stack, and pot sizes, you can <strong>PREFILL</strong> this information by selecting an existing GTO Wizard spot!</div>
      <ul class="mt-1">
        <li>Select the <strong>PREFILL</strong> button in the top-left corner. This will open a popup.</li>
        <li><span class="text-italic">Optional</span> - Change the solution set. These are the pre-solved solutions that you want to pull information from.</li>
        <li>Select the positions and preflop actions.</li>
        <li>Hit confirm!</li>
      </ul>
      <div class="mt-2">GTO Wizard will automatically populate the ranges, stack, and pot size from your selected situation.</div>`,

      customize_ranges: `How do I customize the <span class='weight_700'>ranges</span>?`,
      customize_ranges_text: `
      <div>The range editor allows you to change what hands players have. From here, you can customize, save, and organize your ranges!</div>

      <div class="mt-2">Select either player's range to open the range editor popup.</div>
      <div class="mt-2"><b>Select OOP or IP</b> to specify whose range you're changing. (<b>O</b>ut <b>O</b>f <b>P</b>osition, <b>I</b>n <b>P</b>osition). </div>
      <ul class="mt-1">
        <li>Optionally, you can rename these positions to (e.g. BTN, BB, etc) using the dropdown arrows: this does not affect the solution.</li>
      </ul>

      <div class="mt-2 weight_700">Edit the hand matrix:</div>
      <ul class="mt-1">
        <li>Click on any hand to select or deselect it, and drag your mouse to paint the range.</li>
        <li>Use the Weight box to change how often you have certain hands.</li>
        <li>Use the slider or the From &amp; To boxes to specify how wide the range should be.</li>
        <li>Alternatively, you can Import ranges from other programs. Select the import button and paste the range text.</li>
      </ul>
      <div class="mt-2 weight_700">Saving and organizing ranges:</div>
      <ul class="mt-1">
        <li>You can save ranges for use in future solves. Select the save button in the top-left corner, and name your range.</li>
        <li>You can organize the ranges using the tagging system. Tags are labels that you can use to categorize different ranges. For example, you could have a "Raise First In" or a "BB Defense" tag.</li>
        <li>Assign tags to the range by pressing the + button.</li>
        <li>Filter for specific ranges using the Filter Tags dropdown menu.</li>
      </ul>`,

      customize_bet_sizes: `How do I customize the <span class='weight_700'>bet sizes</span>?`,
      customize_bet_sizes_text: `
      <div>Select the <b>bet sizes dropdown</b> menu to modify the betting structure. Then choose the <b>Fixed</b> or <b>Dynamic</b> option to specify bet sizes. What's the difference?</div>
      <div class="mt-1">By default, you only need to specify sizes for one decision point. But you can toggle the switches labeled <span class="text-italic">"Apply flop settings to all streets"</span> and <span class="text-italic">"Apply same settings as OOP"</span> to customize sizings separately for each street and player.</div>
      <div class="mt-1">You can enter bet/raise sizes as a  (%), as a {geometric_size} (e), or as a multiple of the previous bet (x). To switch between them, hover your mouse over the (% / e / x) icons to open a dropdown menu and change the input type.</div>
      <div class="mt-1">Alternatively, you can use the Tree editor to add or remove sizings directly.</div>
      `,
      // whats_difference: 'What's the difference',
      percentage_pot: 'percentage of the pot',
      geometric_size: 'geometric size',
      // tree_editor: 'Tree editor',

      simplify_strategy: `How can I simplify my strategy with <span class='weight_700'>optimal bet sizes</span>?`,
      simplify_strategy_text: `
      <div>Select the <b>Automatic</b> or <b>Dynamic</b> betting option in the bet sizes dropdown. GTO Wizard AI will autonomously determine the optimal (highest EV) sizings at each decision point!</div>
      <div class="mt-1">This tool doesn't merely simplify or reduce sizes using a predetermined solution.
      Rather, our solver employs artificial intelligence to estimate the EV of all possible betting strategies based on your
      selected number of sizes. It chooses the size that retains the most EV out of a list of predefined sizes, which you can customize to your liking.</div>
      <div class="mt-1"><b>Ultimately, you get a straightforward and optimal strategy built from scratch!</b></div>
      <div class="mt-1">Arguably, the most powerful feature of GTO Wizard AI is its ability to simplify your strategy with optimal betsizes!</div>
      <div class="mt-1">This means you automatically can simplify your strategy down to the highest EV bet size!</div>
      `,

      automatic_dynamic_fixed_bet_sizes: `What is the difference between <span class='weight_700'>Automatic, Dynamic</span>, and <span class='weight_700'>Fixed</span> bet sizes?`,
      automatic_dynamic_fixed_bet_sizes_text: `
      <div><b>Automatic:</b> GTO Wizard automatically simplifies to the best (highest EV) single-size strategy at each decision point.
      <div class="text-italic">This is the best option for most users!</div></div>
      <div class="mt-2"><b>Dynamic:</b> Choose how many bet or raise sizes you want and GTO Wizard AI will automatically determine the optimal (highest EV) sizings at each decision point. You can also specify what sizes the dynamic algorithm should consider before simplifying.
      <div class="text-italic">Select this option to build powerful simplified strategies.</div></div>
      <div class="mt-2"><b>Fixed:</b> Specify exactly what bet or raise sizes are allowed at each decision point. This is similar to traditional solver inputs. Your betting tree will NOT be simplified.
      <div class="text-italic">Choose this option to build more complex trees or force certain sizes to be used</div></div>`,

      tree_node_editing: `What is <span class='weight_700'>tree/node editing</span>?`,
      tree_node_editing_text: `
      <div><b>Tree editing</b> allows you to add or remove actions or change bet sizes at some decision point (node).</div>
      <div class="mt-2">Select the <b>Tree Edit</b> dropdown menu at the bottom of the page. Navigate to the node you’d like to edit, then select the pencil icon in the bottom right corner to open the <b>Node Editor</b> popup. From here, you can add, remove, or change sizes!</div>
      <div class="mt-2">Note that the solver will remove lower EV sizes if you’ve selected Automatic or Dynamic options. So if you want to force a specific size, you’ll need to use the <b>Fixed</b> betting option on that street.</div>
      `,

      save_load_parameters: `How do I <span class='weight_700'>save and load</span> my parameters?`,
      save_load_parameters_text: `
      <div>Your “solving parameters” consist of the betting structure, ranges, stack, pot, and other variables used to define the gamespace.</div>
      <div class="mt-2">You can save and load your solving parameters by selecting the LOAD and SAVE icons located in the bottom-left corner. You can assign names to each one, and filter and organize them using tags.</div>
      <div class="mt-2">Learn more about {how_to_organize_with_tags}.</div>
      `,
      how_to_organize_with_tags: 'how to organize things with tags',

      previously_solved_spots: `Where can I find my <span class='weight_700'>previously solved spots</span>?`,
      previously_solved_spots_text: `Open the Solution Selector and choose Custom solutions. The history column displays previously solved custom spots. You can reopen these spots and edit them!`,

      solution_accuracy: `How <span class='weight_700'>accurate</span> are these solutions?`,
      solution_accuracy_text: `
      <div>How accurate are these solutions, you ask? Very. <b>We've accomplished speed and accuracy that outperforms all {top_benchmarks}</b></div>
      <div class="mt-2">We decimated the ACPC champion {decimated_slumbot} for <b>19bb/100</b> in a 150k hand HUNL match,
      and averaged a Nash Distance of only <b>0.21% pot</b> when nodelocking these solutions against PioSolver.</div>
      `,
      top_benchmarks: `benchmarks`,
      slumbot: `Slumbot`,

      additional_resources: `Where can I find <span class='weight_700'>additional resources</span> for further help?`,
      additional_resources_text: `Watch this video to learn more about how to use the features, our pricing, and roadmap!`,
      additional_resources_text_bottom_tra01: `
      <div>
        We’ve also written several articles and guides to help you understand more about how custom solving works:
        <ul class="mt-1">
          <li>{introducing} - Overview of the features, pricing, and roadmap.</li>
          <li>{benchmarks} - How accurate are these solutions when tested against a traditional solver</li>
          <li>{solver_explained} - How we use artificial intelligence to solve spots quickly</li>
          <li>{crushing_bot} - How we used this technology to crush a top HUNL bot</li>
          <li>{pricing} - Compare tier features and pricing</li>
          <li>Written guides - coming soon!</li>
        </ul>
      </div>

      <div class="mt-4">
        Still have questions? We’re happy to help!
        <br>
        Message us on <a href="https://discord.gg/ht3QxrP" class="link-underline link-underline_hover clr-primary">Discord</a>, or email us at <a
            class="link-underline clr-primary"
            target="_blank"
            href="{mailto}"
          >
            {email}
          </a>
      </div>
            `,
      introducing: 'Introducing GTO Wizard AI',
      benchmarks: 'GTO Wizard AI Benchmarks',
      solver_explained: 'GTO Wizard AI Solver Explained',
      crushing_bot: 'Crushing a top HUNL poker bot',
      pricing: 'Pricing',

      watch_video: 'Watch this video to learn more:',
    },
    errors: {
      tree_too_large:
        'Solution is too large, please try reducing number of bet sizes that are too close to each other.',
    },
    gmf: {
      stack: 'Stack {num}<span class="text-smallest" style="line-height: 1">bb</span>',
      pot: 'Pot {num}<span class="text-smallest" style="line-height: 1">bb</span>',
      ante: 'Ante {ante}<span class="text-smallest" style="line-height: 1">{ante_distribution_method}</span>',
      stack_and_blinds:
        '{stack}<span class="text-smallest" style="line-height: 1">bb</span> {sb}/{bb}',
      rake: 'Rake {rakePercent}<span class="text-smallest" style="line-height: 1">%</span> {rakeCap}<span class="text-smallest" style="line-height: 1">bb</span>',
    },
    import: {
      title: 'Import ranges',
      error: 'Range is corrupted try exporting and importing again',
      subtitle: 'Paste range in the field below',
      // errors: {
      // detail_title: 'Error details',
      // corrupted: 'Ranges are corrupted. Try exporting and importing again',
      // range_not_number: `Range must be a number`,
      // range_above_1: `Range must not be below 0`,
      // range_below_0: `Range must not be above 1`,
      // combo_hands_not_equal_range: `Hands range in not equal`,
      // string_does_not_contains_hands: `Input does not contain hands`,
      // string_does_not_contains_combos: `Input does not contain combos`,
      // },
    },
    export: {
      export_range: 'Export range',
      range_copied_to_clipboard: 'Range copied to clipboard',
    },
    titles: {
      setup: 'Setup',
      // sizes: 'Sizes',
      // flop: 'Flop',
      summary: 'Summary',
      // solved_solutions: 'Solved solutions',
    },
    stackpot: {
      stack: 'Stack',
      stack_flop: 'Stack',
      stack_preflop: 'Stack',
      stack_preflop_tooltip:
        'Enter the starting pot size in big blinds. Stack must be higher than Ante and Blinds.',
      stack_flop_tooltip:
        'Enter the effective stack size in big blinds. The stack/pot ratio cannot exceed {ratio}.',
      pot: 'Pot',
      pot_tooltip:
        'Enter the starting pot size in big blinds. The stack/pot ratio cannot exceed {ratio}.',
      error_stackblinds: 'Stack must be higher than Ante and Blinds',
      error_stackpot_ratio: 'Stack/Pot ratio must be equal or under {ratio}',

      blind: 'Blinds',
      blind_tooltip:
        'Choose small blind size as a fraction of 1 big blind,<br> eg 2,5$/5$ will be 0.5/1.',
      ante: 'Ante',
      ante_distribution_method: 'Ante Distribution Method',
      ante_tooltip: 'Choose ante (in big blinds) per player.',
      allow_limp: 'Limps',
      allow_limp_tooltip: 'Controls if players have the option to limp in.',

      allow_rake: 'Rake',
      allow_rake_tooltip: 'Controls if rake is taken from the pot.',

      rake_cap: 'Rake cap (bb)',
      rake_cap_tooltip: 'The maximum rake that can be taken from the pot',
      rake_percent: 'Rake %',
      rake_percent_tooltip: 'The percentage of the pot that is taken as rake',
    },
    streets: {
      title: 'Street',
      title_tooltip: 'Choose where the action starts.',
      preflop: 'Preflop',
      flop: 'Flop',
    },
    sizes: {
      // all: 'Flop+Turn+River',
      preflop: 'Preflop',
      flop: 'Flop',
      turn: 'Turn',
      river: 'River',
      automatic: 'Automatic',
      dynamic: 'Dynamic',
      fixed: 'Fixed',
      automatic_info: 'We will set the optimal bet sizes for you automatically',

      use_fixed_sizes_options: 'Specify Sizes to Compare',
      use_fixed_sizes_options_tooltip: `List every bet size you'd like the <span class="weight_700">dynamic algorithm</span> to consider
       when building your strategy. We will automatically find the optimal bet sizes in that list
        for every decision point.`,

      use_fixed_sizes_allin_options: 'Advanced options',
      use_single_sizes_all_streets: 'Use these settings for all streets and positions',
      force_check: 'Force check',
      force_callfold: 'Force Call/Fold',

      use_flop_on_all_streets: 'Apply Flop to Turn & River',
      // use_flop_on_all_streets: 'Apply <b>Flop</b> to all postflop streets',
      settings_inherited_from_flop: 'Using Flop settings',
      use_oop_settings: 'Apply same settings as {display_position}',
      settings_inherited_from_OOP: 'Using {display_position} settings',

      // use_oop_settings: 'Use OOP settings',
      override_last_settings: 'Confirm to override settings',
      // force_check: 'Check',
      // force_callfold: 'Call/Fold',
      bet_types: 'Bet types',
      bet_types_automatic: 'Automatic',
      bet_types_automatic_text: `
        GTO Wizard automatically simplifies to the best (highest EV) single-size strategy at each decision point.<br>
        <span class='text-italic'>This is the best option for new users!</span>
      `,
      bet_types_dynamic: 'Dynamic',
      bet_types_dynamic_text: `
        Choose how many bet or raise sizes you want and GTO Wizard will automatically determine the optimal (highest EV) sizings
        at each decision point. You can also specify what sizes the dynamic algorithm should consider before simplifying.
        <span class='ml-1'>{dynamicLink}</span><br>
        <span class='text-italic'>Select this option to build powerful simplified strategies.</span>
      `,
      bet_types_fixed: 'Fixed',
      bet_types_fixed_text: `
        Specify exactly what bet or raise sizes are allowed at each decision point. This is similar to traditional solver inputs.
        Your betting tree will NOT be simplified. <br>
        <span class='text-italic'>Choose this option to build more complex trees or force certain sizes to be used.</span>
      `,

      advanced: {
        allin_threshold_complete:
          'Force all-in threshold <span style="font-weight:var(--weight);color:var(--color)">{num}%</span> stack.',
        allin_threshold_before_input: 'Force all-in threshold',
        allin_threshold_after_input: '% stack',
        allin_threshold_tooltip:
          'Replace bet sizes greater than X% of the effective stack with an all-in shove.',

        allin_if_less_than_complete:
          'Add all-in threshold <span style="font-weight:var(--weight);color:var(--color)">{num}%</span> pot',
        allin_if_less_than_before_input: 'Add all-in threshold',
        allin_if_less_than_after_input: '% pot',
        allin_if_less_than_tooltip:
          'Add the option to go all-in when shoving is less than X% of the pot.',

        merge_sizes_threshold_complete:
          'Bet size merging threshold <span style="font-weight:var(--weight);color:var(--color)">{num}%</span>',
        merge_sizes_threshold_before_input: 'Bet size merging threshold',
        merge_sizes_threshold_after_input: '%',
        merge_sizes_threshold_tooltip: `
        <div style="font-weight:var(--weight);color:var(--color)" >Merging Threshold</div>
        <div class='mt-1'>
        This removes bets and raises that are too close to the same size.
        Merging bet sizes can help clean up your tree by removing redundant strategies.
        </div>
        <div class='mt-1'>
        Algorithm works from the top down, starting with the largest bet size and eliminating all bet sizes that fall within the merging threshold.
        </div>
        <div class='mt-1'>
        Two bet sizes are within the merging threshold of X% if they meet this condition:
        <div class='weight_500 px-1'>X > (1 + Higher) / (1 + Lower) - 1</div>
        </div>
        <div class='mt-1'>For example, a 50% and 25% pot-sized bet would be merged, meaning the 25% bet size would be removed, if X was greater than 20%, because (1.5 / 1.25) - 1 = 0.2%.
        </div>
        `,
        max_num_raises_complete: `Betting cap of maximum <span style="font-weight:var(--weight);color:var(--color)">{num}</span> bets / raises`,
        max_num_raises_before_input: 'Maximum of',
        max_num_raises_after_input: 'raises per street',
        max_num_raises_tooltip: `Sets the maximum number of allowed bets + raises per street. The last raise is converted to an all in.`,
      },
      fields: {
        rake_cap: 'Rake cap (bb)',
        rake_percent: 'Rake %',
        // automatic: 'Automatic',
        // dynamic: 'Dynamic',
        // fixed: 'Fixed',
        bet_type: 'Bet type',
        add_allin: 'Always add all-in',
        add_allin_tooltip: `Always add the option to go all-in, regardless of advanced options. <br>
        If unchecked, all-in will be added only if the solver deems it to be an optimal sizing at that point.`,
        // add_allin: 'Always add all-in',
        bet_count: 'Number of bets',
        bet_count_tooltip:
          'Select how many raise sizes you want. Dynamic mode automatically finds the optimal (highest EV) bet sizes for every decision!',
        raise_count: 'Number of raises',
        raise_count_tooltip:
          'Select how many raise sizes you want. Dynamic mode automatically finds the optimal (highest EV) bet sizes for every decision! ',
        second_raise_count: '4-bet',
        third_plus_raise_count: '5-bet',
        donk_count: 'Number of donks',
        donk_count_tooltip:
          'Select how many raise sizes you want. Dynamic mode automatically finds the optimal (highest EV) bet sizes for every decision! ',

        sizes_betting: 'Donk betting',
        sizes_geobet: 'Geometric bet',

        bet_sizes: 'Bet sizes',
        bet_sizes_tooltip: `
        <div>
        <span class="weight_700">%</span> - <span class="weight_700">Bet</span> sizing as a percentage of the pot.
        </div>
        <div>
        <span class="weight_700">e</span> - <span class="weight_700">{geobetText}</span> sizing refers to betting an equal fraction of the pot on each street, such that you’re all-in by the last bet.
        </div>
        `,
        sb_preflop_bet_sizes: 'Open',
        sb_preflop_bet_sizes_tooltip: 'The first raise',
        bb_preflop_bet_sizes: ' Iso',
        bb_preflop_bet_sizes_tooltip: ' Isolation raise facing a limp',

        // second_raise_sizes_flop: '2nd+ raise sizes',
        // second_raise_sizes_flop: '3bet+ sizes',
        second_raise_sizes_flop: 'Reraise sizes',

        raise_sizes: 'Raise sizes',
        second_raise_sizes: '4-bet',
        bb_second_raise_sizes_tooltip: 'Reraise after isolation raising and facing a 3-bet',
        sb_second_raise_sizes_tooltip: 'Open, then raise facing a 3-bet',
        third_plus_raise_sizes: '5-bet',
        bb_third_plus_raise_sizes_tooltip: 'Controls all OOP sizes after a 4-bet',
        sb_third_plus_raise_sizes_tooltip: 'Controls all IP sizes after a 4-bet',
        preflop_raise_sizes: '3-bet',
        bb_preflop_raise_sizes_tooltip: 'Raise facing an open',
        sb_preflop_raise_sizes_tooltip: 'Limp then reraise over an iso',
        raise_sizes_tooltip: `
        <div>
        <span class="weight_700">%</span> - <span class="weight_700">Raise</span> sizing as a percentage of the pot. {learMoreText}
        </div><div>
        <span class="weight_700">e</span> - <span class="weight_700">{geobetText}</span> sizing refers to betting an equal fraction of the pot on each street, such that you’re all-in by the last bet.
        </div>
        <div>
        <span class="weight_700">x</span> - <span class="weight_700">Raise</span> a multiple of the last bet.
        </div>
        `,

        donk_sizes: 'Donk sizes',
        donk_sizes_tooltip: `
        <div>
        <span class="weight_700">{donkText}</span>  is defined as betting out of position into the previous-street aggressor.
        </div>
        <div class="mt-1">
        <span class="weight_700">%</span> - <span class="weight_700">Bet</span> sizing as a percentage of the pot.
        </div>
        <div>
        <span class="weight_700">e</span> - <span class="weight_700">{geobetText}</span> sizing refers to betting an equal fraction of the pot on each street, such that you’re all-in by the last bet.
        </div>
        `,
      },
      // cloner: {
      //   title: 'Copy from',
      //   // title: 'Copy settings from',
      //   flop_ip: 'Flop IP',
      //   flop_oop: 'Flop OOP',
      //   turn_ip: 'Turn IP',
      //   turn_oop: 'Turn OOP',
      //   river_ip: 'River IP',
      //   river_oop: 'River OOP',
      // },
    },
    shortcut: {
      title: 'Shortcut',
      title_tooltip: 'Shortcut--title_tooltip',
      solution: 'Solution',
      ip: 'IP',
      oop: 'OOP',
      action: 'Action',
      player_one: 'Player one',
      player_two: 'Player two',
    },
    ranges: {
      title: 'Ranges',
      title_tooltip: 'Select the starting ranges for IP (in position) and OOP (out of position).',
      player_ip: 'IP',
      player_oop: 'OOP',
      combos: 'Combos',
      count: 'Count',
      combos_xxx: 'Combos {num}',
      count_xxx: 'Count {num}%',
      chosen_range_above_zero: `Player's range must be above 0%`,
    },
    tooltips: {
      titles: {
        setup: '-tooltip-Setup',
        sizes: '-tooltip-Sizes',
        flop: '-tooltip-Flop',
      },
    },
  },
  datepicker: {
    any: 'Any',
    today: 'Today',
    yesterday: 'Yesterday',
    last_xxx_days: 'Last {num} days',
    last_xxx_months: 'Last {num} months',
    this_week: 'This Week',
    last_week: 'Last Week',
    this_month: 'This Month',
    last_month: 'Last Month',
    custom_date: 'Custom date',
  },
  gto_score_trend: {
    title: 'GTO Score progress',
    title_tooltip: `The GTO Score progress chart reflects your performance over the last 100 - 1000 hands played.`,
    under_100_hands_prompt: 'Play 100 hands first to see your progress.',
  },
  players: {
    UTG: 'UTG',
    'UTG+1': 'UTG1',
    'UTG+2': 'UTG2',
    'UTG+3': 'UTG3',
    UTG1: 'UTG1',
    UTG2: 'UTG2',
    UTG3: 'UTG3',
    LJ: 'LJ',
    HJ: 'HJ',
    CO: 'CO',
    BTN: 'BTN',
    SB: 'SB',
    BB: 'BB',
    STR: 'STR',
    IP: 'IP',
    OOP: 'OOP',
    OOP1: 'OOP+1',
    MP: 'MP',
    P1: 'P1',
    P2: 'P2',
    P3: 'P3',
    P4: 'P4',
    P5: 'P5',
    P6: 'P6',
    P7: 'P7',
    P8: 'P8',
    P9: 'P9',
    P10: 'P10',
  },
  guides: {
    see_guide: `See <a href='{url}' class='link-underline clr-primary' target='_blank'>{text}</a>`,
    read_more_in_depth_guide_here: `Read more in-depth guide <a href='{url}' class='link-underline clr-primary' target='_blank'>here</a>`,
    eq_chart: 'Equity chart',
    range: 'Ranges guide',
    breakdown: 'Breakdown guide',
    equity: 'Equity',
    ev: 'EV',
    eqr: 'EQR',
    combos: 'Combos',
    analyze_guide: 'Analyzer guide',
    solution_browser_guide: 'Study guide',
    trainer_guide: 'Trainer guide',
    custom_solutions_guide: 'Custom solutions guide',
    bubble_factor: 'Bubble factor',
    icm_pressure: 'ICM pressure',
    bubble_factor_learn_more: 'Learn more about Bubble Factors',
    icm_pko: 'The Theory of Progressive Knockout Tournaments (PKO)',
    learn_more_about_pko: 'Learn more about PKO',
    ai_guides: 'GTO Wizard AI Guides',
    how_to_build_custom_solutions: 'How to build custom solutions',
    how_to_build_xxx_custom_solutions: 'How to build {str} solutions',
    bet_sizes: 'How to setup the betting tree?',
    how_to_edit_ranges: 'How to edit ranges',
    saving_loading_guides: 'Saving/Loading Guides',
    nodelocking_how_it_works: 'See how it works',
    train_against_custom_solutions: 'How To Train Against Custom Solutions',
    ev_compare_tips_tricks: 'Tips & Tricks for Comparing EV',
  },
  themes: {
    more_themes_soon: 'More themes coming soon...',
    default: 'Default',
    sunset: 'Sunset',
    spin_power: 'Spin power',
    vivid: 'Vivid',
    colorfull: 'Colorfull',
    autumn_leaves: 'Autumn Leaves',
    exaggerated_redscale: 'Exaggerated redscale',
    data_picker: 'Data Picker',
    hot_pink: 'Hot pink',
    pastels: 'Pastels',
    electric: 'Electric',
    super_mario: 'Super Mario',
    custom: 'Custom',

    ice_cold: 'Ice Cold',
    tadara: 'Tadara',
    homage: 'Homage',
    pio: 'PIO',
    hot_colors: 'Hot Colors',
    wisdom: 'Wisdom',
    data_picker_v2: 'Data picker 2.0',
    ital: 'Ital',
    pickaxe: 'Pickaxe',
    easter: 'Easter',
    colorblinds_arise: 'Colorblinds arise',
    simple_purple: 'Simple Purple',

    default2: 'Default 2',
    aqua: 'Aqua',
    toxic: 'Toxic',
    lego: 'Lego',
    dark: 'Dark',
    minimalist: 'Minimalist',
    forest: 'Forest',
    who: 'Who ?',
    vibes: 'Vibes',
    summer: 'Summer',
    safari: 'Safari',
    late_night: 'Late night',

    trainer: {
      default: 'Default',
      outlined: 'Outlined',
      custom: 'Custom',
    },
  },
  // study_suits: {
  //   show_any_include: 'Show only hands including {suits}',
  //   show_any_exclude: 'Show only hands exluding {suits}',
  //   show_one_include: 'Show only hands including {suits} as a first card',
  //   show_one_exclude: 'Show only hands exluding {suits} as a first card',
  //   show_two_include: 'Show only hands including {suits} as a second card',
  //   show_two_exclude: 'Show only hands exluding {suits} as a second card',
  // },
  ev_comparison: {
    ev_compare: 'Compare EV',
    // ev_regret: 'EV Regret',
    // sub: 'Choose two actions to compare their EV',
    action_primary: 'Action',
    action_secondary: 'Compared to:',
    best_ev_action: 'Best Action',
    // best_ev_action: 'Best EV action',
    // action_ev_regret: 'Action EV Regret',
    // ev_top_action: 'Highest EV action',
  },
  glossary: {
    title: 'Glossary',
    // what_is_xxx: 'What is {term}?',
    // what_is: 'What is?',
  },
  daily_gto: {
    title: 'Daily Dose of GTO',
    // title_christmas: 'Christmas dose of GTO',
  },
  canvas: {
    title: 'You are in Drawing mode',
    press_key_exit:
      'Press <span class="keyboardkey_key clr-white text-normal">{key}</span> to exit',
  },
  practice_hero_frequency: {
    title: 'Show trainer hints',
    press_key_toggle:
      'Press <span class="keyboardkey_key clr-white text-normal">{key}</span> to toggle',
  },
  focus_mode: {
    title: 'You are in Focus mode',
    press_key_exit:
      'Press <span class="keyboardkey_key clr-white text-normal">{key}</span> to exit',
  },
  actions_grouping: {
    title: 'Actions grouping changed',
    press_key_to_switch:
      'Press <span class="keyboardkey_key clr-white text-normal">{key}</span> to switch',
  },
  switch_pot_bb: {
    title: 'Postflop bet display changed',
    press_key_to_switch:
      'Press <span class="keyboardkey_key clr-white text-normal">{key}</span> to switch',
  },
  switch_ev_pot_tra01: {
    title: 'EV display changed',
    press_key_to_switch:
      'Press <span class="keyboardkey_key clr-white text-normal">{key}</span> to switch',
  },
  gmf_change: {
    title: 'Solution changed',
    press_key_to_switch:
      'Press <span class="keyboardkey_key clr-white text-normal">{key}</span> to switch',
  },
  shortcut: {
    players: 'Players',
    action: 'Action',
    street_action: '{street} action',
    hero: 'Hero',
    relative_hero_position: 'Relative hero position',
    board: 'Board',
    alternate_positions: 'Alternate positions',

    StartOfHand: 'From start',
    RFI: 'RFI',
    vsSRP: 'vs Open',
    vs3bet: 'vs 3bet',
    vs4bet: 'vs 4bet',
    vs5bet: 'vs 5bet',
    vsLimp: 'vs Limp',
    vsIso: 'vs Iso',
    SRP: 'SRP',
    srp: 'SRP',
    '3bet': '3-bet',
    '4bet': '4-bet',
    '5bet': '5-bet',
    limp: 'Limp',
    iso: 'Iso',
    Squeeze: 'Squeeze',
    squeeze: 'Squeeze',
    vsSqueeze: 'vs Squeeze',
    vssqueeze: 'vs Squeeze',
    possibleSqueeze: 'vs Raise-Call',

    // practice-hands spot_type
    PREFLOP: 'Preflop',
    preflop: 'Preflop',
  },
  study_plans: {
    title: 'Study plans',
    description: `
    Study plans provide a structured set of <br>
    <b style='color:var(--clr-bolded)'>lessons</b>,
    <b style='color:var(--clr-bolded)'>curated content</b> and
    <b style='color:var(--clr-bolded)'>training drills</b>
    <br>
    to help you become a true GTO Wizard!`,
    // start_studying: 'Start studying',
    plan_not_found: 'Plan not found',
    back_to_plans: 'Back to plans',
    congratulations: 'Congratulations!',
    you_have_finished: `
    <div style="font-size:var(--fnt-size)">
    You have finished:
    </div>
    {name}
    `,
    see_xxx_steps: 'See {num} steps',
    coming_soon: 'Coming soon',
    more_plans_coming_soon: `We are currently working on other plans.
    <a href="https://discord.gg/ht3QxrP" class="link-underline link-underline_hover clr-primary">Stay tuned!</a>
    `,
    step_finished: 'Step completed',
    steps_x_y:
      'Steps completed <span class="clr-white text-nowrap" style="padding:var(--num-padding);font-weight:var(--num-fnt-weight)">{x} / {y}</span>',
    completed: 'Completed',
    incompleted: 'Not completed',
    task: {
      read_article: 'Read article',
      watch_youtube_video: 'Watch video',
      watch_in_app_url: 'Watch video',
      perform_tasks: 'Perform tasks',
      play_drills: 'Play drills',
    },
    note_mark_as_finished: 'Remember to mark as completed',
  },
  tour: {
    title: 'Select what you need to help with',
    help: 'If you would need more help, click here.',
    gameformat: 'Here you can set your preferred format. Click here to change it.',
    StudySolutions: {
      historyevents: 'Click on actions to select the spot you want to study.',
      rangetable: 'Explore the strategy for the selected player.',
      strategyinfo: 'See stacks, pot, and frequency of each action.',
      selectedcombos: 'Study how to play each hand and apply various filters.',
    },
    StudyReports: {
      historyevents: 'Select a spot you want to study.',
      reportstables: 'Study frequencies of different boards and apply various filters.',
    },
    PracticeTrainer: {
      tra_configuretable: `Select hero and opponent seats.`,
      // tra_multitable: 'Choose how many tables you want to practice.',
      tra_startspots: `Decide where the hand starts. Play from preflop, flop, or choose a custom node.`,
      tra_actions: `Define the preflop actions. You can select multiple spots.`,
      tra_advancedsettigs: `Refine your session with advanced settings. Click start training when you're ready to play!`,
      tra_advc_game: `Customize your session. Select format, solution, stack depth(s), positions, preflop actions, and more.`,
      tra_advc_board: `Choose a specific board or texture.`,
      tra_advc_hands: `Select the hands you want to play.`,
      tra_advc_modes: `Change your in-game settings.`,
      tra_advc_display: `Decide what information you want to be shown while playing.`,
      tra_live_controls: `Change your in-game settings. `,
      tra_live_stats: `Measure your performance.`,
      tra_live_hints: `Displays range & hand information, and overall frequencies. Updates as you play.`,
      tra_live_history: `Explore and replay previous hands.`,
      tra_live_hspots: `Navigate to a previous decision point.`,
      tra_live_actions: `What's your move?`,
    },
    // PracticeFullHand: {
    //   fhsettings: 'Set up which situation you want to practice.',
    //   practicesidebar: 'Switch between modes, find history or statistics of your play here',
    // },
    // PracticeSpecificSpot: {
    //   historyevents: 'Click on actions to select the spot you want to practice.',
    //   practicesidebar: 'Switch between modes, find history or statistics of your play here',
    // },
    AnalyzeFiles: {
      btnupload: 'To upload your hand histories, click here.',
      tableuploadedfiles: 'Find details and the status of your uploads here.',
      linkhands: 'Analyze all your uploaded hands here.',
    },
    PracticeRangeBuilder: {
      rbactions:
        'Select your painting brush here first. With your selected brush, you can then paint the whole range.',
      rangetable: `Select which combo you want to paint. If you mouseover and click on the "pin" in the top right corner of the combo, it will select it, and you can then paint specific suits in the hand's matrix (bottom right).`,
      solgraphcheat: `See the frequency of your whole range. Click on the lightbulb to see the correct range frequency.`,
      rbtopcontrols: `Undo, Redo, and Reset.`,
      categories:
        'You can paint the hands also by their categories here. For example, you can say you want all Flush draw hands to be betting 50% of the time.',
      lockpaint: `Here you can select if you want to "paint" or "lock" specific combos. Locking a combo will freeze its selection and won't get overpainted if you decide to paint the whole category (e.g., If you choose to paint all flush draws combos, the locked combo won't be affected)`,
      // rbtopcontrols: `Navigate back and forward, clear the whole range or select which specific suits you want to paint.`,
      // rbconfirm: `After you finish, click on the confirm button. If the button is disabled, it means you are still missing some combos. Mouse over the button to see which ones.`,
      rbconfirm: `After you finish, click on the confirm button to see results.`,
      rbhelp: 'If you need help, click on this icon.',
    },
    NodelockDialog: {
      ndsetstrategy: `Set strategies manually.`,
      ndsetfrequency: `Set overall frequencies.`,
      ndsetlock: `Lock or unlock hands.`,
      rbtopcontrols: `Undo, Redo, and Reset.`,
      ndrbconfirm: 'Confirm changes and nodelock!',
    },
    NodecompareDialog: {
      ndccurrstrategy: `Currently solved strategy.`,
      ndcprevstrategy: `Previously solved strategy .`,
      ndccategoriesswitch: `Change comparison metric.`,
      rdccopyrangebtn: `Copy ranges.`,
    },
  },
  moves: {
    all_in: 'All-in',
    raise: 'Raise',
    bet: 'Bet',
    check: 'Check',
    call: 'Call',
    fold: 'Fold',
  },
  fullscreen_switch: {
    on: 'Maximized',
    off: 'Default',
  },
  hotkeys: {
    study: {
      to_switch: 'To switch',
      to_toggle_grouping: 'To switch',
      to_toggle_fullscreen_mode: 'To toggle <span class="weight_700"> FULLSCREEN </span> mode',
    },

    // practice: {
    //   to_toggle_focus_mode: 'To toggle <span class="weight_700"> FOCUS </span> mode',
    // },

    turn_reports: {
      to_switch: 'To switch',
    },
    hs_back_key: 'Back <span class="keyboardkey_key text-semi-large">{key}</span>',
    hs_forward_key: 'Forward <span class="keyboardkey_key text-semi-large">{key}</span>',

    focus_mode_key: 'Focus mode <span class="keyboardkey_key">{key}</span>',
    reset_history_key: 'Reset history <span class="keyboardkey_key">{key}</span>',
    open_shortcuts_key: 'Shortcut <span class="keyboardkey_key">{key}</span>',

    study_switch_strategy: 'Switch between Strategy tabs',
    study_switch_strategy_sub:
      'Cycle through strategy tab dropdown. Hold <span class="keyboardkey_key">SHIFT</span> to reverse direction',
    study_to_switch_strategy: 'Switch between tabs',
    study_switch_street_card: 'Switch street card',
    study_switch_street_card_sub: 'Change the rank or suit of the last board card',
    study_hspot_jump: 'Switch nodes in Action selector',
    study_hspot_jump_sub:
      'Keep switching between different nodes in the Action selector using hotkeys.',
    study_switch_gmf: 'Switch solution',
    study_switch_gmf_sub:
      'Cycle through similar solutions while retaining the gametree. Similar solutions are defined by the filtering criteria of the quickswitch tool.',

    study_fullscreen_mode: 'Fullscreen mode Ranges',
    study_reports_turn_view: 'Switch table/chart reports view',
    study_reset_filters: 'Reset selected filters',
    study_reset_filters_sub: 'Removes all applied filters in solution browser',

    study_reset_filters_key: `Reset selected filters <span class="keyboardkey_key">{key}</span>`,

    focus_mode: 'Focus mode',
    focus_mode_sub:
      'Works in the Practice mode and Solution browser. Hide all the elements that are not needed to focus only on the data that matters the most to you. This is especially handy in the Practice mode.',
    switch_pot_bb: 'Switch between % pot and BB',
    // switch_ev_pot: 'Switch between EV and %pot',
    switch_ev_pot_tra01: 'Switch EV conversion units',

    expand_history: 'Expand',
    collapse_history: 'Collapse',
    expand_history_key: 'Expand <span class="keyboardkey_key">{key}</span>',
    collapse_history_key: 'Collapse <span class="keyboardkey_key">{key}</span>',

    save_spot_key_tra01: 'Saved spots <span class="keyboardkey_key">{key}</span>',
    save_spot_tra01: 'Saved spots',

    practice_builder_focus_action: 'Focus next action for quick edit',
    practice_builder_lock_paint: 'Switch between locking / painting',
    practice_builder_history_undo: 'History undo',
    practice_builder_history_redo: 'History redo',

    hand_replay_next_hand: 'Next hand',
    hand_replay_previous_hand: 'Previous hand',
    hand_replay_next_spot: 'Next action',
    hand_replay_previous_spot: 'Previous action',

    _123: 'BET / RAISE',
    _123_sub: 'You can use numbers to select bet / raise in practice mode.',

    cancel_selected_action: 'Cancel selection',
    practice_next_hand: 'Next hand / Continue',
    practice_next_hand_key: 'Next hand <span class="keyboardkey_key">{key}</span>',

    practice_full_hand_next_spot: 'Next action',
    practice_full_hand_previous_spot: 'Previous action',

    practice_full_hand_next_table: 'Focus next table',
    practice_full_hand_previous_table: 'Focus previous table',

    practice_study_spot: 'Open Study spot in new tab',
    practice_study_spot_key: 'Study this spot <span class="keyboardkey_key">{key}</span>',

    practice_replay_hand: 'Repeat hand',
    practice_replay_hand_key: 'Repeat hand <span class="keyboardkey_key">{key}</span>',
    practice_play_new_hand: 'Play new hand',
    practice_play_new_hand_key: 'Play new hand <span class="keyboardkey_key">{key}</span>',
    practice_hero_frequency: 'Show hints',

    action_check_fold: 'CHECK / FOLD',
    action_call: 'CALL',
    action_allin: 'ALLIN',

    reset_history: 'Reset history',
    reset_history_sub: 'Resets the hand history in solution browser',
    open_shortcuts: 'Open shortcuts',
    open_shortcuts_sub: 'Opens the spot selector shortcut in solution browser',
    // Configure new game

    switch_actions_grouping: 'Switch action grouping',

    drawing_mode: 'Drawing mode',
    drawing_mode_sub:
      'Use this to help you present your ideas. Fantastic for studying with your friends over screen sharing or for YouTubers and Streamers.',

    press_key: 'Press key',
    press_keys: 'Press key(s)',
  },
  login: {
    title: 'Login to GTO Wizard',
    message_0: 'You are just one click away from',
    message_1: 'crushing your competition',
    one: 'Study {num} presolved solutions',
    two: 'Practice by playing vs. GTO',
    three: 'Analyze your hand histories with 1-click',
    login_to_app: 'Login to GTO Wizard',
    go_home: 'Go to homepage',
  },
  tabs: {
    // brush: 'Brush',
    // paint: 'Paint',
    // lock: 'Lock',

    // painter: 'Set strategy',
    // set_frequency: 'Set frequency',
    // locker: 'Lock / Unlock',

    tools: 'Tools',
    hint: 'Hint',

    // painter: 'Tools',
    bulk_tools: 'Bulk tools',
    frequency: 'Frequency',

    cards: 'Cards',
    include: 'Include',
    exclude: 'Exclude',

    poker_table_tile: 'Overview',
    // poker_table_tile: 'Mini table',
    poker_table: 'Table',
    players: 'Players',
    actions_chart: 'Actions chart',

    actions: 'Actions',
    range_compare: 'Range compare',
    eq_chart: 'Equity chart',
    solution: 'Solution',
    stream_url: 'Stream',

    ev_compare: 'Compare EV',
    blockers: 'Blockers',
    eq_buckets: 'Equity buckets',
    flop: 'Flop',
    turn: 'Turn',
    river: 'River',
    simple: 'Simple',
    advanced: 'Advanced',
    history: 'History',
    hands: 'Hands',
    hand: 'Hand',
    summary: 'Summary',
    categories: 'Categories',
    filters: 'Filters',
    overview: 'Overview',
    strategy: 'Strategy',
    strategy_ev: 'Strategy + EV',
    strategy_eq: 'Strategy + EQ',
    reports: 'Reports',
    ev: 'EV',
    eq: 'Equity',
    eqr: 'EQR',
    blocker: 'Blockers',
    range: 'Ranges',
    breakdown: 'Breakdown',
    overview_range: 'Range',
    overview_all: 'All',
    single_hand: 'Single hand',
    multiple_hand: 'Files',

    quick_play: 'Quick play',
    game: 'Game',
    preferences: 'Preferences',
    save: 'Save',

    // high_cards: 'High cards',
    // board_type: 'Board type',
    // pairing: 'Pairing',
    // connectedness: 'Connectedness',
    // suits: 'Suits',
    // flops: 'Flops',
  },
  // cards_combos: {
  //   high_card: 'Highest card',
  //   mid_card: 'Middle card',
  //   low_card: 'Lowest card',
  // },
  onboarding: {
    welcome: 'Welcome to GTO Wizard',
    select_format_tra01: `Let's start with selecting your preferred format`,
    dont_worry_gmf_change: `Do not worry, you can change the format anytime later.`,
    dont_worry_features: `Do not worry, you will be able to do the others later.`,
    // select_format: 'Select your format',
    what_to_do: 'What would you like to do first?',
    browse: 'Browse solutions',
    sub_solution: 'Study any spot you want. More than {num} presolved solutions.',
    practice: 'Play vs. GTO',
    sub_practice: 'Challenge yourself and practice your skills by playing vs. GTO opponent.',
    analyze: 'Analyze Hand histories',
    sub_analyze: 'Find your mistakes with just one click.',
    reports: 'Study aggregated reports',
    sub_reports: 'Study board frequencies and how they compare to each other.',
  },
  color_palettes: {
    call_to_action: 'Want your theme featured? Post it in #themes on our',
    get_inspired: 'Get inspired by others. See #themes on our',
    custom: 'Custom',
  },
  cards: {
    diamonds: 'Diamonds',
    spades: 'Spades',
    clubs: 'Clubs',
    hearts: 'Hearts',
  },
  settings: {
    preferred_seat: 'Preferred seat',
    trainer_back_pattern: 'Trainer background pattern',
    cards_preview: 'Cards preview',
    trainer_themes: 'Trainer themes',

    trainer_table: 'Trainer table',
    trainer_table_active: 'Trainer active table',
    trainer_poker_player: 'Trainer player',
    // trainer_hand_highlight: 'Trainer hand highlight',
    // trainer_action_btn_default_background: 'Trainer action btn color',

    rng: 'RNG',
    tips: 'tips',
    suits: 'Suits',
    suits_colors: 'Suits',
    player: 'Player',
    typography: 'Typography',
    text_and_backgrounds: 'Text & backgrounds',
    cards: 'Cards',
    card_theme: 'Card theme',
    card_back_theme: 'Card back theme',
    card_back_color: 'Card back color',
    stack: 'stack',
    stack_bb: 'Display in bb',
    stack_chips: 'Display in chips',
    show_bets_in: 'Display bet as:',
    show_ev_in: 'Display EV as:',
    show_ev_icm_in: 'Display tournament EV  as:',
    show_total_hand_frequency: 'Show total hand frequency',
    show_total_hand_frequency_tooltip:
      'When you highlight a hand in the strategy table, you will see overall frequencies for that hand.',

    text_shadow: 'Text shadow',
    text_shadow_none: 'None',
    text_shadow_drop: 'Drop',
    text_shadow_higher: 'Raised',
    text_shadow_lower: 'Depressed',
    text_shadow_outlined: 'Outlined',

    grouping_actions: 'Actions grouping',

    text_shadow_range_cell: 'Range cell text-shadow',
    text_shadow_action_btn: 'Text shadow - action buttons',

    range_eq_buckets_style_title: 'Range comparison chart style',
    range_eq_buckets_style_one: 'Stretched',
    range_eq_buckets_style_two: 'Centered',
    // range_eq_buckets_style_tooltip: 'range_eq_buckets_style',
    range_table_text_color_title: 'Range table text color',
    range_table_text_color_one: 'White',
    range_table_text_color_two: 'Black',
    // range_table_text_color_tooltip: 'range_table_text_color',

    show_hand_value: 'Show numbers in strategy table',
    show_loading_tips: 'Show loading tips',
    show_legacy_solutions: 'Show legacy solutions',
    persist_actions_grouping: 'Remember grouping',
    keep_filters_between_spots: 'Keep filters between spots',

    show_solutions_dialog: 'Choose solution when entering Study mode',

    rng_enabled: 'RNG enabled',
    rng_aggressive_enabled: 'Agressive RNG enabled',

    solutions_hh_anlyzer: 'Used solutions for HH Analyzer',
    actions: 'Actions',
    other: 'Other',
    colors: {
      trainer_active_canvas_back: 'Active canvas background',
      trainer_active_canvas_outline: 'Active canvas outline',
      trainer_active_table_outline: 'Active table outline',
      trainer_active_table_back: 'Active table background',
      trainer_canvas_back: 'Canvas background',
      trainer_canvas_outline: 'Canvas outline',
      trainer_table_outline: 'Table outline',
      trainer_table_back: 'Table background',
      trainer_player_hero: 'Hero',
      trainer_player_opponent: 'Opponent',
      trainer_player_active: 'Player non-folded',
      trainer_player_folded: 'Player folded',
      trainer_pattern: 'Trainer pattern color',
      trainer_hand_highlight: 'Trainer hand highlight color',
      trainer_action_btn_default_background: 'Trainer action button color',

      range: 'Range',
      C: 'Call',
      X: 'Check',
      F: 'Fold',
      R_default: 'Raise',
      R1: 'Small',
      R1_2: 'Small',
      R2: 'Medium',
      R2_2: 'Medium',
      R3: 'Large',
      R3_2: 'Large',
      R4: 'Overbet',
      R4_2: 'Overbet',
      diamonds: 'Diamonds',
      spades: 'Spades',
      clubs: 'Clubs',
      hearts: 'Hearts',
      player_ip: 'In position',
      player_oop: 'Out of position',
      card_back: 'Card back color',

      smaller_bet: 'Smaller bet',
      bigger_bet: 'Bigger bet',

      worst: 'Worst',
      medium: 'Medium',
      best: 'Best',

      range_empty: 'Folded range background',
      range_active: 'Active range background',
      combo_range_empty: 'Folded hands background',
      combo_range_active: 'Active hands background',
      range_text: 'Text',
      combo_text: 'Text',
      action_text: 'Action button text',

      eveqeqrbl: 'Gradient',
      eveqeqrbl_tooltip: `Color gradient for:<div><span class="weight_700">EV, EQ, EQR</span> and <span class="weight_700">Blockers</span> score</div>
      `,
    },
    import_colors: {
      title: 'Import your colors',
      placeholder: '#00000 #FFFFFF #DDDDDD ...',
      error: 'Use hex format (#00000)',
    },
    color_themes: 'Color themes',
    // colors: 'Colors',
    theme_preview: 'Theme preview',
    hotkeys: 'Hotkeys',
  },
  roadmap: {
    roadmap: 'Roadmap',
    features: 'Features',
    solutions: 'Solutions',
  },
  dashboard: {
    tiles: {
      analyze_uploads: 'Uploads',
    },
    help: {
      how_it_works: 'See how it works',
      see_roadmap: 'See our roadmap',
      join_discord: 'Join our discord',
      startcrushing: 'Start crushing',
      solutions: 'Solutions',
    },
  },
  errors: {
    // discord_input_invalid: 'Please insert your Discord tag in the correct format (Name#0000)',
    discord_input_empty: 'Discord nickname cannot be blank',
  },
  event_card: {
    deciding: 'Deciding',
    take_action: 'Take action',
    jump_here: 'Jump here',
  },
  premium_overlay: {
    free_can_access: 'FREE USERS can only access single raised pot BTN vs. BB',
  },
  tips: {
    study: {
      strategy: {
        title: 'Meaning',
        strategy: 'Strategy',
        strategy_explanation: 'Shows the frequency that hands take different actions.',
        strategy_ev: 'Strategy + EV',

        strategy_eq: 'Strategy + EQ',
        strategy_eq_explanation:
          'Shows the color-coded strategy with the EQ of each action instead of the frequency.',

        // blockers: 'Blockers',
        // blockers_explanation: `Blocker score is a number from 1 (weakest) to 10 (strongest) which shows how much EV hero's specific hand removes from opponent range due to card removal.
        //        For example, if you hold the Ace of spades on a board with three spades, your opponent cannot have any nut flushes, which means you block a large portion of the opponent EV in this spot.`,
        // blockers_tra01: '--Blockers--',
        // blockers_tra01_explanation: `--TODOTEXT--`,

        strategy_ev_explanation:
          'Shows the color-coded strategy with the EV of each action instead of the frequency.',
        ev: 'EV',
        ev_explanation: `Shows the expected value of all combinations and actions.
                         EV is your average expected return for a given hand or action. e.g. for a coinflip with a $1 price, your EV is $0.50.`,
        equity: 'Equity',
        equity_explanation: `Shows the equity of each combination.
                             Equity is the percentage of the pot you'll win if a hand is checked down.`,
        eqr: 'EQR',
        eqr_explanation: `Shows the Equity Realization of each hand. Equity realization shows how well a hand performs relative to its raw equity.
        EQR is calculated by comparing the EV and EQ of a hand. e.g. if a hand expects to win 75% of the pot according to EV, and 50% of the pot according to EQ, then its EQR is 75%/50% = 150%.`,
        range: 'Range',
        range_explanation: `Shows the weight of each combination. If you only have a particular hand half the time it will show up as 0.5.`,
        all: 'All',
        all_explanation: 'Shows all of the above at the same time.',
      },
      filter: {
        in_any: 'In Any',
        in_any_explanation:
          'In this example, you will filter all hands that are either Two Pairs or Gutshots.',
        in_all: 'In All',
        in_all_explanation:
          'In this example, you will filter every hand that is both a Two pair and a Gutshot.',

        range_length_title: 'Change category scale',
        range_length: 'Range length',
        range_length_explanation:
          'Hand category graphs are scaled according to their frequency within your range.',
        full_length: 'Full length',
        full_length_explanation: 'All hand category graphs are scaled to 100%.',
      },
      eq_buckets: {
        title: 'Range comparison',
        advanced_sub: 'Hands are separated by their Equity into 7 categories.',
        other_tips: 'Tips',
        filter_eq: 'Filter Equity buckets, Draws, and Hands by clicking on any category.',
        switch_eq: 'Switch between Equity, EV, and Ranges view at the top of the Ranges.',
        mouseover_eq: 'Mouse over any combo in the ranges table to highlight it in the graph.',
        press_hotkey: 'Press {key} to toggle a Fullscreen mode',
      },
      graph_switcher: {
        change_table_view: 'Change table views:',
        show_height_of_hand_combo: 'Show height of each hand or combo',

        range_height: 'Range height',
        range_height_text: 'Scaled to their actual range.<br> (How many combos got into that spot)',

        full_height: 'Full height',
        full_height_text: 'Scaled to 100%.<br> (The whole cell is always filled)',

        normalized: 'Normalized',
        normalized_text:
          'The most frequent combo/hand is scaled to 100% height (Full height), and the rest of the combos/hands are scaled accordingly.',

        how_to_view_combo: 'Change how to view each combo',
        vertical: 'Vertical',
        vertical_text:
          'Shows strategy of all hand combos grouped. <br> (The most common way to view range)',

        horizontal: 'Horizontal',
        horizontal_text:
          'Shows strategy separately for each combo lined up horizontally. <br> (This is a great way to see how different the strategy is for flush draw combos)',
        // horizontal_text:'Shows strategy separately for each combo lined up horizontally (This is a great way to see how different the strategy is for flush draw combos - See this on example)',
        example:
          'For example - in Vertical view, it seems like you should be betting K7s about 50% of the time. In Horizontal view, you can quickly see only one combo betting, and others are mainly checking.',
      },
    },
    practice: {
      range_builder: {
        title: 'Difficulty',
        easy: 'Easy',
        easy_explanation: `Choose between single bet and check<br><span class="clr-grey text-small weight_500">Grouping - Simple</span>`,
        medium: `Medium`,
        medium_explanation: `Choose between all bet categories and check<br><span class="clr-grey text-small weight_500">Grouping - Grouped</span>`,
        hard: `Hard`,
        hard_explanation: `Choose between all bets and check<br><span class="clr-grey text-small weight_500">Grouping - All</span>`,
      },
      range_quiz: {
        // title: 'PP:range_quiz',
        // spot_quiz: 'PP:spot_quiz',
        // spot_quiz_explanation: 'PP:spot_quiz_explanation',
      },
    },
  },
  tables_columns: {
    title: 'Table column settings',
    subtitle: 'Add, remove and change order',
    selected_columns: 'Columns',
    selected_columns_sub: 'Click {icon} to remove or {icon_drag} drag column to rearrange',
    notselected_columns: 'Add column',
    notselected_columns_sub: 'Click {icon} to add column',
    empty_selected_message: 'No columns selected. Add columns from below.',
    empty_notselected_message: 'No additional columns available.',
    // empty_tablecolumns_message: 'No columns selected',
  },
  dashboard_links: {
    title: 'Links settings',
    subtitle: 'Add, remove and change order',
    selected_links: 'Dashboard',
    selected_links_sub: 'Click {icon} to remove or {icon_drag} drag shortcuts to rearrange',
    notselected_links: 'Add shortcut',
    notselected_links_sub: 'Click {icon} to add shortcut',
    empty_selected_message: 'No shortcuts selected. Add shortcuts from below.',
    empty_notselected_message: 'No additional shortcuts available.',
    // empty_dashboardlinks_message: 'No shortcuts selected',
  },

  anyall_tags_switch: {
    match: 'Match',
    // match_xxx: `<div>Match</div>
    //  <div class="gw_btn gw_btn_small gw_btn_text weight_600 lowercase" style="--clr:currentColor;--padding: 0 0 0 0.25rem">{text} <span class="mdi mdi-chevron-down text-semi-large"></span></div>`,
    any_tag: 'Any tag',
    all_tags: 'All tags',
    any_position: 'Any position',
    all_positions: 'All positions',
  },
  units: {
    ev: {
      ev: 'EV',
      ev_pot: 'EV/POT',
      csd: 'CSTE',
      csd_pot: 'CSTE/POT%',
      table_equity: 'TEQ',
      dollar_ev: '$EV',
    },
  },
  switchers: {
    strategy: 'Strategy',
    range: 'Range',
    eq: 'Equity',
    eqr: 'EQR',
    // groups: 'Groups',
    flops: 'Flops',
    ip_ev: 'EV IP',
    oop_ev: 'EV OOP',
    ip_eq: 'IP EQ',
    oop_eq: 'OOP EQ',
    ip_eqr: 'IP EQR',
    oop_eqr: 'OOP EQR',

    all: 'All',
    high_cards: 'High cards',
    board_type: 'Board type',
    pairing: 'Pairing',
    card_ranks: 'Cards',
    connectedness: 'Connectedness',
    suits: 'Suits',
    reports_chart: 'Chart',
    cards_cells: 'Default',
    // reports: 'Reports',
    table: 'Table',
    // reports: 'Reports',
    actions: 'Actions',
    cards: 'Cards',

    // sw_range_length: 'Range length',
    swv_full_length: 'Full length',
    swv_range_length: 'Range length',

    // sw_range_compare
    swv_eq_buckets_simple: 'EQ buckets - Simple ',
    swv_eq_buckets_advanced: 'EQ buckets - Advanced ',
    swv_hands: 'Hands',
    swv_draws: 'Draws',

    // sw_study_filter_intersection
    swv_filter_any: 'Match any category',
    swv_filter_intersection: 'Match all categories',

    // sw_combos_expand
    // swv_expanded: 'Expanded',
    // swv_shrinked: 'Contracted',

    sw_actions_grouping: 'Actions grouping',

    swv_grouping_4: 'Grouped',
    swv_grouping_all: 'Simple',
    swv_grouping_none: 'All',

    swv_grouping_all_difficulty: 'Simple',
    swv_grouping_4_difficulty: 'Grouped',
    swv_grouping_none_difficulty: 'Standard',

    // sw_actions_view
    swv_actions_grid: 'Grid',
    swv_actions_chart: 'Chart',

    // sw_range_content_hero sw_range_content_opponent
    swv_strategy: 'Strategy',
    swv_ev: 'EV',
    swv_eq: 'Equity',
    swv_eqr: 'EQR',
    swv_blocker: 'Blockers',
    swv_range: 'Range',

    // sw_hand_content
    swv_overview_all: 'All',
    // swv_strategy: 'Strategy',

    ev: 'EV',
    ev_pot: 'EV/POT',
    csd: 'Chip-Scaled Tournament Equity (CSTE)',
    csd_pot: 'CSTE/POT%',
    table_equity: 'Table Equity (TEQ)',
    dollar_ev: 'Dollar EV ($EV)',

    sw_range_height: 'Range height',
    swv_range_initial: 'Range height',
    swv_range_full: 'Full height',
    swv_range_normalized: 'Normalized',

    sw_combos_columns: 'Chart style',
    swv_combos_vertical: 'Vertical',
    swv_combos_horizontal: 'Horizontal',

    sw_combos_chart_style: 'Horizontal chart style',
    swv_combos_chart_no_line: `Don't show lines`,
    swv_combos_chart_line: `Show lines`,

    sw_reports_flop_grouping: 'Grouping',
    sw_reports_turn_grouping: 'Grouping',
    swv_flops: 'Flops',
    swv_high_cards: 'High cards',
    swv_suits: 'Suits',
    swv_pairing: 'Pairing',
    swv_connectedness: 'Connectedness',
    swv_turns: 'Turns',
    swv_card_ranks: 'Cards',

    // sw_reports_flop_content
    swv_flop_chart: 'Chart',
    swv_flop_table: 'Table',

    // sw_reports_colorcoded
    swv_reports_colortext: 'Text',
    swv_reports_colortext_colorchart: 'Text + Chart',
    swv_reports_colorchart: 'Chart',
    swv_reports_colorcoded: 'Background',
    swv_reports_notcolorcoded: 'None',

    // sw_reports_turn_content
    swv_turn_cells: 'Default',
    swv_turn_chart: 'Chart',
    swv_turn_table: 'Table',

    // sw_combos_dialog_content
    swv_handmatrix: 'Grid view',
    swv_table_summary: 'Summary',
    swv_table_all_summary: 'Range summary',
    swv_table_blockers: 'Blockers',
    // sw_handmatrix
    swv_handmatrix_simple: 'Simple',
    swv_handmatrix_detailed: 'Detailed',

    // swv_trainer_result_view
    swv_trainer_result_grid: 'Default view',
    swv_trainer_result_chart: 'Chart view',

    swv_layout_horizontal: 'Horizontal',
    swv_layout_split: 'Split',
    swv_layout_horizontal_rvr: 'Horizontal reversed',
    swv_layout_split_rvr: 'Split reversed',

    swv_layout_spacing_compact: 'Compact',
    swv_layout_spacing_medium: 'Medium',
    swv_layout_spacing_large: 'Large',

    // swv_gwiz_sols: 'Solutions library',
    // swv_custom_sols: 'Custom solutions',
  },
  browse: {
    breakdown: {
      title: 'Combo breakdown',
      all_combos_summary: 'All combos summary',
    },

    loading_turn_complex: 'Just a moment. <br> We are solving the Turn.',
    loading_river_complex: 'Just a moment. <br> We are solving the River.',

    loading_turn: 'Just a moment.',
    loading_river: 'Just a moment.',

    frequency_graph: 'Frequency graph',
    bet_distribution: 'Bet distribution',
    filter: 'Filter',

    matrix_summary: 'Summary',
    matrix_grid: 'Grid view',
    matrix_simple: 'Simple',
    matrix_detailed: 'Detailed',

    suits_switcher_included: 'Filter suits excluded',
    suits_switcher_excluded: 'Filter suits included',
    exlude: 'Exclude',
    include: 'Include',
    grouping_switcher: 'Switch between XX, YY, ZZ named view.???',
    grouping_switcher_postflop_only: 'Grouping is available on postflop',
    range_height: 'Range height',
    normalized: 'Normalized',
    full_height: 'Full height',
    range_height_view: 'Range height view',
    normalized_view: 'Normalized view',
    full_height_view: 'Full height view',
    vertical: 'Vertical',
    horizontal: 'Horizontal',

    // range_full_length: 'Full length',
    // range_range_length: 'Range length',

    column_without_lines: `Don't show lines`,
    column_with_lines: 'Show lines',

    in_any: 'Any rule',
    in_all: 'All rules',
    in_any_all_help: 'help',

    eq_buckets_simple: 'EQ buckets - Simple ',
    eq_buckets_advanced: 'EQ buckets - Advanced ',
    hands: 'Hands',
    draws: 'Draws',
    study_range_compare_help: 'help',

    combos_max_or_grid: 'Display combos in grid or maximized view',
    combos_maximized: 'Max',
    combos_grid: 'Grid',

    grouping_all: 'All',
    grouping_grouped: 'Grouped',
    grouping_simple: 'Simple',
    grouping_graph: 'Graph',

    range_in_clipboard: 'Range has been copied to clipboard',
    range_only_for_subscribed_users: 'This feature is available only for subscribed users.',
    copy_range_in_clippoard: 'Copy range in clipboard',
    show_equity_graph: 'show equity chart',
    postflop_only: 'Available on postflop',
    eq_buckets: {
      available_postflop: 'Equity buckets are available on postflop.',
      title: 'equity buckets',
      help_title: 'Hands are separated by their Equity:',
      eq_buckets_simple_tooltip: `<div class="text-center text-nowrap">
      Hands are separated by their Equity:
      </div>
      <div class="mt-1 uppercase text-nowrap">
      Best hands: 100% - 75%
      <br>
      Good hands: 75% - 50%
      <br>
      Weak hands: 50% - 33%
      <br>
      Trash hands: 33% - 0%
      </div>`,
      summary: 'summary',
      ev: 'ev',
      combos: 'combos',
      equity: 'equity',
      eqr: 'eqr',

      best_hands: 'best hands',
      good_hands: 'good hands',
      weak_hands: 'weak hands',
      trash_hands: 'trash hands',

      best_hands_abbr: 'best',
      good_hands_abbr: 'good',
      weak_hands_abbr: 'weak',
      trash_hands_abbr: 'trash',

      hands_0_25: 'Equity 0-25',
      hands_25_50: 'Equity 25-50',
      hands_50_60: 'Equity 50-60',
      hands_60_70: 'Equity 60-70',
      hands_70_80: 'Equity 70-80',
      hands_80_90: 'Equity 80-90',
      hands_90_100: 'Equity 90-100',
      hands_0_25_abbr: '0-25',
      hands_25_50_abbr: '25-50',
      hands_50_60_abbr: '50-60',
      hands_60_70_abbr: '60-70',
      hands_70_80_abbr: '70-80',
      hands_80_90_abbr: '80-90',
      hands_90_100_abbr: '90-100',
    },
    start_help: {
      title: 'Start here by clicking on any action.',
    },
    // eq_graph: {
    //   title: 'equity graph',
    // },
    tabs: {
      hands: 'hands',
      summary: 'summary',
      filters: 'filters',
    },
    filter_categories: {
      hands: 'hands',
      draws: 'draws',
      suits: 'suits',
      eq_buckets: 'Equity buckets',
      eq_buckets_advanced: 'Equity buckets - Advanced',
    },
    filter_rules: {
      no_made_hand: 'No made hand',
      king_high: 'King high',
      ace_high: 'Ace high',
      low_pair: 'Low pair',
      third_pair: 'Third pair',
      second_pair: 'Second pair',
      underpair: 'Underpair',
      top_pair: 'Top pair',
      overpair: 'Overpair',
      two_pair: 'Two pair',
      trips: 'Trips',
      set: 'Set',
      straight: 'Straight',
      flush: 'Flush',
      fullhouse: 'Fullhouse',
      quads: 'Quads',
      straight_flush: 'Straight flush',

      no_draw: 'No draw',
      gutshot: 'Gutshot',
      oesd: 'OESD',
      flush_draw: 'Flush draw',
      combo_draw: 'Combo draw',
      bd_sd: 'BDSD',
      bd_fd: 'BDFD',
      low_bdfd: 'BDFD low',
      mid_bdfd: 'BDFD mid',
      broadway_bdfd: 'BDFD broadway',
      nut_bdfd: 'BDFD nut',
      bd_sdfd: 'BDFD BDSD',
      low_flush_draw: 'FD low',
      mid_flush_draw: 'FD mid',
      broadway_flush_draw: 'FD broadway',
      nut_flush_draw: 'Flush draw nuts',
      onecard_bdfd: 'BDFD 1 card',
      twocards_bdfd: 'BDFD 2 cards',

      best_hands: 'Best hands',
      good_hands: 'Good hands',
      weak_hands: 'Weak hands',
      trash_hands: 'Trash hands',

      hands_0_25: 'Equity 0-25',
      hands_25_50: 'Equity 25-50',
      hands_50_60: 'Equity 50-60',
      hands_60_70: 'Equity 60-70',
      hands_70_80: 'Equity 70-80',
      hands_80_90: 'Equity 80-90',
      hands_90_100: 'Equity 90-100',
    },

    raise_all: 'Raise',
    raise_all_help: 'All raises together',
    bet_all: 'Bet',
    bet_all_help: 'All bets together',

    bet_overbet: 'Overbet',
    bet_large: 'Bet Large',
    bet_medium: 'Bet Medium',
    bet_small: 'Bet Small',

    raise_overbet: 'Overbet',
    raise_large: 'Raise Large',
    raise_medium: 'Raise Medium',
    raise_small: 'Raise Small',

    bet_overbet_help: 'Bets/Raises above 101%',
    bet_large_help: 'Bets/Raises between 67% and 101%. Raises above 67%',
    bet_medium_help: 'Bets/Raises between 36% and 67%',
    bet_small_help: 'Bets/Raises below 36%',

    title_actions: 'Actions',
    title_range: 'Range',
    title_suits: 'Suits',

    title_categories: 'Categories',
    // title_turn_hand_filter: 'Hand',
    title_turn_hand_filter: 'Turn hand',
    title_filter: 'Filter',
  },
  reports: {
    // filter: {
    //   board_type: 'Board type',
    //   flop_suits: 'Suits',
    //   flop_paired: 'Pairing',
    //   flop_connectedness: 'Connectedness',
    //   oesd_possible: 'OESD possible',
    //   flop_subset: 'Subset',
    //   cards: 'Cards',
    //   hands: 'Hands',
    //   categories: 'Categories',
    // },
    chart: {
      strategy: 'strategy',
      ev: 'ev',
      eq: 'equity',
      eqr: 'eqr',

      ip_ev: '{player} EV',
      oop_ev: '{player} EV',
      ip_eq: '{player} Eq ',
      oop_eq: '{player} Eq',
      ip_eqr: '{player} Eqr ',
      oop_eqr: '{player} Eqr',
      order: {
        default: 'Suits',
        color: 'Cards',
        ip: 'ip',
        oop: 'oop',
        // raise: 'raise',
        desc: 'Actions',
      },
    },
  },
  practice: {
    well_played: 'Well played',
    inaccuracy: 'Inaccuracy',
    best_move: 'Best move',
    correct_move: 'Correct move',
    wrong_move: 'Wrong move',
    blunder: 'Blunder',
    na: 'N/A',

    num_of_rules: '{num} Rule | {num} Rules',

    dashboard: {
      full_hand_title: 'PLAY vs GTO OPPONENT',
      full_hand_subtitle: 'Play hands from start to finish.',
      full_hand: 'Full hand',
      specific_spot_hand_title: 'MASTER SPECIFIC SPOT',
      specific_spot_hand_subtitle: 'Real time feedback and repetition.',
      specific_spot: 'Specific spot',
    },
    filter: {
      any: 'Any',
      specific: 'Specific',

      // custom_spot: 'Custom spot',
      custom: 'Custom',

      board: 'Board',
      flop: 'Flop',
      turn: 'Turn',
      river: 'River',
      postflop: 'Postflop',
      preflop: 'Preflop',
      real_game: 'Real game',
      custom_spot: 'Custom spot',
      flop_connectedness: 'Connectedness',
      oesd_possible: 'OESD possible',
      flop_cards: 'Cards',
      flop_suits: 'Suits',
      flop_paired: 'Pairing',
      not_paired: 'Not paired',
      trips: 'Trips',
      quads: 'Quads',
      tripled: 'Tripled',
      turn_paired: 'Pairing',
      turn_suit: 'Suit',
      turn_card: 'Card',
      river_paired: 'Pairing',
      river_suit: 'Suit',
      river_card: 'Card',
      paired: 'Paired',
      backdoor: 'Backdoor',
      high: 'High',
      mid: 'Mid',
      low: 'Low',
      rainbow: 'Rainbow',
      flush_draw: 'Flush draw',
      monotone: 'Monotone',
      medium: 'Medium',
      disconnected: 'Disconnected',
      disconnected_help: 'Straight not possible',
      connected: 'Connected',
      connected_help: 'Straight possible',
      flop_subset: 'Subset',

      diamonds: 'Diamonds',
      spades: 'Spades',
      clubs: 'Clubs',
      hearts: 'Hearts',

      flush: 'Flush',
      filter_message: 'Filter will be applied from the next hand',
      flop_high_card_help: 'You can select multiple cards at once.',
      flop_high_card: 'Highest card',
      flop_mid_card: 'Middle card',
      flop_low_card: 'Lowest card',

      flop_high_card_abbr: 'High',
      flop_mid_card_abbr: 'Mid',
      flop_low_card_abbr: 'Low',
      flop_subset_abbr: 'Subset',

      shorthand: {
        flop_high_card: 'High',
        flop_mid_card: 'Mid',
        flop_low_card: 'Low',
      },
      A: 'A',
      K: 'K',
      Q: 'Q',
      J: 'J',
      T: 'T',
      9: '9',
      8: '8',
      7: '7',
      6: '6',
      5: '5',
      4: '4',
      3: '3',
      2: '2',
    },
    history: {
      title: 'History',
      specific_spot_message: 'You can review your moves here.',
      full_hand_message: 'You can review your games here.',
      range_builder_message: 'History is not available in beta. ',
      range_quiz_message: 'History is not available in beta. ',
    },
    stats: {
      title: 'Stats',
      help: 'You can review your stats here.',
      total_hands: 'Total hands',
      played_hands: 'Played hands',

      hands: 'Hands',
      correct: 'Correct',
      correctness: 'Correctess',
      wrong: 'Wrong',

      total_good_res: 'Correct answers',
      total_bad_res: 'Wrong answers',

      good_percentage: 'Correct answers',

      total_ev_loss: 'Total EV loss',
      average_ev_loss: 'Avg. EV loss / hand',
      average_ev_mistake: 'Avg. mistake EV loss',
      format: 'Format',

      average_ev_loss_per_hand: 'EV loss / hands',

      avg_ev_mistake: 'Avg. mistake EV',
      avg_ev_loss: 'Avg. action EV',
      total_ev_loss_as_pot: 'Total EV loss as %pot',
      average_mistake_ev_loss: 'Avg. EV loss per mistake ',
      average_ev_loss_as_pot: 'Avg. EV loss as %pot',
      average_mistake_ev_loss_as_pot: 'Avg. mistake EV loss as %pot ',
      total_frequency_difference: 'Avg. frequency diff.',

      inaccuracy_moves: 'Inaccuracy move',
      best_moves: 'Best move',
      correct_moves: 'Correct move',
      wrong_moves: 'Wrong move',
      blunder_moves: 'Blunder',

      inaccuracies: 'Inaccuracy',
      mistake_moves: 'Mistakes',

      bests: 'Best',
      corrects: 'Correct',
      inaccuracy: 'Inaccuracy',
      wrongs: 'Wrong',
      blunders: 'Blunder',

      range_builder_message: 'Stats are not available in beta. ',
      range_quiz_message: 'Stats are not available in beta. ',
    },
    whole_game: {
      well_played: 'Well played!',
      mistake: 'Mistake',
      inaccuracy: 'Inaccuracy',
      perfect: 'Perfect',
      good: 'Good',
      na: 'Non-existing GTO spot',
    },
    solutions: 'Solutions',
    start_practice: 'start practice',
    table: {
      show_ranges: 'Show ranges',
      cheats: 'Cheats',
      act: 'Act',
      actions: 'Actions',
      freq: 'Freq',
      frequencies: 'Frequencies',
      total_freq: 'Total freq',
      hand_freq: 'Hand freq',
      results: 'Results',
      solution: 'Solution',
      change_move: 'Change move',
      continue: 'Continue',
      // next_hand: 'next hand',

      new_specific_spot_hand: 'New specific spot hand',

      new_fullhand_session: 'Next hand',
      repeat_fullhand_session: 'Repeat hand',
      configure_fullhand_session: 'Configure hand',

      answer: 'Answer',
      showdown: 'Showdown',
    },
    streak: {
      neutral: 'neutral-streak',
      winning: 'winning-streak',
      losing: 'losing-streak',
    },
    full_hand_finish_message: {
      played_hand: `You have played <span class="clr-white">{hands}</span>
                     hand with <span class="clr-white">{acc}%</span> accuracy`,
      played_hands: `You have played <span class="clr-white">{hands}</span>
                     hands with <span class="clr-white">{acc}%</span> accuracy`,
      average_mistake_is: 'Your avg. mistake EV loss is <span class="clr-white">{mistake}</span>',
      average_loss_is: 'Your average action EV is <span class="clr-white">{loss}</span>',
    },
    modes: {
      title: 'Modes',
    },
  },
  study: {
    dashboard: {
      solutions: 'Solutions',
      agg_reports: 'Aggregated reports',
      play_vs_gto: 'Play vs GTO',
      master_spec_spot: 'Master specific spot',
      analyzed_hands: 'Analyzed hands',
      uploads: 'Uploads',
    },
  },
  user_settings: {
    using_free_version: `You're using free version of GTO Wizard`,
    cancel_subscription: 'Cancel subscription',
    cancel_subscription_sub: `All future payments will be canceled and your plan will downgrade
     to the free version of GTO Wizard at the end of your current subscription period.`,
    payment_method: 'Payment method',
    current_plan: 'Current plan',
    current_plans: 'Current plans',

    other_plan: 'Other plan',
    other_plans: 'Other plans',

    tier_till: 'till',

    trial_will_expire_on_date: 'Your trial of GTO Wizard will expire on <b>{date}</b>.',
    sub_will_expire_on_date: 'Your plan will expire on <b>{date}</b>.',
    sub_will_renew_on_date: 'Your plan will renew on <b>{date}</b>.',
    sub_will_charge_via_tra01:
      'You will be charged <b>{amount} USD {amount_month}</b>  via <b>{payment_method}</b>.',

    how_to_install_mobile: 'How to install as an app on your phone.',
    how_to_install_desktop: 'How to install as an app on your desktop.',

    credits_banner_title: 'Introducing Power Credits',
    credits_banner_description:
      'Use credits to supercharge your app experience - Custom Aggregated Reports and more advanced features coming soon.',
    credits_banner_discord_button: 'Give us feedback on our Discord',
    credits_banner_learn_more: 'Learn more about Power Credits',
    credits_current_balance: 'Current Balance',
    credits_current_balance_value: '{credits_balance} credits',
    credits_usage_summary: 'Usage Summary',
    transaction_types: {
      _initial: 'Initial',
      _customer_care_topup: 'Customer Care Top-Up',
      _user_spend: 'User Spend',
      _user_topup: 'User Top-Up',
      _refund: 'Refund',
      _custom_report: 'Custom Report',
    },
  },
  sub_cancelation: {
    which_plan_cancel: 'Which plan do you want to cancel?',
    before_you_go: 'Before you go...',
    step: 'Step',
    other_placeholder: 'I am canceling because...',
    by_downgrading: `By downgrading, you'll lose access to many great features. Are you sure?`,
    tell_us_why: 'Before you cancel could You tell us why?',
    canceled_subscription:
      'You have canceled <span class="text-nowrap">{subscription_tier}</span> subscription.',
    tier_subscription_canceled: `Your {subscription_tier} is canceled.
                      Your account will downgrade to the FREE version of GTO Wizard on
                      <b>{subscription_expiration}</b>.`,
    cancelation_failed: 'Cancelation was not succesfull.',
    try_contacting: 'Try again or contact us via',
    sorry_for_tech_difficulties: `and our support will cancel your subscription manually.
                                 We are sorry for technical difficulties.`,
    reason: {
      no_need: 'I no longer need it',
      no_need_sub: `Once your subscription ends, you'll lose access to all your features.`,
      no_need_link: 'See all features',
      price: `It's too expensive`,
      price_sub: 'You can save a lot of money by switching to an annual plan.',
      price_link: 'Change my plan',
      free: 'The free version is good enough',
      free_sub: `Once your subscription ends, you'll lose access to all your features.`,
      free_link: 'See all features',
      technical: 'Technical difficulties',
      technical_sub: 'Having technical issues? Contact us so we can help you.',
      technical_link: 'Contact us ',
      other: 'Other',
    },
    features: {
      unlimited_solutions: 'Unlimited solutions to study',
      unlimited_solutions_sub:
        'Study any preflop and postflop spot you want in the Solution browser.',
      unlimited_spots: 'Unlimited spots in practice mode',
      unlimited_spots_sub: 'Practice as many hands as you want in all practice modes.',
      hands_month: '{starter_hands_mo} hands / month to analyze',
      hands_month_sub:
        'You get to upload and analyze {starter_hands_mo} hands you have played each month.',

      thousand_hands: '{premium_hands_mo} hands / month to analyze',
      thousand_hands_sub:
        'You get to upload and analyze {premium_hands_mo} hands you have played each month.',
      weekly_coaching: 'Weekly coaching',
      weekly_coaching_sub:
        'Every week, we offer Cash/MTT or Theory coaching, and you, along with other GTO Wizards.',
    },
  },
  sub_update: {
    change_plan: `Change your <span class="link-underline">{game}</span> plan`,
    select_plan: 'Please select a plan below',
    premium_users_can_analyze: 'Premium users can analyze {premium_hands_mo} hands / month.',
    see_premium_features: 'See all features here.',

    will_upgrade_to: 'Your account will be upgraded to:',
    will_downgrade_to: 'Your account will be downgraded to:',

    will_updown_to: 'Your account will {updown} to:',
    account_will: 'Your account will',
    downgrade: 'downgrade',
    upgrade: 'upgrade',

    update_fail: 'Ops. Something went wrong.',
  },
  tier: {
    plan_updated: 'Plan updated',
    plan_will_change: `Your plan <b class="text-nowrap">{game} / {plan} / {interval}</b> will change to <b class="text-nowrap">{new_game} / {new_plan} / {new_interval} </b> on <b>{date}</b>.`,
    next_charge_tra01: 'You will be charged <b class="text-nowrap">{amount} USD / {timespan}</b>.',

    plan_no_renew: 'Plan will not renew',
    plan_no_renew_message: `All scheduled charges have been canceled. On <b>{date}</b> your <b class="text-nowrap">{game} / {plan} / {interval}</b> plan will end and your account will be downgraded to the <b>Free</b> version of GTO Wizard.`,
    reactivate_plan: 're-activate your plan',
    reactivate_prev_plan: 're-activate your previous plan',
    perks: {
      free: {
        spots_day: 'You can study {free_spots_day} postflop spot / day',
        hands_day: 'You can practice {free_hands_day} hands / day in each practice mode',
        hands_month: 'You can analyze {free_hands_mo} hands / month',
      },
    },
    options: {
      free_tier: 'Free tier',
      trial_tier: 'Trial tier',

      all_formats: 'All formats',
      free_formats: 'Free formats',
      other_formats: 'Other formats',

      free_plan: 'Free plan',
      free: 'Free',
      trial: 'Trial',
      starter: 'Starter',
      premium: 'Premium',
      elite: 'Elite',

      FREE: 'Free',
      TRIAL: 'Trial',
      STARTER: 'Starter',
      PREMIUM: 'Premium',
      ELITE: 'Elite',

      trial_day: 'Trial / Day',
      starter_month: 'Starter / Monthly',
      starter_year: 'Starter / Annually',
      premium_month: 'Premium / Monthly',
      premium_year: 'Premium / Annually',
      elite_month: 'Elite / Monthly',
      elite_year: 'Elite / Annually',

      DAILY: 'Day',
      MONTHLY: 'Monthly',
      YEARLY: 'Annually',

      month: 'month',
      monthly: 'Monthly',
      monthly_plan: 'Monthly plan',
      year: 'year',
      yearly: 'Annually',
      yearly_plan: 'Annual plan',
      annualy: 'Annually',
      annual_plan: 'Annual plan',
      one_pament_of: 'One payment of',
    },
  },
  dashboard_articles: {
    title: 'Content',
    all_content: 'All content',
    // video: 'Video',
    // announcement: 'Announcement',
    // article: 'Article',
    // coaching: 'Coaching',
    all: 'All content',
    types: {
      video: 'Videos',
      announcement: 'Announcements',
      article: 'Articles',
      coaching: 'Coaching',
    },
    type: {
      video: 'Video',
      announcement: 'Announcement',
      article: 'Article',
      coaching: 'Coaching',
    },
  },
  history_events: {
    // no_rules: 'Random',
    mobile_message: 'Select a spot to practice',
    history_loading_error:
      'Something went wrong with this solution. Please select a different spot. We are working on it.',
  },
  close_decisions: {
    title: 'Close decisions',
    text: `Practice tricky spots! This setting means you’ll be dealt only those hands that have a close decision on their first action. A “close decision” is defined as a hand that has a similar EV between checking/betting or folding/continuing.`,
    examples: {
      one: `Practicing your opening strategy you'd be dealt hands that are close between opening and folding`,
      two: `Facing a bet you’d be dealt hands that are close between folding and continuing`,
      three: `Practicing c-bets you’d be dealt hands that are close between checking and betting`,
    },
  },
  messages: {
    zero_frequency_line: 'Selected line is rarely used in GTO. Solution may be inaccurate.',
    no_colors_in_uploaded_hands: 'There are no color labels in your hands.',
    upload_mainenance_tra01: `Due to maintenance, hand upload is currently disabled. <br>
          The functionality will be restored later today.`,
    // erase_combos: 'Erase combos',
    forced_fold_title: `This solution is only for SB vs. BB`,
    forced_fold_subtitle: `Skip BTN action by clicking Fold to get to SB vs BB solution`,

    all_hands_locked: 'All hands are locked',
    loading_taking_longer: 'Loading is taking longer than usual. <br> Please be patient...',
    loading_custom_reports:
      'Reports are loading, you can leave the reports tab and return later...',

    nodelock_no_locked_hands: 'No hands are locked',
    nodelock_unlocked_hands_will_be: `<b>Unlocked hands</b>  will be optimized by the solver.`,
    nodelock_locked_hands_will_be: `<b>Locked hands</b>  will retain their current strategy.`,

    erase_to_gto_sub: 'Manually unlock selected hands.',
    erase_to_gto_note: 'Solver will optimize the strategy of unlocked hands',

    lock_to_nodelocked_sub: 'Locks the current strategy of selected hands.',
    lock_to_nodelocked_note: 'Locked hands will retain their current strategy',

    choose_solution: 'Choose a solution',
    copy_to_clipboard: 'Copy to clipboard',
    copied_to_clipboard: 'Copied to clipboard',
    choose_last_flop_node_to_prefill_ranges: 'Complete the preflop action to prefill ranges',
    // gtowiz_ai_subtitle: `Learn from the world's <b>fastest</b> and most <b>advanced</b> solver. <br> {link}`,
    gtowiz_ai_subtitle: `Learn from the world's <b>fastest</b> and most <b>advanced</b> solver.`,
    no_custom_solutions: 'No custom solutions',
    click_hero_to_evaluate_strategy: 'Click here to validate your strategy',
    click_here_to_nodelock_strategy: 'Click here to nodelock your strategy',
    subscription_subtitle_help_links: {
      start: 'Need help? Contact us ',
      end: ` or via <a
      class="link-underline clr-primary"
      target="_blank"
      href="{mailto}"
    >
      {email}
    </a>`,
    },
    forced_logout: 'You have been logged out because you have logged in on a different device.',
    refresh_token_fail_logout: 'You have been logged out because your session has expired.',
    welcome_back: 'Welcome back!',
    dashboard_links_minimum: 'Please select at least 3 dashboard links',
    tables_columns_minimum: 'Please select at least 3 table columns',
    // icm_pko_future_tier_info: 'The MTT Classic and PKO solutions will soon be offered as separate subscriptions. Premium MTT users can access both in the meantime.',
    dashboard_no_content: 'No content was loaded',
    available_keys: 'Use A-Z or Space',
    // forbiden_key:'Forrbidden key',
    error_loading_bubble_factors: 'There was an error',
    see_analyze_guide: 'Analyzer guide',
    rakes_guide: 'Rake guide',
    uploads_explained: 'Uploads explained',
    analyzed_hands_explained: 'Analyzed hands explained',
    upload_statuses_explained: 'Statuses explained',

    more_themes_on_discord:
      'More themes on our <a href="https://discord.gg/ht3QxrP" class="link-underline clr-primary">Discord</a>.',
    select_option: 'Select option',
    more_about_blockers: 'More about blockers',
    assign_tags: 'Assign tags',
    no_results: 'No results',
    tag_contains: 'Tag contains',
    no_tags_yet: 'No tags created yet. Create a tag by assigning it to a drill',
    select_or_create_option: 'Select an option or create one',
    choose_tag: 'Filter tags',
    no_tags_create_one: 'No tags, yet...',
    same_tag_exists: 'Same tag already exists',
    available_posftlop_mtt:
      'MTT postflop solutions are currently available for ChipEV - 8max solutions',
    switch_to_mtt_chipev: 'Continue with MTT ChipEV 8max',

    change_solution_here: 'You can change your solution here.',
    error_gmf_favourite: 'There was an error. Setting was not saved. Status - {status}',
    try_out_focus_mode:
      'Try out <b>Focus mode</b>. The best way to practice without any distractions.',

    add_coaching_to_calendar:
      'Add <span style="color:var(--clr-coaching)">coaching</span>   to your calendar',

    initial_protection_title: 'It looks like you have opened GTO Wizard through an external link.',
    initial_protection_subtitle: 'Please wait before we open your solution.',
    initial_protection_note: `We appreciate your patience. <br> This serves as a security protection to help maintain a fair game environment.`,

    error_gameformat_set_gameformat: 'Error setting game format. Status {status}',

    outstanding: 'Outstanding',
    superb: 'Superb',
    exceptional: 'Exceptional',
    remarkable: 'Remarkable',
    astonishing: 'Astonishing',

    excellent: 'Excellent',
    great: 'Great',
    fantastic: 'Fantastic',
    terrific: 'Terrific',
    marvelous: 'Marvelous',

    well_played: 'Well played',
    skilled: 'Skilled',
    savvy: 'Savvy',
    proficient: 'Proficient',

    good: 'Good',
    solid: 'Solid',
    acceptable: 'Acceptable',
    decent: 'Decent',
    respectable: 'Respectable',

    fair: 'Fair',
    adequate: 'Adequate',
    sufficient: 'Sufficient',
    median: 'Median',

    marginal: 'Marginal',
    average: 'Average',
    mediocre: 'Mediocre',
    ordinary: 'Ordinary',

    inaccurate: 'Inaccurate',
    errant: 'Errant',
    imprecise: 'Imprecise',
    incorrect: 'Incorrect',

    needs_work: 'Needs work',
    improvable: 'Improvable',
    deficient: 'Deficient',
    lacking: 'Lacking',

    blunder: 'Blunder',
    gaffe: 'Gaffe',
    misstep: 'Misstep',
    slip_up: 'Slip-up',
    // best
    // well_played: 'Well played',
    // well_done: 'Well done',
    // keep_it_up: 'Keep it up',
    // excellent: 'Excellent',
    // perfect: 'Perfect',
    // great: 'Great',
    // magnificent: 'Magnificent',
    // outstanding: 'Outstanding',

    // innacuracy
    // inaccuracy: 'Inaccuracy',
    // not_bad: 'Not bad',
    // ok: 'Okay',
    // good: 'Good',

    // worst
    // mistake: 'Mistake',
    // needs_work: 'Needs work',
    // poor: 'Poor',
    // blunder: 'Blunder',

    solution_creation_error: 'Failed to create solution. Status {status}',

    get_custom_tree_error: 'Failed to load custom tree. Status {status}.',

    spot_ranges_prefill_failed: 'Ops. Settings prefill failed. Preflop action sequence is invalid.',
    spot_ranges_prefill_failed_status_xxx: 'Ops. Settings prefill failed. Status {status}.',

    filter_fetch_failed_status_xxx: 'Ops. Filter fetch failed. Status {status}.',

    trainer_session_finished: 'Session Complete',
    trainer_table_finished: 'Table finished',
    trainer_table_finished_sub: 'Finish your other tables',
    if_problem_contact_us_with_url: `If this problem persists, please contact us on <a href="https://discord.gg/ht3QxrP" class="link-underline clr-primary">Discord</a> and share url.`,

    solution_maintenance: 'Solution under maintenance',
    trainer_session_create_error: 'Failed creating session. Please try again.',
    multitable_disabled: 'Disabled on mobile',
    drill_corrupted: 'Drill is corrupted. Try to delete and save it again.',
    info_disabled_multitable:
      'In multitable mode, Info can be found in the top right corner of each table',
    outdated_safari_warning:
      'You are using outdated version of Safari browser, some features may not work correctly. Please upgrade to the latest Safari version.',
    // trainer_multitable_in_progress: 'Multiple hands in progress',
    // trainer_session_in_progress: 'Trainer session in progress',
    // trainer_multitable_will_be_canceled: 'By confirming this action current hands are going to be canceled.',
    // trainer_session_will_be_canceled: 'By confirming this action current session is going to be canceled.',

    trainer_game_in_progress: 'Game in progress',
    // trainer_current_game_cancel: 'Current game is going to be canceled',
    trainer_current_game_will_cancel: 'Leaving now will cancel the current game.',

    trainer_hands: '{n} hand | {n} hands',
    remeber_to_join_discord: 'Remember to join Discord',
    url_copied_in_clipboard: 'Url has been copied to clippboard',
    trainer_total_full_hands: '{n} hand | {n} hands',
    trainer_tables: '{num} tables',
    trainer_preflop_only: 'Preflop only',
    trainer_session_no_hands: 'Zero hands finished',
    trainer_learning_mode_on: 'Learning mode is enabled',
    theme_updated: 'Theme was updated',
    trainer_session_blocks_autoplay: 'Ignored in session mode',
    rng_is_set_to: 'RNG set to {rng_mode}',
    rng_enabled: 'RNG enabled',

    bc_not_supported_title: `This feature is not supported in your browser.`,
    // bc_not_supported_sub: `Please use the latest version of <br> Chrome, Firefox, Opera, Edge or Safari.`,

    get_most_of_analyzer: `Get the most out of Analyzer! <span class='text-underline'>Read guide</span>.`,
    get_most_of_trainer: `Get the most out of Trainer! <span class='text-underline'>Read guide</span>.`,
    get_most_of_rangebuilder: `Get the most out of Range Builder! <span class='text-underline'>Read guide</span>.`,
    get_most_of_stats: `Get the most out of Stats! <span class='text-underline'>Read guide</span>.`,
    get_most_of_drills: `Get the most out of Drills! <span class='text-underline'>Read guide</span>.`,
    // drill_what_is: `Drills define all settings for the GTO Trainer. Configure your training session in the advanced settings, then click confirm.
    //             The settings are saved in the URL. Paste that URL here to import a drill.`,
    drill_pep_talk: `Share Drills with your friends or join our <a href="https://discord.gg/ht3QxrP" class="link-underline clr-primary">Discord</a>
                    to discover new training Drills from others!`,
    palettes_pep_talk: `Share themes with your friends or join our <a href="https://discord.gg/ht3QxrP" class="link-underline clr-primary">Discord</a>
                    to discover new themes from others!`,
    coaching_video_in_post_production:
      'This video is currently in post production. It will be available soon.',
    no_videos_try_changing_filter_parameters: 'No videos found. Try changing filter parameters.',
    waiting_for_trainer_session_start: 'Waiting for trainer session...',
    start_crushing_with_us: 'Start crushing with GTO Wizard',
    no_coachings: 'There are no coachings scheduled.',
    error_loading_coachings:
      'There was an error loading the coachings. Please try again later. If this problem persists, please contact us on  <a href="https://discord.gg/ht3QxrP" class="link-underline clr-primary">Discord</a>.',
    no_drills: 'No drills',
    no_favorite_drills: 'No favorite Drills',
    manage_drills_here: 'Manage Drills here',
    create_drill_here: 'Create a Drills here.',
    // trainer_add_new_preset: 'Add new drill',
    // trainer_preset_custom_info: 'Your custom drills <br> will appear here.',
    trainer_preset_import_error: 'This drill is corrupted, try exporting it again.',
    preset_solfigr_setting_error: 'This setting is corrupted, try exporting it again.',

    success_drill_create: 'Drill was created. | {n} Drills were created.',
    success_drill_update: 'Drill was updated. | {n} Drills were updated.',
    success_drill_delete: 'Drill was deleted. | {n} Drills were deleted.',
    error_drill_create:
      'Drill was not created. Error {status}. | {n} Drills were not created. Error {status}.',
    error_drill_update:
      'Drill was not updated. Error {status}. | {n} Drills were not updated. Error {status}.',
    error_drill_delete:
      'Drill was not deleted. Error {status}. | {n} Drills were not deleted. Error {status}.',

    success_range_create: 'Range was created.',
    success_range_update: 'Range was updated.',
    success_range_delete: 'Range was deleted.',
    error_range_create: 'Range was not created. Error {status}.',
    error_range_update: 'Range was not updated. Error {status}.',
    error_range_delete: 'Range was not deleted. Error {status}.',

    success_tree_create: 'Settings was created.',
    success_tree_update: 'Settings was updated.',
    success_tree_delete: 'Settings was deleted.',
    success_tree_import: 'Settings was imported.',
    error_tree_create: 'Settings was not created. Error {status}.',
    error_tree_update: 'Settings was not updated. Error {status}.',
    error_tree_delete: 'Settings was not deleted. Error {status}.',
    // error_tree_import: 'Settings was not imported. Invalid settings.',

    // success_nodeedit_create: 'Settings was created.',
    success_nodeedit_update: 'Node was updated.',
    // success_nodeedit_delete: 'Settings was deleted.',
    // error_nodeedit_create: 'Settings was not created. Error {status}.',
    error_nodeedit_update: 'Node was not updated. Error {status}.',
    // error_nodeedit_delete: 'Settings was not deleted. Error {status}.',

    success_solution_create: 'Solution was created.',
    success_solution_update: 'Solution was updated.',
    success_solution_delete: 'Solution was deleted.',
    error_solution_create: 'Solution was not created. Error {status}.',
    error_solution_update: 'Solution was not updated. Error {status}.',
    error_solution_delete: 'Solution was not deleted. Error {status}.',

    success_tag_create: 'Tag was created',
    success_tag_update: 'Tag was updated',
    success_tag_delete: 'Tag was deleted',
    error_tag_create: 'Tag was not created. Error {status}.',
    error_tag_update: 'Tag was not updated. Error {status}.',
    error_tag_delete: 'Tag was not deleted. Error {status}.',

    success_filter_create: 'Filter was created.',
    success_filter_update: 'Filter was updated.',
    success_filter_delete: 'Filter was deleted.',
    error_filter_create: 'Filter was not created. Error {status}.',
    error_filter_update: 'Filter was not updated. Error {status}.',
    error_filter_delete: 'Filter was not deleted. Error {status}.',

    success_preset_create: 'Preset was created.',
    success_preset_update: 'Preset was updated.',
    success_preset_delete: 'Preset was deleted.',
    error_success_preset_create: 'Preset was not created. Error {status}.',
    error_success_preset_update: 'Preset was not updated. Error {status}.',
    error_success_preset_delete: 'Preset was not deleted. Error {status}.',

    trainer_preset_name_exists_error: 'Drill with the same name already exists.',
    trainer_preset_name_empty_error: 'Drill name cannot be empty.',
    name_too_many_characters: 'Session name has more than {max_chars} characters.',
    note_too_many_characters: 'Session note has more than {max_chars} characters.',
    trainer_preset_name_too_many_characters: 'Drill name has more than {max_chars} characters.',
    trainer_preset_description_too_many_characters:
      'Drill description has more than {max_chars} characters.',

    custom_solution_name_empty_error: 'Solution name cannot be empty.',
    custom_solution_preset_name_too_many_characters:
      'Solution name has more than {max_chars} characters.',
    // custom_solution_preset_description_too_many_characters: 'Solution description has more than {max_chars} characters.',

    custom_range_name_empty_error: 'Range name cannot be empty.',
    custom_range_preset_name_too_many_characters:
      'Range name has more than {max_chars} characters.',
    // custom_range_preset_description_too_many_characters: 'Range description has more than {max_chars} characters.',

    field_too_many_characters: 'Field has more than {max_chars} characters.',
    field_empty_error: 'Field cannot be empty.',

    field_name_empty_error: '{field_name} cannot be empty.',
    field_name_too_many_characters: 'Name has more than {max_chars} characters.',
    field_description_too_many_characters: 'Description has more than {max_chars} characters.',

    no_players_postfop: 'Selected players have no actions.',
    // no_players_postfop: 'Selected players have no actions.',
    solution_no_postfop: 'Selected solution is currently preflop only',
    solution_no_postfop_abbr: 'This solution is currently preflop only',
    solution_prefill_from_this_node: 'Click "confirm" to prefill ranges.',
    solution_no_shortcuts_trainer:
      'This solution does not contain any shortcuts. Choose Custom spot.',
    solution_no_shortcuts_solfigr:
      'This solution does not contain any shortcuts. <br> Use custom ranges or select different solution.',
    oops_error: 'Ops! Something went wrong. ',
    something_wrong: 'Something went wrong',
    opps_error_sub:
      'If this problem persists, please contact us on  <a href="https://discord.gg/ht3QxrP" class="link-underline clr-primary">Discord</a>.',

    no_results_were_found: 'No results were found.',
    error_code: 'Error code: {code}',
    // contact_us_discord: 'Please contact us on our Discord.',

    oops_error_filter_fetch_status: 'Ops! Failed to fetch: "{title}". Status {status}',

    upgrade_to_tier: 'Upgrade to {tier}',
    upgrade_to_unlock: 'Upgrade to unlock',

    upgrade_to_elite_unlock_custom_solutions:
      'Upgrade to <span class="weight_700">Elite</span> to unlock <br>  <span class="weight_700">Custom solving</span> for all flops',
    upgrade_to_elite_unlock_custom_preflop_solutions:
      'Upgrade to <span class="weight_700">Elite</span> to unlock <br>  <span class="weight_700">Custom solving</span> for preflop',
    upgrade_to_elite_unlock_custom_solutions_with_rake:
      'Custom Rake solving is available in <br> {tier} <br>  Elite subscriptions',
    upgrade_to_elite_mtt_unlock_icm_tournament_search:
      'Upgrade to <span class="weight_700 clr-whiste">Elite MTT</span> to unlock <span class="weight_700 clr-whiste">tournament search</span>',

    switch_free_flop: 'Switch to free flop',
    non_tier_available_flop: 'Non {tier} users can only use {board} flop.',
    upgrade_to_elite_unlock: 'Upgrade to <span class="weight_700">Elite</span> to unlock',
    upgrade_to_elite_unlock_all_flops:
      'Upgrade to <span class="weight_700">Elite</span> to unlock <span class="weight_700">all flops</span>',
    upgrade_to_elite_unlock_all_flops_with_rake:
      '<span class="weight_700">Custom Rake solving</span> is available in <br> <span class="weight_700">{tier} Elite subscriptions</span>',
    upgrade_to_elite_unlock_all_flops_with_icm:
      '<span class="weight_700">ICM solving</span> is available in <br> <span class="weight_700">{tier} Elite subscriptions</span>',
    upgrade_to_premium_postflop: 'Upgrade to Premium to unlock postflop',
    upgrade_to_premium_all_spots: 'Upgrade to Premium to unlock all spots',

    save_spot_note_placeholder: 'Add a note here...',

    sucess_deleting_spots: 'Spot deleted | Spots deleted',
    error_deleting_spots: 'There was an error. Some of the spots were not deleted.',

    sucess_deleting_trees: 'Settings deleted | Settings deleted',
    error_deleting_trees: 'There was an error. Some of the settings were not deleted.',

    sucess_deleting_filters: 'Filter deleted | Filters deleted',
    error_deleting_filters: 'There was an error. Some of the filters were not deleted.',

    sucess_saved_solutions: 'Saved Solution deleted | Saved solutions deleted',
    error_deleting_saved_solutions:
      'There was an error. Some of the saved solutions were not deleted.',

    file_in_queue_tra01: 'File is in queue and will be processed.',
    files_in_queue_tra01: `The queue time can take multiple hours now. We're working to get things back to normal as quickly as possible, and we apologize for the inconvenience.`,
    files_in_queue_tooltip: `Your files will end up in queue if there are too many players analyzing their hands simultaneously.
                             Please wait. Your files will get analyzed. You will need to refresh the page to see the status get updated.
                             We are continuously improving our infrastructure, so you never have to wait.`,
    only_for_premium: 'Only for Premium users',
    // coaching_only_for_premium: 'This Coaching is only for Premium users.',

    coaching_upgrade_message_tra01:
      'This Coaching video is only for <span class="weight_500 clr-whiste">{tier} {gametype}</span> users.',
    coaching_upgrade_to_continue_watching_message:
      'Upgrade to <span class="weight_500 clr-whiste">{tier} {gametype}</span> to see full video.',

    range_builder_pinned_combo: 'Painting specific combos',
    range_builder_lock_mode_on: 'Locking specific combos',
    range_builder_in_beta: `<div class="weight_500 mb-1">Range builder is in the beta version.</div>Tell us how to improve it on our <a href="https://discord.gg/ht3QxrP" class="link-underline clr-primary">Discord</a>!`,
    range_quiz_in_beta: `<div class="weight_500 mb-1">Range quiz is in the beta version.</div>Tell us how to improve it on our <a href="https://discord.gg/ht3QxrP" class="link-underline clr-primary">Discord</a>!`,
    loading_showdown: 'Loading showdown',
    errors: {
      error_loading_solution: `Something went wrong with this solution.
                              <br> Please select a different spot. <br> We are working on it.`,

      title_400_TREE_IS_TOO_BIG: 'Solution is too large.',
      subtitle_400_TREE_IS_TOO_BIG: `Try reducing the number of bet sizes <br> that are too close to each other.`,
      error_discord_help: `If this problem persists, please contact us on  <a href="https://discord.gg/ht3QxrP" class="link-underline clr-primary">Discord</a> for support.`,
      error_analyze_hand: `Sorry, we weren't able to analyze this hand.`,
    },
    banners: {
      // starting_at: 'Starting at',
      weekly_coaching_with: 'Weekly Coachings <br> with Saulo Costa',
      is_happening: 'Is happening now!',
      link_will_be_available: '* You can join the coaching after the countdown ends.',
      click_zoom_link:
        '* After you click JOIN, click on the <span class="weight_700">Join from Your Browser</span> in the ZOOM.',
      previous_coachings: 'Previous coachings',
    },
    cookies: {
      line_0: 'By using our website you agree to our',
      line_1: 'Cookie Policy',
    },
    upload: {
      files_deleted_tra01: 'Deleted {n} file. | Deleted {n} files.',
      hands_deleted_tra01: 'Deleted {n} hand. | Deleted {n} hands.',
      sessions_deleted: 'Deleted {n} session. | Deleted {n} sessions.',
    },
    solutions: {
      title_429: 'You have reached the daily solution browsing limit.',
      title_starter_429: 'You have reached the daily solution browsing limit.',
      subtitle_429: 'This is security protection. Please come back again tomorrow.',

      title_403: 'You have reached your free daily solution browsing limit.',
      title_starter_403: `You don't have access to this solution.`,
      title_only_subscribed_403: `This solution is only for subscribed users.`,

      subtitle_403_tra01: `<span class="weight_700">{gameformat_option}</span> <br> is only for
      <span class="weight_700">{gameformat_tiers} {gameformat}</span> users.`,
      subtitle_403_starter_depths: `Available depths in <span class="weight_700">Starter {gameformat}</span> are: <br> {depths} BB`,
      subtitle_403_starter_depths_custom: `Available depths in <span class="weight_700">Starter {gameformat}</span> are: <br> {str}`,

      title_204: 'There is no solution for this spot.',
      subtitle_204: `Please select a heads-up post-flop spot, or this spot doesn't
                     have any meaningful range in GTO.`,

      title_204_elite: 'There is no solution for this spot.',
      subtitle_204_elite: `You may have selected an action that this solution never takes. Make sure you've selected a heads-up postflop spot.`,
    },
    reports: {
      title_429: 'You have reached the daily solution browsing limit.',
      title_starter_429: 'You have reached the daily solution browsing limit.',
      subtitle_429: 'This is security protection. Please come back again tomorrow.',

      title_403: 'You have reached your free daily solution browsing limit',
      title_starter_403: `You don't have access to this solution.`,
      title_only_subscribed_403: `This solution is only for subscribed users.`,

      subtitle_403_tra01: `<span class="weight_700">{gameformat_option}</span> <br> is only for
      <span class="weight_700">{gameformat_tiers} {gameformat}</span> users.`,
      subtitle_403_starter_depths: `Available depths in <span class="weight_700">Starter {gameformat}</span> are: <br> {depths} BB`,
      subtitle_403_starter_depths_custom: `Available depths in <span class="weight_700">Starter {gameformat}</span> are: <br> {str}`,

      title_204: 'Please come back later.',
      subtitle_204: `We will add reports for this spot soon.`,
    },
    practice: {
      title_429: 'You have reached your free 10 hands daily practicing limit.',
      title_starter_429: `You have reached your free 10 hands daily practicing limit.`,
      subtitle_429_tra01: `<span class="weight_700">{gameformat_option}</span> <br> is only for
      <span class="weight_700">{gameformat_tiers} {gameformat}</span> users.`,
      subtitle_403_starter_depths: `Available depths in <span class="weight_700">Starter {gameformat}</span> are: <br> {depths} BB`,
      subtitle_403_starter_depths_custom: `Available depths in <span class="weight_700">Starter {gameformat}</span> are: <br> {str}`,

      title_starter_403: `You don't have access to this solution.`,
      title_only_subscribed_403: `This solution is only for subscribed users.`,

      // title__429: `You have reached your free 10 hands daily practicing limit.`,

      title_204: 'There is no solution for this spot.',
      subtitle_204: `Please select a heads-up post-flop spot,
      or this spot doesn't have any meaningful range in GTO.`,

      title_204_elite: 'There is no solution for this spot.',
      subtitle_204_elite: `You may have selected an action that this solution never takes. Make sure you've selected a heads-up postflop spot.`,

      trainer_continue_to_next_hand: 'Please continue to next hand.',
      trainer_unhandled_error_sub:
        'Please continue to next hand. If this problem persists, please contact us on  <a href="https://discord.gg/ht3QxrP" class="link-underline clr-primary">Discord</a>.',
      title_400_INVALID_HAND: 'No hand found.',
      subtitle_400_INVALID_HAND: `Please continue to next hand. If this problem persists, please contact us on
      <a href="https://discord.gg/ht3QxrP" class="link-underline clr-primary">Discord</a> for support.`,
      title_400_INVALID_SESSION: 'No session found.',
      subtitle_400_INVALID_SESSION: `This session was removed or couldn't be found.
       If you think this is an error you can contact our
       <a href="https://discord.gg/ht3QxrP" class="link-underline clr-primary">Discord</a> for support.`,

      title_400_TREE_IS_TOO_BIG: 'Solution is too large.',
      subtitle_400_TREE_IS_TOO_BIG: `Try reducing the number of bet sizes <br> that are too close to each other.`,
    },

    upload_limit_reached:
      'It seems that you have reached your upload limit in last {upload_reset_days} days.',
    enjoy_free_version: 'Hello, enjoy your free trial for the next {trial_hours} hours!',
    enjoy_free_version_affiliate:
      'Enjoy your <b>FREE trial</b> for the next {trial_hours} hours! And thanks to "<span class="weight_700">{affiliate_name}</span>" you also got a {discount}% discount on your first purchase!',
    enjoy_free_version_discount:
      'Enjoy your <b>FREE trial</b> for the next {trial_hours} hours! You also got a {discount}% discount on your first purchase!',
    translators_wanted: 'We are looking for native translators!',
    help_us_localize: 'Please help us to translate GTO Wizard into your language.',
    contact_team_member: 'Contact {team_member} on our',

    select_postflop_to_see_category: 'Select a post-flop spot to see {str}',
    eq_buckets_preflop: 'Select a post-flop spot to see ranges comparison.',
    postflop_equity_only: 'Select a post-flop spot to see {value}.',
    select_postflop_spot: 'Select a post-flop spot to see more info.',
    select_postflop_spot_blockers: 'Select a post-flop spot to see blockers.',
    select_postflop_spot_filter: 'Select a post-flop spot to see filters.',
    select_postflop_spot_categories: 'Select a post-flop spot to see categories.',
    select_postflop_spot_breakdown: 'Select a post-flop spot to see breakdown.',
    hero_only_strategy_summary: 'Strategy summary is for HERO only.',
    hero_only_strategy_summary_sub: 'Mouseover his range.',

    practice_builder_beta_mobile: 'Range Builder mobile version is not available in beta.',
    practice_quiz_beta_mobile: 'Range Quiz mobile version is not available in beta.',

    we_are_almost_there: 'We are almost there.',
    error_reload: 'There was an error. Try refreshing the page or try clearing browser cache.',
    error_check_internet_connection: 'There was an error. Check your internet connection',
    update_in_progress: 'Update in progress',
    thx_patience: 'Thank you for your patience.',
    well_be_back: 'We will be right back.',

    shortcut_spot_doesnt_exist: 'This spot does not exist',
    select_spot_to_master: 'Select a spot you want to master in the selector above the table.',
    select_spot_to_range_build: 'Select a spot you want to practice in the selector above.',

    blockers_upper_tier_only: {
      title: 'Blockers are available only for {tier} users.',
      // subtitle: 'We are still solving post-flop. We will add it soon.',
    },
    game_format_unavailable: {
      // title: 'solutions are available only for preflop at the moment.',
      // title_tra01: '{gametype} solutions are available only for preflop at the moment.',
      title_tra02: '{gametype} <br> This solution is available only for preflop at the moment.',
      subtitle: 'We are still solving post-flop. We will add it soon.',
    },
    FREE_unavailable: {
      title: 'Aggregated reports are available only for {game} subscribed users.',
      video_title: 'See how it works',
    },
    trialUser403: {
      // TODo unify translation
      title_tra01: 'Trial users can study only limited spots.',
      subtitle: 'Starter and Premium users can study more spots.',
    },
    starterUser403: {
      // title: 'Starter users can study only limited spots.',
      // subtitle: 'Premium users can browse unlimited spots.',
      title_tra01: 'Starter users can access only limited reports:',
      subtitle_tra01: 'Premium users can study all reports.',
    },
    select_board_strategy: {
      title: 'Choose board first',
    },
    custom_reports_payment_required: {
      subtitle: `Generating Report for Custom Solution will cost <span class="clr-primary weight_700 mdi mdi-poker-chip">&nbsp;{price}</span> credits.</br>
      Your current available balance is <span class="clr-primary weight_700 mdi mdi-poker-chip">&nbsp;{balance}</span> credits.</br></br>
      You can view reports you’ve already paid for in your history.`,
      insufficient_balance:
        'Insufficient Balance. To generate more reports, please contact support.',
    },
    no_river: {
      title: 'River reports are not available yet.',
      subtitle: 'Please select different reports',
    },
    no_custom_report_turn: {
      title: 'Turn reports are not available yet.',
      subtitle: 'Please select different reports',
    },
    no_custom_sol_reports: {
      title: 'Reports for Custom Solutions are not available yet.',
      subtitle: 'Please select a solution from Solution Library to see reports.',
      switch_to_library_solutions: 'Switch to Solution Library',
    },
    turnZeroDataValues: {
      title: `Chosen hand is not in the player's range.`,
    },
    // upgrade_to_elite_unlock_custom_solutions:{
    //   title: 'Upgrade to Elite to unlock Custom Solutions',
    // }
    // no_preflop: {
    //   title: 'Select a post-flop spot to see more info.',
    // },

    missing_spot: {
      title: 'MISSING SPOT',
      subtitle: 'We will add this spot soon!',
    },
    // subscription: {
    //   select_gametype_first: 'Please select prefered gameformat first.',
    // },
    flops_not_yet_generated: 'All flops are not yet generated. This data is incomplete...',
  },
  range_builder: {
    auto_setup_matrix: 'Automatically setup the whole matrix',
    // keep_locked_hands: 'Keep locks ',
    // overwrite_all: 'Overwrite all',
    all_hands: 'All hands',
    unlocked_hands: 'Unlocked hands',

    ovewrite_unlocked_hands: 'Overwrite unlocked',
    ovewrite_all_hands: 'Overwrite all',

    // existing_locks: 'Existing locks',
    combos_locked: ' Combos locked: {n}',
    hands_locked: 'Hands locked: {n}',
    // highlight_different_groups: 'Higlight diffenrent groups',
    combos_by_score: 'Combos by score',
    categories_best: 'Best categories',
    categories_worst: 'Worst categories',
    chart_yours: 'Yours',
    chart_correct: 'Correct',
    // actions: 'Actions',
    summary: 'Summary',
    hands: 'Hands',
    draws: 'Draws',

    perfect: 'Perfect',
    perfect_help: 'Combos above 75%',
    good: 'Good',
    good_help: 'Combos below 75% and above 60%',
    inaccuracy: 'Inaccuracy',
    inaccuracy_help: 'Combos below 60% and above 40%',
    mistake: 'Mistake',
    mistake_help: 'Combos below 40%',
  },
  range_quiz: {
    mode_one: 'Spot quiz',
    mode_three: 'Range quiz',
    title_one: 'Which spot uses this range?',
    title_three: 'Choose correct range for:',
    // title_three: '<span class="text-normal">Choose correct range for:</span> {spot}',
    a: 'a',
    b: 'b',
    c: 'c',
    d: 'd',
  },
  nodeedit: {
    title: 'Edit node',
    reset_node: 'Reset node',
    add_bet: 'Add bet',
    select_min_one_action: 'Select at least one action',
  },
  nodelock: {
    lock_atleast_one_hand: 'Lock at least one hand',
    // add_locks_to_all: 'Lock all hands',
    add_locks_to_all: 'Lock all',
    remove_locks_from_all: 'Unlock all',
    // reset_all_to_default: 'Unlock & Reset all hands',
    reset_all_to_default: 'Unlock & Reset',
    eraser_brush: 'Eraser brush',
    choose_solution_to_compare: `Choose the solution that <br> you want to compare`,
    no_solution: 'There is no solution for this board',
    no_solution_sub: 'Game tree has diverged, these nodes are no longer comparable',
  },
  tooltips: {
    remove_table: 'Remove table',
    turn_off_hints_key:
      'Press <span class="keyboardkey_key clr-white text-normal">{key}</span> to hide hint',
    sort_by_last_used_date: 'Sort by last used date',
    edit_solution: 'Edit solution',
    unignore_action: 'Unignore action',
    ignore_action: 'Ignore action',
    swap_ranges: 'Swap ranges',
    save_solution: 'Save solution',
    show_info: 'Show info',
    copy: 'Copy <span class="keyboardkey_key clr-white text-normal">Ctrl(⌘) + C</span>',
    paste: 'Paste <span class="keyboardkey_key clr-white text-normal">Ctrl(⌘) + C</span>',
    choose_filter: 'Choose filter',
    remove_action: 'Remove action',
    add_action: 'Add action',
    edit_node: 'Edit actions',
    merged_actions: 'These sizes have been merged: {str}',
    node_lock: 'Nodelock',
    node_lock_disabled: 'Nodelock is disabled for single action',
    node_compare: 'Compare nodes',
    view_hands: 'View hands',
    choose_solution: 'Choose solution',
    filter_toggle_category: 'Toggle category',
    select_all_above: 'Select all above',
    deselect_all_above: 'Deselect all above',
    drag_drop_to_reorder: 'Drag and drop to reorder',
    show_usernames: 'Show usernames',
    copy_hand_id_to_clipboard: 'Copy hand id',
    hand_id_copied_to_clipboard: 'Hand id has been copied to clipboard',
    remove_player_color: 'Remove player color',
    what_are_symmetric_stacks: `Symmetric stacks are solutions where all players have the same stack sizes. <br> (e.g. BTN - 10bb, SB - 10bb, BB - 10bb)`,
    filter_suit:
      'Filter suits in your range <br> by including or excluding <br> Suited and/or Offsuit suits',
    what_is_pot_odds: `
    Pot odds tell you what portion of the pot <br>
    you need to win to justify a call.
    {linkText}`,
    coaching_video_toggle_favorite: 'Toggle favorite video',
    coaching_video_toggle_watched: 'Toggle watched video',
    see_glossary: 'See glossary',
    take_quiz: 'Take quiz',
    dashboard_settings: 'Configure dashboard',
    trainer_result_view: 'Result view',
    reports_table_color_coding_unavailable:
      'This feature can only be accessed when viewing reports in a table view',
    remove_dashboard_link: 'Remove shortcut',
    add_dashboard_link: 'Add shortcut',
    // reorder_dashboard_link:'Reorder link',
    ev_compare_explained_tra01: `
    <div class="py-2">
    <div class="weight_700">Compare the expected value of one action against another</div>
    <div class="mt-2">Your range is color-coded according to the difference between the selected action on the left and the comparison on the right. This helps you find which hands have a close decision and which hands clearly prefer one action over another.
    </div>
    <div class="mt-2">Comparing some action to the <b>'Best Action'</b> effectively shows the <b>'regret'</b> or <b>EV loss</b> against a fixed strategy.
    </div>
    {linkText}
    </div>
    `,
    // ev_regret_explained: '--ev_regret_explained--',

    bubble_factor_explained: `
    <div class="py-2">
    <div><b>Bubble Factor</b> measures {linkText} - how much more losing hurts than winning helps you in MTTs.</div>
    <div class='mt-2'><b>Bubble Factor</b> is defined as the ratio between how much tournament equity (<b>$EV</b>) you’d lose getting stacked, divided by how much <b>$EV</b> you’d gain stacking some player in the tournament.</div>
    <div class='mt-2'><b>Risk Premium</b> is a percentage defined as how much extra equity you’d need, compared to a chip <b>EV</b> pot odds calculation, to breakeven against a shove against some player.</div>
    <div class='mt-2'>Every player in the tournament has a different <b>BF</b> vs every other player.</div>
    {linkTextBubble}
    </div>
    `,
    show_bubble_factor: 'Show bubble factor',
    tag_anyall: `Filter drills either by partial or full match of selected tags.`,
    more_about_subsets: 'More about subsets',
    see_payouts: 'Show payouts',
    see_payouts_bubble_factors: 'Display payouts and bubble factors',
    new_drill: 'Create new Drill',
    see_performance: 'See your performance',
    see_file_detail: 'See file detail',
    rearrarnge_items: 'Rearrange items',
    drill_drag_drop_control: 'Rearrange drills',
    drag_drop_disable_enable_sort: `Enable Drag and Drop by <span class='mdi mdi-drag-vertical text-normal'></span> activating this column`,
    drill_drag_drop_change_order: 'Drag and Drop to rearrange',
    drill_type: `
    <b>My Drills</b>: Your custom drills <br>
    <b>GTO Wizard</b>:  Pre-made training drills
    `,
    drill_format: 'Filter by game format',
    drill_tags: `Use tags to organize your drills`,
    drill_tags_arrow: `Show all tags`,
    blockers_cell_explanation: `
    If your opponent holds <b>{card}</b> your <b>{action}</b> frequency will <br>  <b>{icon} {decrease_increase}</b> by <b>{percent_num}%</b>
    `,
    blockers_cell_explanation_for_zero: `
    If your opponent holds <b>{card}</b> your <b>{action}</b> <br>  <b>frequency will not change</b>
    `,
    // blockers: '--blockers--',
    remove_all_tags: 'Rremove all tags',
    assign_tags: 'Edit tags',
    always_reset_history: `
    <b>Enable history reset</b> <br>
    By enabling the reset history feature, preflop actions will be reset whenever a new solution is selected.
    If reset history is disabled, your current preflop actions will be preserved and carried over to the new solution.
    `,
    keep_history: `
    <b>Disable history reset</b> <br>
    By enabling the reset history feature, preflop actions will be reset whenever a new solution is selected.
    If reset history is disabled, your current preflop actions will be preserved and carried over to the new solution.
    `,
    mark: 'Mark',
    unmark: 'Unmark',
    show_starred_only: 'Show starred only',
    // show_all: 'Show all',
    show_preview: `
    <b>Show preview</b> <br>
    Display more information about the solution, including available spots, accuracy, rake, complexity, ante, and stack sizes.
    `,
    hide_preview: `
    <b>Hide preview</b> <br>
    Display more information about the solution, including available spots, accuracy, rake, complexity, ante, and stack sizes.`,
    can_be_dragged: `Drag and drop to reposition your selector. <br> You can click on the <i class="mdi mdi-pin"></i> to pin its position.`,
    can_be_dragged_simple: `Drag and drop to reposition.`,
    focus_window: 'Focus window',
    change_solution: 'Change solution',

    pinn: 'Pin',
    unpinn: 'Unpin',

    gmf_pinn: `<b>Pin</b> <br>
    If you click outside of the selector (while it's pinned),
     it will still stay open. Otherwise, it will close once you select any solution or click away from the window.`,
    gmf_unpinn: `<b>Unpin</b> <br>
     If you click outside of the selector (while it's pinned),
      it will still stay open. Otherwise, it will close once you select any solution or click away from the window.`,

    gmf_pinn_simple: `<b>Pin</b> <br>
      Will not be closed by outside click.`,
    gmf_unpinn_simple: `<b>Unpin</b> <br>
      Will be closed by outside click.`,

    open_in_separate_window: 'Open in separate window',

    gmf_ante: `
    <b>4max</b>: <b>0.75bb ante</b> <br> Solutions are suitable for CoinPoker's cash tables with big ante. <br>
    <b>7max</b>: <b>0.1bb ante</b>  <br> Solutions are based on the CoinPoker format.
    `,

    gmf_ante_straddle: `
    <b>6max</b>: <b>0.1bb ante</b> <br> Suitable for GG VIP games and live games with a small ante. <br>
    <b>8max</b>: <b>0.5bb ante</b> <br> Suitable for playing on WPT Global, online apps, and live with bigger ante.
    `,
    // gmf_3bet__size: `
    // <b>GTO</b>: Using preferred GTO 3bet sizes. <br>
    // <b>Smaller</b>: Using a smaller 3bet size (adjusted to
    // population).
    // `,
    gmf_solutions: 'Select which game format you would like to study.',
    gmf_players: 'Select how many players are sitting at the table.',
    gmf_stacks: 'Select which stack depth you would like to study.',

    gmf_solution_completeness: `
    <b>Preflop only</b>: Solutions are available only for preflop. <br>
    <b>Postflop</b>: Solutions are available for preflop, flop, turn and river.
    `,

    gmf_spins_biggest_stacks: `
    Choose the stack depth you want to analyze. <br>
    <b>The format is</b>: BTN Stack - SB Stack - BB Stack. <br>
    You can view the data in either a grid or table format using the icon on the right side.`,

    gmf_variant_mtt_chipev: `
    In MTT, GTO Solutions limps are represented only in solutions 25bb and below. <br>
    <b>No limps</b>: Solutions with no limps at all. <br>
    <b>With limps</b>: Solutions including limping.
    `,
    gmf_variant_limps: `
    <b>No limps</b>: Solutions with no limps at all. <br>
    <b>With limps</b>: Solutions including limping.
    `,
    gmf_variant_cash_ante_4max: `
    <b>No limps</b>: Solutions contain no limp on Cut-off and Button. <br>
    <b>With limps</b>: Solutions contain both raises and limps on Cut-off and Button.
    `,

    gmf_cash_drop: `Cash Drops are a rakeback feature in GG Poker where 10bb or 20bb are randomly added to the pot preflop.`,
    // gmf_type_spins: `
    // <b>General</b> are solutions with medium amount of sizes. Suitable for looking up how to play versus various betsizes. <br>
    // <b>Simple</b> are solutions with minimum sizes. <br>
    // <b>Complex</b> are solutions with lot of postflop sizes. Suitable for exploring all possible GTO lines and looking up uncommon lines. <br>
    // <b>Research</b> are solutions with multiple sizes, used for discovering GTO preferred sizings. These solutions are preflop only. <br>
    // <b>Basic</b> are older GTO Wizard's solutions. We recommend using newer solutions: General or Simple.
    // `,
    gmf_type_rest: `
    <b>Simplified</b> Solutions with minimal bet sizes. The hero is assigned one or two sizes, while the villain is given a range of sizes. These solutions are perfect for practicing a straightforward and easily applicable strategy. <br>
    <b>Simple</b> Solutions with fewer bet sizes and reduced complexity compared to General or Complex. <br>
    <b>General</b> Solutions with a moderate range of bet sizes, ideal for studying and practicing against. <br>
    <b>Complex</b> Solutions featuring numerous bet sizes, designed to uncover patterns and trends in bet sizing. <br>
    <b>Research</b> Solutions incorporating multiple preflop bet sizes, utilized for exploring optimal preflop sizing strategies. <br>
    <b>Advanced</b> Solutions with more complex preflop strategies including limps, without too much postflop complexity. <br>
    <b>Basic</b> These were our very first solutions. They were groundbreaking at the time, but they no longer align with our current standards and are now considered obsolete.
    `,
    gmf_types: {
      simplified: 'Simplified',
      simplified_text:
        'Solutions with minimal bet sizes. The hero is assigned one or two sizes, while the villain is given a range of sizes. These solutions are perfect for practicing a straightforward and easily applicable strategy.',
      simple: 'Simple',
      simple_text:
        'Solutions with fewer bet sizes and reduced complexity compared to General or Complex.',
      general: 'General',
      general_text:
        'Solutions with a moderate range of bet sizes, ideal for studying and practicing against.',
      complex: 'Complex',
      complex_text:
        'Solutions featuring numerous bet sizes, designed to uncover patterns and trends in bet sizing.',
      research: 'Research',
      research_text:
        'Solutions incorporating multiple preflop bet sizes, utilized for exploring optimal preflop sizing strategies.',
      advanced: 'Advanced',
      advanced_text:
        'Solutions with more complex preflop strategies including limps, without too much postflop complexity.',
      basic: 'Basic',
      basic_text:
        'These were our very first solutions. They were groundbreaking at the time, but they no longer align with our current standards and are now considered obsolete.',
    },
    // gmf_type_table_cash: `
    // <b>General</b> are solutions with medium amount of sizes. Suitable for looking up how to play versus various betsizes. <br>
    // <b>Simple</b> are solutions with only 3bet or fold vs. open, no 4bet allin, and no limping BvB. Less postflop sizes.
    // `,
    // gmf_type_hu: `
    // <b>Simple</b> are solutions with no limps and only 1 preflop size everywhere. <br>
    // <b>Advanced</b> are solutions with limping and more 3bet, and 4bet sizes preflop.
    // `,
    // gmf_rake: `Select your preferred rake structure. <b>NL500</b> and <b>NL50</b> are based on the PokerStars structure.
    //  <b>GG Rake</b> is based on <b>GG Poker</b>, which also rakes preflop.`,
    gmf_rake_hu: `
    NL25 = 2BB cap, 5% rake <br>
    NL100 = 1BB cap, 5% rake <br>
    NL200 = 0.625BB cap, 5% rake <br>
    NL500 = 0.3BB cap, 5% rake <br>
    cEV = No rake.
    `,
    gmf_rake_6max_preflop_only: `
    cEV = No rake <br>
    NL10 = 15BB cap, 5% rake <br>
    NL25 = 8BB cap, 5% rake <br>
    NL50 = 6BB cap, 5% rake <br>
    NL100 = 3BB cap, 5% rake <br>
    NL200 = 1.5BB cap, 5% rake <br>
    NL500 = 0.6BB cap, 5% rake <br>
    NL1k = 0.3BB cap, 5% rake <br>
    NL2k = 0.15BB cap, 5% rake <br>
    NL5k = 0.06BB cap, 5% rake <br>
    NL10k = 0.03BB cap, 5% rake <br>
    GG R&C = 3BB cap, 5% rake
    `,
    gmf_rake_6max_all_spots: `
    NL50 = 4BB cap, 5% rake <br>
    NL500 = 0.6BB cap, 5% rake <br>
    NL50 GG = 8BB cap, 5% rake <br>
    NL1k GG = 1BB cap, 5% rake
    `,
    gmf_rake_9max: `
    NL50 = 4BB cap, 5% rake <br>
    LIVE 10% = 2BB cap, 10% rake
    `,
    gmf_rake_8max: `
    cEV = no rake <br>
    Live 10% = 10%, 2bb cap.
    `,
    gmf_rake_8max_straddle: `
    cEV = no rake <br>
    NL25 = 4%, 6BB CAP <br>
    NL100 = 4%, 4BB CAP <br>
    NL400 = 4%, 2BB CAP
    `,
    gmf_rake_8max_ante_straddle: `
    cEV = no rake <br>
    NL25 = 4%, 6BB CAP <br>
    NL100 = 4%, 4BB CAP <br>
    NL400 = 4%, 2BB CAP`,
    gmf_rake_4max: `
    cEV = no rake <br>
    NL25 = 5%, 4BB CAP <br>
    NL50 = 5%, 2.5BB CAP <br>
    NL100 = 5%, 1.75BB CAP <br>
    NL200 = 5%, 1.125BB CAP <br>
    NL500 = 5%, 0.6BB CAP
    `,
    gmf_rake_7max: `
    cEV = no rake <br>
    NL25 = 5%, 7BB CAP <br>
    NL50 = 5%, 4.5BB CAP <br>
    NL100 = 5%, 2.5BB CAP <br>
    NL200 = 5%, 1.55BB CAP <br>
    NL500 = 5%, 1BB CAP
    `,
    gmf_rake: 'Select your preferred rake structure.',
    gmf_cash_type: `
    <b>Classic</b> is a regular cash game without any ante or straddle. <br>
    <b>Short</b> is a format, where every player starts with 5 to 10bb starting stack and builds his stack up. <br>
    <b>Straddle</b> is a format with forced straddle for UTG. <br>
    <b>Straddle+Ante</b> is a format with forced ante and straddle. <br>
    <b>Double straddle</b> is a format with forced straddles for the first two players to act preflop. <br>
    <b>Mississippi straddle</b> is a format with a forced straddle from the button.
    `,
    gmf_cash_stacks: `Select which solution you want to study.`,
    gmf_shortstack_type: `
    <b>All-in or Fold</b> with only 8 big blinds, you can choose between moving All-In or folding. This is a GGPoker poker variant that keeps things fast and simple. <br>
    <b>Winamax Short-Track</b> At Short Track tables, every player sits down with a buy-in of 5 big blinds and builds his stack up. <br>
    <b>ACR - No Rathole</b> Every player sits down with 10 big blinds buy-in. If you leave a winner and want to return to the No Rathole tables, you must come back with the same amount you left with (that amount locked in for 7 days).
    `,

    gmf_cash_opening_size: `
    Select from multiple different opening sizes for each position.
    `,

    gmf_cash__3bet_size: `
    <div>
      <b>GTO</b>: Game theory optimal 3bet sizes. Solvers prefer these sizes when given the option between many different sizes. <br>
      <b>Smaller</b>: Smaller 3bet sizes compared to GTO.
    </div>
    `,
    gmf_simplified_position: `
    These solutions are simplified by position. Hero has a simple, easy to learn strategy,
    while villain can play multiple sizes.`,
    tip_simplified_cash: `Tip - Select the simplified player (Hero)
    as shown in the right column`,
    gmf_opening_type: `
    <div>
    Select from multiple different possible opening sizes for Small blind. <br>
    </div>
    <div class='mt-2'>
    This functionality is available only for symmetric stack sizes. <br>
    If you see only option "GTO", please select the closest symmetric stack sizes.
    </div>
    <div class='text-italic mt-2'>
    Example: <br>
    You can study multiple opening sizes in 16-16-16 situations, however, not in 16-16-14 situations. So to study alternative SB sizes, switch to the 14-14-14 solution representing the effective stack between SB and BB. <br>
    </div>
    `,
    // gmf_3bet__size: `
    // <div>
    //   <b>GTO</b>: Game theory optimal 3bet sizes. Solvers prefer these sizes when given the option between many different sizes. <br>
    //   <b>Smaller</b>: Smaller 3bet sizes compared to GTO.
    // </div>
    // `,

    gmf_type_opening_size: `
    <b>General</b> are versatile solutions, using GTO-preferred preflop sizes. <br>
    <b>General 2.5x</b> are versatile solutions, using a fixed opening size to 2.5x. <br>
    <b>Simple</b> are solutions with only 3bet or fold vs. open, no 4bet allin, and no limping BvB. Less postflop sizes.
    <b>Simple 2.5x</b> are solutions with only 3bet or fold vs. open, no 4bet allin, and no limping BvB. Using a fixed opening size to 2.5x.
    `,
    gmf_format_mtt: `
    <b>ICM</b>: Solutions that account for pay jumps. <br>
    <b>ChipEV</b>: Solutions that don't account for pay jumps. <br>
    <b>Heads-up</b>: Solutions for the last two players in the tournament (including ante).
    `,
    gmf_tournament_type_tra01: `
    <b>Classic</b> are regular tournaments without any bounty. <br>
    <b>PKO</b> are tournaments with progressive bounties.
    <div>{linkText}</div>
    `,
    // gmf_tournament_type: `
    // <b>Classic</b> are regular tournaments without any bounty. <br>
    // <b>PKO</b> are tournaments with progressive bounties.
    // `,
    gmf_tournament_phase: `
    <b>Final table </b> are solutions suitable for studying the final table of the tournament. Solutions are solved based on a 1000 players pool.<br>
    <b>2 tables </b> are solutions suitable for studying situations where the last two tables are in the tournaments.
    Both of the last two tables are having same players on each table. Solutions are solved based on 200 players pool.
    `,
    gmf_tournament_players: 'The number of players who entered the tournament',
    // ssss: `
    // <b></b>: <br>
    // <b></b>: <br>
    // <b></b>:
    // `,
    gmf_tournament_group: 'Select which tournament group you would like to study.',
    gmf_tournament_name: 'Select which tournament event you would like to study.',
    gmf_stacks_type_spins: `
    <b>Symmetric</b>: Everyone at the table has the same stack. <br>
    <b>Asymmetric</b>: All players have different stack sizes.
    `,
    gmf_stacks_type_mtt: `
    <b>Symmetric</b>: All players have the same stack size. <br>
    <b>Near</b>: Stack sizes are close to each other (e.g., 2bb away).  <br>
    <b>Far</b>: Stack sizes are further away from each other (e.g., 7bb away from each other). <br>
    <b>Big stack</b>: One or two of the players have a much bigger stack than the rest.
    <b>Short</b>: One or two players have a very small stack compared to other players at the table.
    `,
    gmf_mtt_chipev01: `
    <b>6max</b>: <b>Postflop available</b> under 50bb (mixed stacks). <br>
    <b>8max</b>: <b>Postflop available</b> (symmetric stacks). <br>
    <b>9max</b>: Preflop only.
    `,

    switch_to_table_view: 'Switch to table view',
    switch_to_grid_view: 'Switch to grid view',

    select_random_card:
      'Randomizes unchosen cards. If no unchosen cards remain, randomize all cards.',

    study_switch_format: 'Switch format',
    save_filter: 'Save filter',
    open_saved_filters: 'Show saved filters',

    open_drill: 'Open drill',
    edit_name: 'Edit name',
    mtt_icm_solutions:
      'These solutions include all tournament phases from the start of the tournament all the way down to a final table. They factor in the pay jumps and mixed stacks at the table.',
    mtt_icm_pko_solutions:
      '{num} PKO ICM solutions. Includes tournament phases from start of the tournament down to final table.',
    trainer_color_themes: 'Trainer color themes',

    edit_theme: 'Edit theme',
    close_forever: 'Close forever',
    trainer_back_pattern: 'Style of the background pattern',
    table_hints_menu: 'Info',
    table_controls_menu: 'Controls',
    preferences_floating_menu: 'Additional controls',
    action_grouped_actions: 'Grouped actions',
    multitable_disabled_option: `This option is disabled in multitable mode.
    Individual table controls can be found in the top left corner on each table.`,

    poker_table_trainer_colors: 'Trainer active table colors',
    tables_indicator: 'Marks table with active focus',
    poker_table_trainer_colors_active: 'Trainer active table colors',
    // poker_table_trainer_hand_highlight: 'Trainer strategy table highlighted hand color',
    // trainer_action_btn_default_background: 'Background color of action buttons in trainer after action is taken',
    trainer_poker_player_colors: 'Trainer player colors',
    trainer_themes: 'Choose predefined trainer theme or make your own by modifing current colors',

    grouping_actions: 'Change actions grouping',
    board_subset: `Each subset contain different amount of strategically different flops.
    Useful for quick overview of varying flops.`,

    board_cards: `Practice a specific flop, turn or river spot`,
    // suits: `Rainbow means no flush draws are possible, Flushdraw flops have two of the same suit, monotone has 3 of the same suit`,
    board_suits: `
              <b class="text-nowrap">Rainbow</b>: Means no flush draws are possible. <br>
              <b class="text-nowrap">Flushdraw</b>: Has two of the same suit. <br>
              <b class="text-nowrap">Monotone</b>: Has 3 of the same suit.`,
    // board_paired: `Paired boards have two cards of the same rank, tripled boards of 3 cards of the same rank`,
    board_paired: `
              <b class="text-nowrap">Not paired</b>: Board does not have two cards of the same rank. <br>
              <b class="text-nowrap">Paired</b>: Board has two cards of the same rank. <br>
              <b class="text-nowrap">Tripled</b>: Board has 3 cards of the same rank.`,
    // board_connectedness: `Connected means a straight is possible. Disconnected means a straight is not possible,
    board_connectedness: `
             <b class="text-nowrap">Connected</b>: It is possible to have straight. <br>
             <b class="text-nowrap">OESD possible</b>: It is possible to have OESD. <br>
             <b class="text-nowrap">Disconnected</b>: It is not possible to have OESD or straight.`,
    board_high_card: `Select the highest card(s) on the flop`,
    board_mid_card: `Select the second highest card(s) on the flop`,
    board_low_card: `Select the lowest card(s) on the flop`,
    // board_suit: `Rainbow will choose suits that are not on the board if possible. Backdoor adds a suit that is already on the board. Flush completes any flush available, otherwise it selects a suit that's already on the board.`,
    board_suit: `
              <b class="text-nowrap">Rainbow</b>: Will choose suits that are not on the board if possible. <br>
              <b class="text-nowrap">Backdoor</b>: Adds a suit that is already on the board. <br>
              <b class="text-nowrap">Flush</b>: Completes any flush available, otherwise it selects a suit that's already on the board. <br>
              `,
    board_pairing: `Chooses a card of the same rank that's already on the board`,
    // board_card: `High = Jack-Ace. Middle = 7-T. Low = 2-6.`,
    board_card: `
            <b class="text-nowrap">High</b>: Jack-Ace. <br>
            <b class="text-nowrap">Middle</b>: 7-T. <br>
            <b class="text-nowrap">Low</b>: 2-6.
            `,

    solutions: `Select the type of game you want to practice`,
    format: `Select the format. Formats with locks require a separate subscription for full access`,
    rake: `NL500 is raked at 5% with a 0.6bb cap, NL50 is raked at 5% with a 4bb cap`,
    depth: `The maximum effective stack depth in big blinds`,
    stacks: `The maximum effective stack depth in big blinds`,
    variant: `With or without limping strategies preflop`,

    // tables: 'Play single or up to 4 tables at once with any setting',
    // start_spot: `Where the hand begins. Preflop will start the hand after the preflop actions you define below. Selecting Flop starts the hand on the flop. Custom can be used to start the hand anywhere else.`,
    start_spot: `
    <b class="text-nowrap">Preflop</b>: Hand will start after defined preflop actions. <br>
    <b class="text-nowrap">Flop</b>: Hand will start after defined flop actions. <br>
    <b class="text-nowrap">Custom</b>: Hand will start anywhere you choose. `,

    start_spot_cssol: `
    <b class="text-nowrap">From start</b>: Hand will start on initial street. (Preflop / Flop)<br>
    <b class="text-nowrap">Custom</b>: Hand will start anywhere you choose. `,

    // preflop_action: `Any randomizes the betting sequence preflop. From start plays like a real game. RFI means raise first in, indicating the action folds to you. Vs Open starts the hand facing an opening raise. Vs 3bet/4bet/5bet starts the hand facing a raise as the previous raiser, e.g. facing 4bet as the 3bettor. Vs Limp stars the hand facing a limp. Vs Iso starts the hand facing a raise after you have limped`,
    preflop_action: `
    <b class="text-nowrap">Any</b>: Randomizes the betting sequence on preflop. <br>
    <b class="text-nowrap">RFI</b>: Means raise first in - indicating the action folds to you. <br>
    <b class="text-nowrap">Vs. Open</b>: Hand will start facing an opening raise. <br>
    <b class="text-nowrap">Vs. 3bet/4bet/5bet</b>: Hand will facing a raise as the previous raiser, e.g. facing 4bet as the 3bettor. <br>
    <b class="text-nowrap">Vs. Limp</b>: Hand will start facing a limp. <br>
    <b class="text-nowrap">Vs. Raise-Call</b>: Someone has opened, and another player has called. Action has folded to you with the option to squeeze. <br>
    <b class="text-nowrap">Vs. Squeeze</b>: You've either opened or called an open, and a third player has now raised. <br>
    <b class="text-nowrap">Vs. Iso</b>: Hand will start facing a raise after you have limped. <br>
    <b class="text-nowrap">From start</b>: Simulates real game scenario.
    `,
    // flop_action: `This defines the preflop betting sequence. Any is random. SRP means one raise occurred and was called. 3bet means the initial raiser called a raise. 4bet means the 3bettor called a raise. Limp means the blinds were called and no raises took place. Iso means a limper called a raise.`,
    flop_action: `
    <b class="text-nowrap">Any</b>: Randomizes the betting sequence on flop. <br>
    <b class="text-nowrap">SRP</b>: Means one raise occurred and was called. <br>
    <b class="text-nowrap">3bet</b>: Means the initial raiser called a raise. <br>
    <b class="text-nowrap">4bet</b>: Means the 3bettor called a raise. <br>
    <b class="text-nowrap">Limp</b>: Means the blinds were called and no raises took place. <br>
    <b class="text-nowrap">Iso</b>: Means a limper called a raise.
    `,
    hero: `Define the positions you would like to play. You can choose multiple positions.`,
    gto_opponent: `Select which positions your opponent will play. You can choose multiple positions.`,
    relative_hero_position: `IP means hero is in position. OOP means hero is out of position, acting first postflop.`,
    alternate_positions: `Alternates the relative position`,

    color_themes: `Select from premade themes. Import and export allows you share your settings with others!`,
    action_colors: 'Define color for player actions',
    clr_range: 'Changes the color of the range weights view',
    color_player: 'Changes the color of lines in equity distribution graph in the Ranges tab',
    suits_colors: 'Change the color of each suit',
    card_theme: 'Style of board cards and hero hole cards in the Trainer',
    card_back_color: `Color of villain's hidden cards in the Trainer`,
    card_back_theme: `Style of villain's hidden cards in the Trainer`,
    text_shadow_action_btn: 'Changes the text shadow inside action buttons',
    range_table_cell:
      'These settings control the display of text and backgrounds in the range matrix',
    range_text: 'Color of text in the range matrix. ',
    range_active: `Background color of active hands in range that aren't full frequency`,
    range_empty: 'Background color of folded hands that are not in your range',
    show_total_hand_frequency_tooltip:
      'Show frequency of actions when you click a hand in the strategy matrix',
    strategy_combo_with_value: 'Show numeric data such as EV/EQ/EQR in the range matrix',
    text_shadow: 'Outline of text in the range matrix',
    hand_table_cell:
      'These settings control the display of text and backgrounds in the hand matrix (bottom right) of the solution browser',
    combo_text: 'Color of text in the hand matrix',
    combo_range_active: `Background color of active hands in range that aren't full frequency`,
    combo_range_empty: 'Background color of folded hands that are not in your range',
    show_bets_in: 'Show bet sizes as big blinds or a percentage of the pot',
    show_ev_in: `Estimated value units.`,
    show_ev_icm_in: `Estimated value units in tournaments`,
    range_eq_buckets_style_title: 'Behavior of hand category comparisons in the ranges tab',

    expand: 'Expand',
    collapse: 'Collapse',
    trainer_reset_session_stats: 'Reset session stats',
    trainer_reset_session_stats_during_session: 'Disabled in Session mode',
    edit_drill_name: 'Edit drill name',
    edit_solution_name: 'Edit solution name',
    expand_info: 'Open info in new window',
    varying_stacks: `
              <div style="width:220px">
              <b class="text-nowrap">Off</b>: All players have the same effective stack depth. <br>
              <b class="text-nowrap">On</b>: One player can have a smaller stack than the others.
              </div>
              `,
    what_is_varying_stacks_solutions:
      'Mixed stacks solutions are solutions where all players have different stack sizes.',
    save_preset: 'Save drill',
    import_drill: 'Paste drill',
    edit_drill: 'Edit drill',
    delete_drill: 'Delete drill',
    export_drill: 'Export drill',
    drill_copied_to_clipboard: 'Drill has been copied to clipboard.',
    setting_copied_to_clipboard: 'Setting has been copied to clipboard.',
    show_all: 'Show all',
    hide_all: 'Hide all',
    show: 'Show',
    hide: 'Hide',
    hide_sidebar: 'Hide sidebar',
    show_sidebar: 'Show sidebar',

    trainer_stats_hands: `Number of hands you’ve played`,
    trainer_stats_moves: `Number of actions you've taken`,
    best_moves: `Defined as taking the highest frequency action when RNG is not active. If RNG is enabled (yellow dice) then Best moves are defined as choosing the correct frequency according to your dice roll.`,
    correct_moves: `Actions that GTO uses at least 3.5% of the time, that are not best moves`,
    inaccuracy_moves: `Actions that GTO uses less than 3.5% of the time`,
    wrong_moves: `Actions that are never used, but don't lose significant EV`,
    blunder_moves: `Actions that are never used and lose significant EV`,

    total_ev_loss: `Cumulative losses in big blinds, compared to playing GTO`,
    average_ev_loss: `Average loss in big blinds per hand, compared to playing GTO`,
    // average_ev_loss: `Average loss in big blinds per move, compared to playing GTO`,
    total_ev_loss_as_pot: 'Average loss as a percentage of the pot, compared to playing GTO',
    average_ev_loss_as_pot: 'Average loss in percentage of pot compared to playing GTO',
    average_ev_mistake: `Average EV loss per 100 hands`,
    average_mistake_ev_loss:
      'Average loss in big blinds per mistaken action, compared to playing GTO',
    average_mistake_ev_loss_as_pot:
      'Average loss as a percentage of the pot per mistaken action, compared to playing GTO',
    // total_ev_loss__sum: 'Cumulative losses in big blinds compared to playing GTO',
    // average_ev_loss__avg: 'Average loss in big blinds per move',
    // average_mistake_ev_loss__avg: 'Average loss in big blinds per mistake made',
    // total_ev_loss_as_pot__avg: 'Average loss in percentage of pot compared to playing GTO',
    // total_ev_loss_as_pot__sum: 'Cumulative losses in percentage of pot compared to playing GTO',
    // average_mistake_ev_loss_as_pot__avg: 'Average loss in percentage of pot per mistake made',

    total_frequency_difference: `Indicates how much you deviate from the highest frequency actions. A higher frequency difference indicates you're taking low-frequency lines more often.`,

    trainer_session_counter: 'Session hands counter',

    clone_drill: 'Duplicate drill',
    // see_settings: 'See settings',
    // customize_settings: 'Customize settings',
    real_game: 'TODO: real game it this and that mode. <br> Here is a video or something.',

    practice_is_rng_enabled: 'Use RNG for results correctness',
    practice_aggressive_actions_as_low_rng: 'Use low RNG values for aggresive actions',

    edit_note: 'Edit note',
    // blocker_score: `Blocker score: <span class="weight_700">{blocker_score}</span>`,
    blocker_rate: `
    {icon} <b>Value Removal</b>: {num} <br>
    `,
    unblocker_rate: `
    {icon} <b>Trash Removal</b>: {num}
    `,
    blockers_premium_only: 'Blockers are only for Premium users',

    cheat_range_quiz: 'Use 50:50 help',
    range_builder_complex_disabled: 'Hard difficulty is not available for complex solutions.',
    range_builder_hands: 'See how well you play with each specific hand class.',
    // range_builder_missing_groups: 'You are still missing {groups} combo. | You are still missing {groups} combos.',
    range_builder_paint_mode: 'Painting mode',
    range_builder_lock_mode: 'Locking mode',
    // help_range_builder: 'PP:help_range_builder',
    cheat_range_builder: 'Show help',
    range_builder_show_around: 'Show me around',
    what_is_NA: 'We cant show a solution for this spot because you took a non-existing GTO line.',

    // show_total_hand_frequency_tooltip: 'Shows total frequency for a specific hand',
    show_numbers_in_table_tooltip: 'Hide or show 0.09',

    show_loading_tips: 'Activate or disable tips while GTO Wizard is loading',
    show_legacy_solutions:
      'Display retired solutions, such as Complex and Basic solutions for cash games.',
    show_solutions_dialog: 'Choose your solution each time you open the Solutions Browser.',

    persist_actions_grouping:
      'By default actions are automatically reset to "All". Select this option to remember your action grouping settings.',

    keep_filters_between_spots: 'Filters will be kept between spots in Study mode',

    how_many_flops: 'How many flops are represented in your current filter.',
    reports: 'View custom aggregated flop reports here. Turn reports will be available soon.',
    select_flop_first: 'Please select flop first',
    turn_hand: 'See how turn strategy changes based on a specific hand.',
    affliate_discount: `This discount is only for your first purchase.
      It applies to both monthly and annual memberships.
      Choose wisely. After the first month or the year,
      you will be charged again for the full price. <br>
      By this purchase, you are directly supporting <span class="text-nowrap"><b>{affiliate_name}</b></span>.`,
    show_combo_breakdown: 'Show combo breakdown',

    all_combos_summary: `Shows all combos in hero's range and their strategies sorted by equity.`,
    breakdown_performed: 'Shows how often each category does selected action(s).',
    breakdown_represented: 'Shows how many of selected action(s) combos each category represents.',
    breakdown_summary: `Shows each combo in the category with it's strategy. Combos are sorted by equity.`,

    change_color_eq_chart: 'Change player color in Equity chart',
    weighted_average: 'Weighted average from all Bets/Raises',
    settings: 'Settings',
    account: 'Account',
    study_spot: 'Study this spot',
    replay_hand: 'Replay hand',

    saved_solutions: 'Saved solutions',

    // show_next_hand: 'Show next hand',
    // show_previous_hand: 'Show previous hand',
    show_next_hand: 'Show next hand',
    show_previous_hand: 'Show previous hand',

    show_next_hand_key: 'Show next hand <span class="keyboardkey_key">{key}</span>',
    show_previous_hand_key: 'Show previous hand <span class="keyboardkey_key">{key}</span>',
    study_spot_short: 'Study',
    view_game_in_practice: 'Practice this spot',
    practice_spot: 'Practice this spot',
    practice_total_frequencies: 'Switch between Hand and Total frequencies',
    study_reports: 'See in Reports',
    fullscreen: 'Fullscreen',
    exit_fullscreen: 'Exit fullscreen',
    show_range: 'Show my range',
    show_ranges: 'Show ranges',
    show_solution: 'Show solution',
    show_range_short: 'Range',
    share_spot: 'Share spot',
    share: 'Share',
    link_copied_to_clipboard: 'Link to this spot has been copied to clipboard',
    hands_limit_reached: 'You have reached your monthly limit.',
    loss_streak: 'Loss streak',
    win_streak: 'Win streak',
    neutral_streak: 'Tracks your win / loss streak.',

    show_range_in: 'Show range in full height or range height',
    show_reports_range: 'Show average range',

    status_FINISHED_file: 'Analysis has been completed',
    status_UPLOADING_file: 'File is being uploaded',
    status_PROCESSING_file: 'File is being analyzed',
    status_ANALYSING_file: 'File is being analyzed',
    status_ERROR_file: 'There is an error with the file',
    status_PARTIALLY_FINISHED_file: 'Hand has been partially analyzed',
    status_IN_QUEUE_file: 'File is uploaded and is waiting in the queue to be processed',
    status_LIMIT_REACHED_file: 'You have reached Your monthly hands limit.',

    status_warning_NO_GTO_SOLUTION: 'Nonexisting GTO spot',
    status_warning_NEGATIVE_EV: 'Nonexisting GTO spot',
    status_warning_ZERO_PERCENT_ACTION: 'Zero percent action - Solution could be incomplete',
    status_warning_SPOT_NOT_SUPPORTED: 'Not supported spot',
    status_warning_STACK_NOT_SUPPORTED:
      'Results may be inaccurate (Large gap between actual depth and solved depth).',

    analyze_hand_help: `When we analyze your hand, we use sizings we initially solved and compare them with your actions.
    If you bet 3 BB and we have a solution for 2.5 BB, we will automatically take your action as 2.5 BB.
    We are planning to resolve our solutions with more sizings making them near perfect.
    You can sometimes see the N/A sign next to your actions.
    That occurs either if you took a wrong line that should never happen in GTO or if we don't have a solution for that
    specific situation (multiway pot post-flop).
    `,
    analyze_hand_size_mode: 'Switch between Large and Compact mode',

    analyze_hand_show_all_on: 'Hide all actions',
    analyze_hand_show_all_off: 'Show all actions',

    // analyze_hand_show_diff: 'Show in-game sizings (if they differentiate from presolved)',

    analyze_hand_screenshot: 'Share a picture with analysis of your hand',
    analyze_hand_show_hand_in_table: 'Show all hands',
    analyze_hand_na: 'No solution.',
    zoom_out: 'Zoom out',
    zoom_in: 'Zoom in',
    cheat_help_on: 'Turn on help',
    cheat_help_off: 'Turn off help',
    show_results_after_action: 'Show results after each action',
    shortcuts_stop_session: 'Stop session',
    shortcuts_configure_game: 'Configure a new game',
    shortcuts_replay_game: 'Replay this hand',
    shortcuts_new_hand: 'Play new hand',
    shortcuts_configure_quiz: 'Configure new quiz',
    shortcuts_replay_quiz: 'Replay quiz',
    shortcuts_shortcut: 'Shortcut',
    shortcuts_select_players: 'Random will select two random players on each new hand.',
    shortcuts_clear: 'Reset history',
    previous_spot: 'Previous spot',
    next_spot: 'Next spot',
    lock_ecrypted: 'Payments are secured using SSL and client-side encryption.',
    hover_over: 'Hover over to learn more.',

    name_of_file: 'Name of your file',
    num_of_hands_in_file: 'Number of hands in your file',
    num_of_success_analyzed_hands: 'Successfully analyzed hands',
    num_of_not_analyzed_hands: 'Hands to analyze',
    num_of_partialy_analyzed_hands: `Number of hands we couldn't fully analyze`,
    num_of_error_hands: 'Number of error hands',

    not_suitable_stack: 'Not suitable stack depth',
    multiway_postflop: 'Multiway postflop spot',
    nonexisting_GTO: 'Nonexisting GTO spot',

    num_of_duplicate_hands: 'Number of duplicated hands',
    num_of_unsupported_hands: `Number of hands we couldn't analyze at all`,
    // diff_format_6max: 'Different format (not 6max)',
    // not_suitable_stack_depth: 'Not suitable stack depth (0-50BB or 150BB+)',

    diff_format_6max_tra01: 'Not supported amount of players',
    not_suitable_stack_depth_tra01: 'Not suitable stack depth',

    copy_color_theme: 'Copy color theme.',
    color_theme_in_clipboard: 'Color theme has been copied to clipboard.',

    filter_call: {
      title: 'Let us know if you want to see other filters!',
      subtitle: 'Currently, we are working on:',
      filtering_preflop_postflop: 'Filtering by preflop/postflop',
      filtering_spec_lines: 'Filtering by specific lines',
    },

    pagination: {
      first_page: 'First page',
      previous_page: 'Previous page',
      next_page: 'Next page',
    },

    bet_size_not_used: 'This bet size is not being used in this solution',
    bet_size_not_available: 'Available bet sizes will be shown once the Report is calculated.',
    bet_size_not_used_in_flop: 'This betsize is not being used on this flop',

    reports_loading:
      'You can leave the reports tab at any time and return<br/>later while the reports are being generated.',
    situations_omitted:
      'Some situations may be omitted because<br/>they are duplicates of other situations.<br/><br/>Duplicate hands: {duplicates}',

    show_with_video_only: 'Show with video only',

    events_accuracy_warning: `This solution was solved using a regular ante instead of a big blind ante,<br/>
      which may slightly affect accuracy in short-handed situations.<br/>
      All other solutions — and future additions — use the correct setting.`,
  },
  gameformat: {
    model: 'Model',
    tournament_type: 'Tournament type',
    tournament_group: 'Tournament group',
    tournament_name: 'Tournament name',
    tournament_players: 'Tournament players',
    tournament_pool: 'Tournament pool',
    tournament_phase: 'Tournament phase',
    players_left: 'Players left',
    // stacks_type: 'Stacks type',
    stacks_type: 'Stack type',
    avg_stack: 'Avg. stack',

    spins_type: 'Type',
    husng_type: 'Type',
    husng_or_spins_type: 'Type',
    type_opening_size: 'Type',
    type: 'Type',
    cash_type: 'Type',
    cash_drop: 'Cash drop',
    cash_drop_xxx: 'Cash drop {cash_drop}',
    bet_sizes: 'Bet sizes',

    opening_type: 'BvB opening size',

    reports: 'Reports',
    format: 'Format',
    variant: 'Variant',
    rake: 'Rake',
    opening_size: 'Opening size',
    simplified_position: 'Hero',
    opening_size_abbr: 'Open',
    _3bet_size: '3bet size',
    _3bet_size_abbr: '3bet',
    simplified_position_abbr: 'Hero',
    spots: 'Spots',
    stack: 'Stack',
    stacks: 'Stacks',
    stacks_btn_sb_bb: 'Stacks (BTN-SB-BB)',
    spins_biggest_stack: 'Biggest stack',
    sizing: 'Sizings',
    note: 'Note',
    ante: 'Ante',
    accuracy: 'Accuracy',
    select_diff_format: 'Select a different format',
    preflop_only: 'Preflop only',
    // all_spots: 'All spots',
    all_spots: 'Postflop included',
    all: 'All',
    players: 'Players',
    solution_completeness: 'Available spots',
    spots_preflop_postflop: 'Available spots',
    shortstack_type: 'Game',

    top: 'top',
    '9handed': '9handed',
    '8handed': '8handed',
    '7handed': '7handed',
    '6handed': '6handed',
    '5handed': '5handed',
    '4handed': '4handed',
    '3handed': '3handed',
    '2handed': '2handed',
  },
  gametypes: {
    preflop_only: 'Preflop',
    all_spots: 'All',
    // gametype_as_MTTGeneral: 'Preflop + Postflop',
    // gametype_as_MTTGeneral_8m: 'Preflop only',
    ip: 'IP',
    oop: 'OOP',
    husng: 'Husng',
    '6max': '6max',
    '6max_hu': '6max + Heads-up',
    '9max_6max_hu': '9max + 6max + Heads-up',
    '2max': '2max',
    '3max': '3max',
    '4max': '4max',
    '5max': '5max',
    '8max': '8max',
    '7max': '7max',
    '9max': '9max',

    GTO: 'GTO',

    '4bb': '4bb',
    '5bb': '5bb',
    '6bb': '6bb',
    '7bb': '7bb',
    '8bb': '8bb',
    '10bb': '10bb',
    '12bb': '12bb',
    '14bb': '14bb',
    '20bb': '20bb',

    no_cash_drop: 'None',

    '2x': '2x',
    '2.25x': '2.25x',
    '3x': '3x',
    '4x': '4x',
    '5x': '5x',
    '7x': '7x',
    '6x': '6x',
    '8x': '8x',
    '10x': '10x',
    '12x': '12x',
    '14x': '14x',
    '25x': '2.5x',
    gto_mixed: 'GTO',
    gto: 'GTO',
    smaller: 'Smaller',

    default: 'GTO',
    R2: '2x',
    R2ONLY: '2x No Limp',
    R2_25: '2.25x',
    R2_5: '2.5x',
    // R2_5ONLY: '2.5x Only',
    R2_5ONLY: '2.5x No limp',
    R2_75: '2.75x',
    R3: '3x',
    '225x': '2.25x',

    'R2.25': '2.25x',
    'R2.5': '2.5x',
    'R2.5ONLY': '2.5x No limp',
    'R2.75': '2.75x',

    cash_game_8max: 'Cash game 8max',
    cash_game_8max_6max: 'Cash game 6max + 8max',
    '8max_6max': '6max + 8max',

    '8max_straddle': 'Straddle+Ante',
    '8max_straddle_full': '8max Straddle+Ante',
    '6max_straddle': 'Straddle+Ante',
    '6max_straddle_full': '6max Straddle+Ante',
    '8max_straddle_abbr': '8max Straddle',
    '6max_straddle_abbr': '6max Straddle',

    '8max_max': '8max',
    '8max_straddle_max': '8max',
    '6max_straddle_max': '6max',

    no_limps: 'No limps',
    with_limps: 'With limps',

    '1000_players': '1000 players',
    '200_players': '200 players',

    FT_players: 'Final table',
    T2_players: '2 tables',
    T3_players: '3 tables',
    PCT5_players: '5% left',
    PCT10_players: ' 10% left',
    PCT25_players: '25% left',
    PCT37_players: '37% left',
    PCT50_players: '50% left',
    PCT70_players: '70% left',
    PCT75_players: '75% left',
    PCT90_players: '90% left',
    START_players: '100% left',

    BUBBLEEARLY_players: '18% left',
    BUBBLEMID_players: '16% left',
    BUBBLELATE_players: 'Near bubble',
    // BUBBLE180PT_players:'Early bubble 180PT',
    // BUBBLE160PT_players:'Mid bubble 160PT',
    // BUBBLE152PT_players:'Near bubble 152PT',

    // BUBBLEMID: 'Near bubble',
    // BUBBLELATE: 'Late bubble',
    // BUBBLEEARLY: 'Early bubble',

    icm: 'ICM',
    icm_pko: 'ICM PKO',
    hu: 'Heads-up',
    chipev: 'ChipEV',
    regular: 'Classic',
    with_ante: 'With ante',
    ante_straddle: 'Straddle+Ante',
    ante: 'Ante',
    shortstack: 'Short',
    straddle: 'Straddle',
    icm_events: 'Events',
    double_straddle: 'DoubleStraddle',
    mississippi_straddle: 'MississippiStraddle',

    gg_ai_or_fold: 'All-in or Fold',
    winamax_short: 'Winamax - Short Track',
    acr_short: 'ACR - No Rathole',

    pko: 'PKO',
    // pko: 'PKO  <span class="text-small clr-grey">(bounty)</span>',
    FT: 'Final table',
    T2: '2 tables',
    T3: '3 tables',
    PCT25: 'Last 25%',
    PCT37: 'Last 37% ',
    PCT50: 'Last 50%',
    'topX%': '--topX%--',
    bubble: 'Bubble',
    SYMMETRIC: 'Symmetric',
    ASYMMETRIC: 'Asymmetric',
    ASYMMETRIC_SHORT: 'Short',
    ASYMMETRIC_NEAR: 'Near',
    ASYMMETRIC_BIGSTACK: 'Big stack',
    ASYMMETRIC_FAR: 'Far',

    LIVE10: ' LIVE 10% ',

    no_rake: 'No rake',
    'no rake': 'No rake',

    NL10000: 'NL10k',
    NL5000: 'NL5k',
    NL2000: 'NL2k',
    NL1000: 'NL1k',
    NL500: 'NL500',
    NL400: 'NL400',
    NL200: 'NL200',
    NL100: 'NL100',
    NL50: 'NL50',
    NL25: 'NL25',
    NL10: 'NL10',
    cEV: 'cEV',
    GGrc: 'GG R&C',
    'GG NL50': 'NL50 GG',
    'GG NL500': 'NL1k GG',

    basic: 'Basic',
    test: 'Research',
    general: 'General',
    general_2_5x: 'General 2.5x',
    simple_2_5x: 'Simple 2.5x',
    simplified_25x: 'Simplified 2.5x',
    complex: 'Complex',
    simplified: 'Simplified',
    simple: 'Simple',
    advanced: 'Advanced',
    none: '',

    general_gto: 'General',
    general_25x: 'General 2.5x',
    simple_25x: 'Simple 2.5x',
    complex_gto: 'Complex',
    simple_gto: 'Simple',
    basic_gto: 'Basic',

    CashHu500zSimple: 'NL500',
    Cash6m500zBasic: 'NL500',
    Cash6m500zSimple: 'NL500',
    Cash6m500zComplex: 'NL500',
    Cash6m500zGeneral: 'NL500',
    Cash6m500zGeneral25Open: 'NL500',
    Cash6m500zGGGeneral: 'NL1k',
    Cash6m500zSimple25Open: 'NL500',
    CashHu500zComplex: 'NL500',

    Cash6m50zSimple: 'NL50',
    Cash6m50zComplex: 'NL50',
    Cash6m50zGeneral: 'NL50',
    Cash6m50zSimplified: 'NL50',
    Cash6m50zGeneral25Open: 'NL50',
    Cash6m50zGGGeneral: 'NL50',
    Cash6m50zSimple25Open: 'NL50',

    Cash9m50zGeneral: 'NL50',

    StraddleAnteGeneral: '--',

    MTTGeneral: 'MTT',
    MTTMRonlyGeneral: 'MTT',
    MTTSimplified: 'MTT',

    SpinsComplex: 'Spin & Go',
    SpinsGeneral: 'Spin & Go',
    SpinsSimplified: 'Spin & Go',

    HuSngComplex: 'HU SnG',
    HuSngGeneral: 'HU SnG',
    HuSngSimplified: 'HU SnG',
    HuSngGeneralV2: 'HU SnG',

    fullname: {
      CashHu500zSimple: 'NL500 Simple',

      Cash6m500zBasic: 'NL500 Basic',
      Cash6m500zSimple: 'NL500 Simple',
      Cash6m500zSimplified: 'NL500 Simplified',
      Cash6m500zComplex: 'NL500 Complex',
      Cash6m500zGeneral: 'NL500 General',
      Cash6m500zGeneral25Open: 'NL500 General 2.5x',
      CashHu500zComplex: 'NL500 Complex',
      Cash6m500zSimple25Open: 'NL500 Simple 2.5x',
      Cash6m500zGGGeneral: 'GG NL1k  General',

      Cash6mVIPGGGeneralGeneral: 'Straddle+Ante',

      StraddleAnteGeneral: 'Straddle+Ante',

      Cash6m50zComplex: 'NL50 Complex',
      Cash6m50zSimple: 'NL50 Simple',
      Cash6m50zGeneral: 'NL50 General',
      Cash6m50zSimplified: 'NL50 Simplified',
      Cash6m50zGeneral25Open: 'NL50 General 2.5x',
      Cash6m50zSimple25Open: 'NL50 Simple 2.5x',
      Cash6m50zGGGeneral: 'GG NL50 General ',

      MTTGeneral: 'MTT General',
      MTTGeneralV2: 'MTT General',
      MTT6mGeneral: 'MTT General',
      MTTMRonlyGeneral: 'MTTMR General',
      MTTSimplified: 'MTT Simplified',

      HuSngComplex: 'HU SnG Complex',
      HuSngGeneral: 'HU SnG General',
      HuSngSimplified: 'HU SnG Simplified',
      HuSngGeneralV2: 'HU SnG General',

      SpinsComplex: 'Spin & Go Complex',
      SpinsGeneral: 'Spin & Go General',
      SpinsSimplified: 'Spin & Go Simplified',

      mtt_icm: 'MTT ICM',
      mtt_chipev: 'MTT Chipev',
      MTTICM3mGeneral: 'MTT ICM',
      MTTICM4mGeneral: 'MTT ICM',
      MTTICM5mGeneral: 'MTT ICM',
      MTTICM6mGeneral: 'MTT ICM',
      MTTICM7mGeneral: 'MTT ICM',
      MTTICM8mGeneral: 'MTT ICM',

      MTTComplex_ICM3m1000PTFT: 'MTT ICM',
      MTTGeneral_ICM3m1000PTFT: 'MTT ICM',
      MTTComplex_ICM4m1000PTFT: 'MTT ICM',
      MTTGeneral_ICM4m1000PTFT: 'MTT ICM',
      MTTComplex_ICM5m1000PTFT: 'MTT ICM',
      MTTGeneral_ICM5m1000PTFT: 'MTT ICM',
      MTTComplex_ICM6m1000PTFT: 'MTT ICM',
      MTTGeneral_ICM6m1000PTFT: 'MTT ICM',
      MTTComplex_ICM7m1000PTFT: 'MTT ICM',
      MTTGeneral_ICM7m1000PTFT: 'MTT ICM',
      MTTComplex_ICM8m1000PTFT: 'MTT ICM',
      MTTGeneral_ICM8m1000PTFT: 'MTT ICM',
      MTTGeneral_ICM9m1000PTFT: 'MTT ICM',
      MTTComplex_ICM9m1000PTFT: 'MTT ICM',
      MTTGeneral_ICM6m200PTT3: 'MTT ICM',
      MTTGeneral_ICM7m200PTT3: 'MTT ICM',
      MTTGeneral_ICM8m200PTT3: 'MTT ICM',
      MTTComplex_ICM6m200PTT3: 'MTT ICM',
      MTTComplex_ICM7m200PTT3: 'MTT ICM',
      MTTComplex_ICM8m200PTT3: 'MTT ICM',
      MTTGeneral_ICM9m200PTBUBBLEMID: 'MTT ICM',
      MTTComplex_ICM9m200PTBUBBLEMID: 'MTT ICM',
      MTTGeneral_ICM9m200PTBUBBLELATE: 'MTT ICM',
      MTTComplex_ICM9m200PTBUBBLELATE: 'MTT ICM',
      MTTGeneral_ICM9m200PTBUBBLEEARLY: 'MTT ICM',
      MTTComplex_ICM9m200PTBUBBLEEARLY: 'MTT ICM',
      MTTGeneral_ICM9m200PTPCT25: 'MTT ICM',
      MTTGeneral_ICM9m200PTPCT37: 'MTT ICM',
      MTTGeneral_ICM9m200PTPCT50: 'MTT ICM',

      MTTGeneral_ICM6m200PTT2: 'MTT ICM',
      MTTComplex_ICM5m200PTT2: 'MTT ICM',
      MTTComplex_ICM6m200PTT2: 'MTT ICM',
      MTTComplex_ICM7m200PTT2: 'MTT ICM',
      MTTComplex_ICM8m200PTT2: 'MTT ICM',
      MTTGeneral_ICM5m200PTT2: 'MTT ICM',
      MTTGeneral_ICM7m200PTT2: 'MTT ICM',
      MTTGeneral_ICM8m200PTT2: 'MTT ICM',
    },

    tournament_name: {
      'SCOOP-2024-EVENT115-10K': '2024, 115-H: $10K [Main Event]',
      'SCOOP-2024-EVENT120-25K': '2024, 120-H: $25K<br>[Super High Roller]',
      'SCOOP-2024-EVENT-16H-10K-HR': '2024, 16-H: $10K<br>[Super Tuesday High Roller]',
      'SCOOP-2024-EVENT-90H-5200': '2024, 90-H: $5K<br>[Super Tuesday High Roller]',
      'SCOOP-2024-EVENT-65-PKO': '2024 65-H: $10K [PKO High Roller]',
      'WSOP-2022-EVENT70-10000': '2022, $10K [Main Event]',
      'WSOP-2023-EVENT76-10000': '2023, $10k [Main Event]',
      'WSOP-2024-MAIN-EVENT81-10000': '2024, $10K [Main Event]',
      'WSOP-2023-EVENT40-250K-SUPER-HIGH-ROLLER': '2023, $250K<br>[Super High Roller]',
      'WSOP-2024-ONLINE-EVENT-33-10K-GGMILLIONS': '2024 Online $10K<br>[GGMillion$ High Roller]',
    },
    tournament_name_short: {
      'SCOOP-2024-EVENT115-10K': 'SCOOP 2024 115-H Main',
      'SCOOP-2024-EVENT120-25K': 'SCOOP 2024 120-H SHR',
      'SCOOP-2024-EVENT-16H-10K-HR': 'SCOOP 2024 16-H STHR',
      'SCOOP-2024-EVENT-90H-5200': 'SCOOP 2024 90-H STHR',
      'SCOOP-2024-EVENT-65-PKO': 'SCOOP 2024 65-H PKO HR',
      'WSOP-2022-EVENT70-10000': 'WSOP 2022 Main',
      'WSOP-2023-EVENT76-10000': 'WSOP 2023 Main',
      'WSOP-2024-MAIN-EVENT81-10000': 'WSOP 2024 Main',
      'WSOP-2023-EVENT40-250K-SUPER-HIGH-ROLLER': 'WSOP 2023 SHR',
      'WSOP-2024-ONLINE-EVENT-33-10K-GGMILLIONS': 'WSOP 2024 GG HR',
    },
    // wholeName: {
    //   Cash6m500zBasic: '6max NL500 Basic',
    //   Cash6m500zSimple: '6max NL500 Simple',
    //   Cash6m500zSimplified: '6max NL500 Simplified',
    //   Cash6m500zComplex: '6max NL500 Complex',
    //   Cash6m500zGeneral: '6max NL500 General',
    //   Cash6m500zGeneral25Open: '6max NL500 General 2.5x',
    //   Cash6m50zComplex: '6max NL50 Complex',
    //   Cash6m50zSimple: '6max NL50 Simple',
    //   Cash6m50zGeneral: '6max NL50 General',
    //   Cash6m50zSimplified: '6max NL50 Simplified',
    //   Cash6m50zGeneral25Open: '6max NL50 General 2.5x',

    //   Cash6m50zGGGeneral: '6max GG NL50 General',
    //   Cash6m500zGGGeneral: '6max GG NL1k General',
    //   Cash6m50zSimple25Open: '6max NL50 Simple 2.5x',
    //   Cash6m500zSimple25Open: '6max NL500 Simple 2.5x',
    //   CashHu500zComplex: 'Heads-up NL50 Complex',

    //   Cash6mVIPGGGeneralGeneral: '6max Straddle+Ante',

    //   StraddleAnteGeneral: '8max Straddle+Ante',

    //   CashHu500zSimple: 'Heads-up NL500 Simple',

    //   MTTGeneral: 'MTT General',
    //   MTTGeneralV2: 'MTT General',
    //   MTT6mGeneral: 'MTT General',

    //   MTTMRonlyGeneral: 'MTTMR General',
    //   MTTSimplified: 'MTT Simplified',

    //   HuSngComplex: 'HU SnG Complex',
    //   HuSngGeneral: 'HU SnG General',
    //   HuSngSimplified: 'HU SnG Simplified',
    //   HuSngGeneralV2: 'HU SnG General',

    //   SpinsComplex: 'Spin & Go Complex',
    //   SpinsGeneral: 'Spin & Go General',
    //   SpinsSimplified: 'Spin & Go Simplified',
    // },

    groups: {
      cash: 'Cash',
      spins: 'Spin & Go',
      spins_ante: 'Spin & Go + Ante',
      husng: 'Hu SnG',
      mtt: 'MTT',
      sitngo: 'Sit & Go',
      straddle_ante_cash: 'Straddle+Ante',

      any_long: 'Every game format',
      cash_long: 'Cash game',
      straddle_long: 'Straddle+Ante',
      spins_long: 'Spin & Go',
      husng_long: 'Hu SnG',
      mtt_long: 'MTT',
      straddle_ante_cash_long: 'Straddle+Ante',
      custom: 'Custom',
      elite_long: 'Elite',

      shortdeck: 'Shortdeck',
      straddle_ante_cash_6max: 'Straddle+Ante 6max',
      straddle_ante_cash_8max: 'Straddle+Ante 8max',
    },
    tiers: {
      // any: 'Every game format',
      cash_6max: 'Cash 6max',
      cash_9max: 'Cash 9max',
      headsup: 'Heads-up',
      // spins: 'Spin & Go',
      // husng: 'Hu SnG',
      // mtt: 'MTT',
      straddle_ante_cash_8max: '8max Straddle+Ante',
      straddle_ante_cash_6max: '6max Straddle+Ante',
    },
    notes: {
      note_cash_general: 'Versatile solutions, using GTO preferred preflop sizes',
      note_cash_general3betsmall:
        'Versatile solutions, using GTO preferred opening sizes and using smaller, population adjusted 3bet sizes',
      note_cash_general25x: 'Versatile solutions, every player opens preflop to 2.5x',
      note_cash_general25x3betsmall:
        'Versatile solutions, every player opens preflop to 2.5x and using smaller, population adjusted 3bet sizes',
      note_cash_complex: 'Adjusted preflop sizes, lots of postflop sizings',
      note_cash_simple:
        'Solutions with only 3bet or fold vs open, no 4bet allin and no limping BvB. Less postflop sizes',
      note_cash_simple25x:
        'Solutions where each player opens 2.5x, with only 3bet or fold vs open, no 4bet allin and no limping BvB. Less postflop sizes',
      note_cash_simple3betsmall:
        'Solutions with only 3bet or fold vs open, no 4bet allin and no limping BvB. Using smaller, population adjusted 3bet sizes. Less postflop sizes',
      note_cash_simple25x3betsmall:
        'Solutions where each player opens 2.5x, with only 3bet or fold vs open, no 4bet allin and no limping BvB. Using smaller, population adjusted 3bet sizes. Less postflop sizes',
      note_cash_basic: 'Adjusted preflop sizes, basic postflop sizings',
      note_cash_gg_general: 'Solutions for GG poker, with raked preflop pots',
      note_cash_hu_complex: 'Advanced solutions with limping and more 3bet, 4bet sizes preflop',
      note_cash_hu_simple: 'No limping, 1 preflop size everywhere',
      note_cash_straddle_ante_8m:
        'Solutions with straddle and 0.5bb ante per player. Suitable for games on apps',
      note_cash_straddle_ante_6m:
        'Solutions with straddle and 0.1bb ante per player. Suitable for live games with straddle+ante',
      note_mtt_icm: 'Solutions for MTT final tables with pay jumps considerations',
      note_mtt_icm_complex:
        'Complex solutions contain multiple sizings, we have used them for testing to see which sizings are preferred in each spot',
      note_mtt_limps: 'Limping preflop allowed',
      note_mtt_no_limps: 'No limping preflop allowed',
      note_spins_general: 'Versatile solutions, using sizes to cover most options',
      note_spins_complex:
        'Contains lot of postflop sizes, we have used them for testing to see which sizings are preferred in each spot',
    },
    special: {
      varying_stacks_on: 'On',
      varying_stacks_off: 'Off',
    },
  },
  poker_table: {
    pot: 'Pot',
    board: 'Board',
  },
  analyze: {
    dashboard: {
      total_hands: 'Total hands',
      correct_plays: 'Correct plays',
      wrong_plays: 'Wrong plays',
      ev_mistake: 'Average EV loss',
      total_hands_abbr: 'Total',
      correct_plays_abbr: 'Correct',
      wrong_plays_abbr: 'Wrong',
      ev_mistake_abbr: 'Avg. EV loss',
    },
    hand: {
      // real_in_game_size: 'Real in-game size:',
      winner: 'Winner',
      winners: 'Winners',
      showdown: 'Showdown',
      subtitle_one_line: '{numOfPlayers} players, {date}, {site}',
      solved_for: 'Solved for {depth} BB',
      solved_for_html: 'Solved for <span class="text-nowrap">{depth} BB</span>',
      action: {
        folds: '{numOfFolds} Folds',
      },
      players: 'players',
      upload_new_hh: 'Upload new hand',
      // capture: {
      //   by_gto_wizard: 'GTOWizard.com',
      // },
    },
    upload: {
      hand: {
        status_429: 'Your Hand History limit was reached.',
        status_400: 'Something went wrong.',
        status_500: 'Something went wrong.',
        status_empty: 'Click that big text field and paste text with Your HH.',
        status_over_2500_chars: 'Your Hand history has too many characters.',
        error_EMPTY: 'Your Hand history looks to be empty.',
        error_NO_HERO_CARDS: 'Hero cards are missing! Please check your Hand History.',
        error_UNKNOWN_FORMAT: 'Please use currently supported formats and sites.',
        error_PARSING_ERROR: 'Your Hand history is not complete.',
        error_NO_BUTTON: 'Your Hand history is not complete.',
        error_LIMIT_REACHED: 'You have reached Your monthly hands limit.',
        error_UNSUPPORTED_PLAYERS: 'Unsupported number of players in a hand.',
        error_UNSUPPORTED_STACK: 'Stack is out of range of supported stack sizes.',
        error_UNSUPPORTED_GAME: 'This game variant is not suported.',
        error_MULTIPLE_HEROES: `We are currently unable to analyze hands where there are more players with pocket cards (Unable to determine hero player).`,
      },
      status_waiting: 'Waiting',
      status_progress: 'Uploading',
      status_finished: 'Uploaded',
      status_error: 'Error',
      status_canceled: 'Canceled',
      status_file_over_50MB: 'exceeds size limit 50MB',
      status_not_suported_file_type: 'file not supported. Use {filetypes}',
      status_too_many_files: 'Please upload a maximum of 1500 files at once.',
      error_deleting_files: 'There was an error. Some of the files were not deleted.',
      error_deleting_hands: 'There was an error. Some of the hands were not deleted.',
      error_deleting_sessions: 'There was an error. Some of the sessions were not deleted.',
      error_uploading_files: '{num} files were not uploaded.',
      copy_failed_to_clipboard: 'Copy file names to clipboard',
      files_try_again: 'Try uploading them again',
      check_uploads_status: 'Check the status of the analysis here.',

      // error_reading_upload_entry: 'Entry is not file or directory',

      error_fetching_preffered_gametype: 'There was an error. Prefered gametype was not retrieved.',
      error_updating_preffered_gametype: 'There was an error. Prefered gametype was not set.',
      finished: {
        file: 'File is being analyzed.',
        files: 'Files are being analyzed.',
      },

      error_dragdrop: `Draging & Droping has failed.
      Please click inside the Drag & Drop field or use the green buttons bellow
       to open upload window.`,
    },
  },
  practice_dashboard: {
    title: 'Train like a Pro <br> with GTO Wizard',
  },
  practice_totals: {
    title: 'Totals',
    // title_sub: 'Overall performance',
    total_ev_loss__sum: 'Total EV loss',
    average_ev_loss__avg: 'Average EV loss',
    average_mistake_ev_loss__avg: 'Avg. mistake EV loss ',
    total_ev_loss_as_pot__avg: 'Avg. EV loss as %pot ',
    total_ev_loss_as_pot__sum: 'Total EV loss as %pot',
    average_mistake_ev_loss_as_pot__avg: 'Avg. mistake EV loss as %pot ',
  },

  table_files_upload: {
    status_UPLOADING_file: 'Uploading',
    status_PROCESSING_file: 'Analyzing',
    status_ANALYSING_file: 'Analyzing',
    status_FINISHED_file: 'Analyzed',
    status_PARTIALLY_FINISHED_file: 'Partially analyzed',
    status_LIMIT_REACHED_file: 'You have reached your upload limit.',
    status_ERROR_file: 'Error',
    status_IN_QUEUE_file: 'In queue',
  },
  table_totals: {
    site: 'site | sites',
    game_format: 'format | formats',
  },
  data_table: {
    view: 'View',
    delete_file: 'Delete',
    confirm_delete: 'Confirm delete',
    cancel_delete: 'Cancel delete',
    saved_spots_table: {
      no_files: 'No spots.',
      save_spots: 'Try saving your spots first.',
    },
    solutions_history: {
      title: 'History',
      // no_items: 'No solutions.',
      // save_solutions: 'Try saving your solutions first.',
    },
    saved_solutions: {
      title: 'Saved solutions',
      no_data: 'Try changing filter parameters.',
      no_items: 'No saved solutions.',
      no_items_sub: 'Try saving your solutions first.',
      save_solutions: 'You can save solutions from history.',
    },
    custom_solutions: {
      title: 'Custom solutions',
      no_data: 'Try changing filter parameters.',
      no_items: 'No custom solutions.',
      no_items_sub: 'Try creating your solutions first.',
    },
    custom_reports: {
      title: 'Custom reports',
      no_data: '',
      no_items: 'No custom reports.',
      no_items_sub: 'Try creating your reports first.',
    },
    saved_ranges: {
      title: 'Saved ranges',
      no_data: 'Try changing filter parameters.',
      no_items: 'No saved ranges.',
      no_items_sub: 'Try saving your ranges first.',
    },
    saved_trees: {
      title: 'Saved settings',
      title_tra01: 'Custom settings',
      no_data: 'Try changing filter parameters.',
      no_items: 'No saved settings.',
      no_items_sub: 'Try saving your settings first.',
    },
    saved_filters_table: {
      no_filters: 'No filters.',
      save_filters: 'Try saving your filters first.',
      no_data_change_filter_tra01: 'Try changing filter parameters.',
    },
    files_table: {
      no_files: 'No files.',
      make_upload: 'Try uploading your files here.',
    },
    reports_table: {
      no_data: 'No data. Try changing filter parameters.',
    },
    report_table: {
      welcome: 'Welcome to Analyzer',
      welcome_m: 'Welcome to <span class="clr-primary">Analyzer 2.0</span>',
      welcome_sub: 'Upload hands to start upgrading your game',
      no_hands: 'No hands found.',
      no_hands_sub: `
      You’ve filtered all your hands. <br>
      Remove some filters in order to analyze your game.`,

      view_performance: 'View Performance In Any Type of Spot',
      rate_play: 'Rate Your Play According to GTO',
      plug_leaks: 'Plug Your Leaks',
    },
    saved_reports_table: {
      no_reports: 'No reports found.',
      no_reports_sub: `
      You’ve filtered all your reports. <br>
      Try typing something else to the search box.`,
    },
    analyze_hands: {
      title: 'Analyzed hands',
      no_hands: 'No hands.',
      make_upload: 'Try uploading your hands first.',
      no_data_change_filter_tra01: 'Try changing filter parameters.',
    },
    practice_drills: {
      title: 'Drills',
      no_data: 'No Drills.',
      make_drill: 'Try creating a drill first.',
      no_data_change_filter_tra01: 'Try changing filter parameters.',
    },
    practice_hands: {
      title: 'Practiced hands',
      no_data: 'No hands.',
      play_trainer: 'Try playing a few hands in Trainer.',
      no_data_change_filter_tra01: 'Try changing filter parameters.',
    },
    practice_sessions: {
      title: 'Practiced sessions',
      no_data: 'No sessions.',
      play_trainer: 'Try playing a few hands in Trainer.',
      no_data_change_filter_tra01: 'Try changing filter parameters.',
    },
    selected_hand: {
      hero_only: 'Hero only',
    },
    icm_structure: {
      no_data: 'No presets.',
      no_data_sub: 'Try saving a preset first.',
      no_data_search_sub: 'There are no preset with such name.',
    },
  },
  table_filter: {
    clear_filter: 'clear filter',
    date_from: 'From:',
    date_to: 'To:',
    label: {
      drill: 'Drill',
      // board_type: 'Board type',
      flop_suits: 'Suits',
      flop_paired: 'Pairing',
      flop_connectedness: 'Connectedness',
      oesd_possible: 'OESD possible',
      flop_subset: 'Subset',
      // cards: 'Cards',
      // hands: 'Hands',
      categories: 'Categories',

      flop_high_card: 'Highest card',
      flop_mid_card: 'Middle card',
      flop_low_card: 'Lowest card',

      tags: 'Tags',
      type: 'Type',
      stake: 'Stake',
      small_blind: 'Small blind',
      big_blind: 'Big blind',
      gto_score: 'GTO score',
      status: 'Status',

      total_pot: 'Pot',
      amount_won: 'BB W/L',
      street: 'Street',
      site: 'Site',
      cards: 'Cards',
      ev_loss: 'EV loss',
      ev_mistake: 'EV loss',
      positions: 'Positions',
      board: 'Board',
      board_type: 'Board type',

      hero: 'Hero',
      position: 'Hero',
      average_ev_loss: 'Avg. EV loss',
      average_ev_loss_as_pot: 'Avg. EV loss / %pot',
      total_ev_loss: 'EV loss',
      total_ev_loss_as_pot: 'EV loss / %pot',
      total_frequency_difference: 'Frequency difference',
      shortcut_type: 'Pot type',
      spot_type: 'Pot type',
      gameformat: 'Format',
      hands: 'Hands',
      date: 'Date',
      starred: 'Starred',
      hand: 'Hand',
      session: 'Session',
      session_name: 'Session',
      drill_name: 'Drill name',
      drill_type: 'Drill type',
      l_gmf_format: 'Format',
      file: 'File',
      filename: 'File',
      marked: 'Starred',

      game_format: 'Gameformat',
      blinds: 'Blinds',
      player_name: 'Player name',

      number_of_players_dealt: 'Number of players dealt',
      color_hex: 'Hero Label',
      player_label_color: 'Opponent label',
    },
  },
  table_head: {
    hand_correctness: 'GTO Result',
    place: 'Place',
    prize: 'Prize',
    prize_percentage: 'Prize %',
    stack: 'Stack',
    chip_percentage: 'Chip %',
    ev_percentage: 'EV %',
    ev_dollar: 'EV $',
    // redundant hhv3
    situation_street: 'Street',
    winloss: 'Win/Loss',
    frequency_difference: 'Freq. diff',
    avg_frequency_difference: 'Freq. diff%',
    player_winloss: 'Win/Loss (bb)',
    solution_status: 'Status',
    player_hand: 'Hand',
    player_aggression_preflop: 'Aggression preflop (Hero)',
    blinds: 'Blinds',
    file_id: 'File Id',
    player_relative_position: 'Relative position',
    hero_went_postflop: 'Hero went postflop',

    //--

    tournament_type: 'Tournament type',
    bounty_instant_percentage: 'Instant Payout %',

    name: 'Name',
    currency: 'Currency',
    prize_pool: 'Prize pool',
    total_entrants: 'Total players',
    players_per_table: 'Players per table',

    file: 'File',
    rake: 'Rake',
    table: 'Table',
    player_nickname: 'Nickname',
    big_blind: 'Big blind',
    small_blind: 'Small blind',
    type: 'Type',
    stake: 'Stake',
    rake_percentage: 'Rake %',
    rake_cap: 'Rake cap (bb)',
    preflop_rake_type: 'Preflop rake type',
    last_used: 'Last used',
    positions: 'Positions',
    name_description: 'Name + Description',
    ip: 'IP',
    oop: 'OOP',
    stats: 'Stats',
    card: 'Card',
    suit: 'Suit',
    controls: 'Controls',
    tags: 'Tags',

    description: 'Description',
    overview: 'Overview',

    breakdown_category: 'Category',
    breakdown_range: 'Range %',
    breakdown_performed: 'Performed %',
    breakdown_represented: 'Represented %',
    breakdown_summary: 'Summary',

    hands: 'Hands',
    drill: 'Drill',
    created_at: 'Date',
    combos: 'Combos',
    player: 'Player',
    eqr: 'EQR',
    total_pot: 'Pot',
    amount_won: 'BB W/L',
    label: 'Label',
    marked: 'Mark',
    date: 'Date',
    played_at: 'Date',
    date_played: 'Date',
    gametype: 'Type',
    total_hands: 'Total hands',
    total: 'Total',
    analyzed_hands: 'Analyzed hands',
    fully_analyzed_hands: 'Fully analyzed hands',
    partialy_analyzed: 'Partially analyzed hands',
    duplicate_hands: 'Duplicate hands',
    unsupported_hands: 'Unsupported hands',
    errors: 'Errors',
    correct: 'Correct',
    correct_hands: 'Correct hands',
    mistakes: 'Mistakes',
    mistakes_hands: 'Mistakes hands',
    over_limit_hands: 'Over limit hands',
    ev_mistake: 'EV loss',
    format: 'Format',
    note: 'Note',
    avg_ev_mistake: 'Avg. EV loss',
    status: 'Status',
    actions: 'Actions',
    actions_with_correctness: 'Actions',
    site: 'Site',
    position: 'Position',
    cards: 'Cards',
    board: 'Board',
    boards: 'Board',
    preflop: 'Preflop',
    flop: 'Flop',
    turn: 'Turn',
    river: 'River',
    hand: 'Hand',
    strategy: 'Strategy',
    range: 'Range',
    ev: 'EV',
    eq: 'EQ',
    eq_percent: 'EQ %',
    eqr_percent: 'EQR %',
    equity: 'Equity',
    blockers: 'Blockers',
    blocker: 'Blocker',

    blocker_rate: 'Value Removal',
    unblocker_rate: 'Trash Removal',

    blocker_score: 'Blocker score',
    flops: 'Flops',
    unique: 'Unique',
    turns: 'Turns',

    ev_ip: 'EV IP',
    ev_oop: 'EV OOP',
    equity_ip: 'EQ IP %',
    equity_oop: 'EQ OOP %',
    ip_eqr: 'EQR IP %',
    oop_eqr: 'EQR OOP %',

    ev_ip_html: `EV  <br><span style='font-size:var(--ipopeqr-fnt-size)'>IP</span>`,
    ev_oop_html: `EV <br><span style='font-size:var(--ipopeqr-fnt-size)'>OOP</span>`,
    equity_ip_html: `EQ <br><span style='font-size:var(--ipopeqr-fnt-size)'>IP %</span>`,
    equity_oop_html: `EQ <br><span style='font-size:var(--ipopeqr-fnt-size)'>OOP %</span>`,
    ip_eqr_html: `EQR <br><span style='font-size:var(--ipopeqr-fnt-size)'>IP %</span>`,
    oop_eqr_html: `EQR <br><span style='font-size:var(--ipopeqr-fnt-size)'>OOP %</span>`,

    // ev_ip_html: `EV  <span style='font-size:var(--ipopeqr-fnt-size)'>IP</span>`,
    // ev_oop_html: `EV <span style='font-size:var(--ipopeqr-fnt-size)'>OOP</span>`,
    // equity_ip_html: `EQ <span style='font-size:var(--ipopeqr-fnt-size)'>IP%</span>`,
    // equity_oop_html: `EQ <span style='font-size:var(--ipopeqr-fnt-size)'>OOP%</span>`,
    // ip_eqr_html: `EQR <span style='font-size:var(--ipopeqr-fnt-size)'>IP%</span>`,
    // oop_eqr_html: `EQR <span style='font-size:var(--ipopeqr-fnt-size)'>OOP%</span>`,

    ip_eq_simple: 'EQ IP',
    oop_eq_simple: 'EQ OOP',
    ip_eqr_simple: 'EQR IP',
    oop_eqr_simple: 'EQR OOP',

    high_cards: 'High cards',
    board_type: 'Board type',
    pairing: 'Pairing',
    card_ranks: 'Cards',
    connectedness: 'Connectedness',
    oesd_possible: 'OESD possible',
    suits: 'Suits',
    whitespace: ' ',

    game_mode: 'Gamemode',
    shortcut_type: 'Pot type',
    pot_type: 'Pot type',
    hero_position: 'Hero position',
    gto_score: 'GTOW Score %',
    avg_gto_score: '<span class="text-nowrap">Avg. GTOW</span> Score%',
    ev_loss: 'EV loss',
    total_ev_loss: 'EV loss',
    ev_loss_avg: '<span class="text-nowrap">Avg. EV</span> loss',
    avg_ev_loss:
      '<span class="text-nowrap">Avg. EV</span> <span class="text-nowrap">loss (bb)</span>',
    ev_loss_as_pot: '<span class="text-nowrap">EV loss</span> pot%',
    total_ev_loss_as_pot: '<span class="text-nowrap">EV loss</span> pot%',
    ev_loss_as_pot_tra01: '<span class="text-nowrap">EV loss</span> pot %',
    total_ev_loss_as_pot_tra01: '<span class="text-nowrap">EV loss</span> pot%',
    avg_ev_loss_as_pot: '<span class="text-nowrap">EV loss</span> pot%',
    total_frequency_difference: 'Freq. Diff. %',
    frequency_difference_abbr: 'Freq. Diff. %',
    hero: 'Hero',
    result: 'Result',

    chosen_hero_player: 'Hero',
    color_hex: 'Color',
    game_analysis: 'Game analysis',
    game_type: 'Game type',
    solution_warning_status: 'Status',
    spot_type: 'Spot type',
    variant: 'Variant',
    game_table: 'Game table',
    hand_id: 'Hand ID',
    game_format: 'Game format',
    action_sequence: 'Action sequence',
    player_position: 'Player position',
    style: 'Style',
    hero_hand: 'Hero hand',
    file_original_name: 'File name',
    game_rake: 'Rake',

    stack_depth: 'Stack Depth',
    model: 'Model',
    solution_name: 'Solution Name',
    open: 'Open',
  },
  tournament_phase_dialog: {
    title_sub: 'The tournament phase indicates how many players remain in the tournament',
    finale_table_title: 'Final table',
    finale_table_sub: 'Final table strategy. There are 3 to 9 players remaining.',
    tables_2_title: '2 tables',
    tables_2_sub: `The last two tables of the tournament. Each table has the same number of players. There are 10, 12, 14 or 16 players remaining.`,
    tables_3_title: '3 tables',
    tables_3_sub: `The last three tables of the tournament. Each table has the same number of players. There are 18, 21 or 24 players remaining.`,
    near_bubble_title: 'Near bubble',
    near_bubble_sub: `The last 3 players before the money bubble bursts and secure a payout. There are 33 players remaining. 30 places paid.`,
    last25_title: '25% left',
    last25_sub: `25% of the player pool remains. Payouts based on 200 player MTTs.`,
    last37_title: '37% left',
    last37_sub: `37.5% of the player pool remains. There are 75 players left.`,
    last50_title: '50% left',
    last50_sub: `50% of the player pool remains. There are 100 players left.`,
    last70_title: '70% left',
    last70_sub: `70% of the player pool remains. There are 140 players left.`,
    last90_title: '90% left',
    last90_sub: `90% of the player pool remains. There are 180 players left.`,
    start_title: '100% left',
    start_sub: `Start of the tournament. Nobody has been eliminated. There are 200 players left.`,
    players_1000: {
      last5_title: '5% left',
      last5_sub: '5% of the player pool remains. There are 50 players left',
      last10_title: '10% left',
      last10_sub: '10% of the player pool remains. There are 100 players left',
      last25_sub: '25% of the player pool remains. There are 250 players left',
      last37_sub: '37.5% of the player pool remains. There are 375 players left',
      last50_sub: '50% of the player pool remains. There are 500 players left',
      last75_title: '75% left',
      last75_sub: '75% of the player pool remains. There are 750 players left',
      start_sub: `Start of the tournament. Nobody has been eliminated. There are 1000 players left.`,
      near_bubble_sub:
        'The last 2 players before the money bubble bursts and the remaining players and secure a payout. 152 players remain. 150 places paid.',
      middle_bubble_title: '16% left',
      middle_bubble_sub:
        '16% of the player pool remains. There are 160 players left. 150 places paid.',
      early_bubble_title: '18% left',
      early_bubble_sub:
        '18% of the player pool remains. There are 180 players left. 150 places paid.',
    },
  },
  blockers: {
    title_sub: `This displays how card removal changes your frequencies. Sort this table by any action to find
    which blockers increase or decrease that action the most.`,
    blockers_tab: `Blockers tab`,
    blockers_tab_sub: `This displays how card removal changes your frequencies. Sort this table by any action to find
    which blockers increase or decrease that action the most.`,
    value_removal: `Value Removal`,
    value_removal_sub: `
    Value Removal is scored from {min_icon} 0 to {max_icon} 10. This indicates how much EV your hand removes from the
    top of your opponent’s range due to card removal.
    <br>
    A low score (0) means your hand does not block value in your opponent’s range. This is
    desirable when value betting.
    <br>
    A high score (10) means your hand blocks a lot of value in your opponent’s range. This is
    desirable when bluffing or bluff-catching.
    `,
    trash_removal: `Trash Removal`,
    trash_removal_sub: `
    Trash Removal is scored from {min_icon} 0 to {max_icon} 10. This indicates how much trash you block in your
    opponent’s range due to card removal.
    <br>
    A low score (0) means you do not block trash in your opponent’s range. This is desirable when
    bluffing or bluff-catching.
    <br>
    A high score (10) means you block a lot of trash in your opponent’s range. This is desirable
    when value betting.`,
    blockers_examples_1: `
    If you want to find good bluffs, select a bet size and go into your opponent’s blocker tab.
    Sort by most folded to find what blocked cards cause them to fold more.
    `,
    blockers_examples_2: `
    If you want to find good slow plays OOP, select check and go into your opponent’s blocker
    tab. Sort by least checked to find what blocked cards cause them to bet more.
    `,
  },
  links: {
    icm_calculator: 'ICM calculator',
    training_plans_dashboard: 'Study plans',
    training_plans_dashboard_sub: 'Structured GTO Lessons',
    // guides:'Guides',
    // guides_sub:'',
    guide_upload: 'Upload guide',
    // guide_upload_sub: 'Get the most out of uploads!',

    glossary: 'Glossary',

    practice: 'Practice',
    practice_dashboard: 'Dashboard',
    practice_dashboard_sub: 'Subtitle Dashboard',
    practice_full_hand: 'Full hand',

    practice_drills: 'Drills',
    practice_drills_sub: 'Manage training drills',

    practice_trainer: 'Trainer',
    practice_trainer_sub: 'Play vs. GTO opponent',

    practice_specific_spot: 'Specific spot',
    practice_range_builder: 'Range builder',
    practice_range_quiz: 'Quizzes',

    practice_play: 'Play',
    practice_play_sub: '--Play subtitle--',
    practice_practice: 'Practice',
    practice_practice_sub: '--Practice subtitle--',

    practice_hands: 'Hands',
    practice_hands_sub: 'Review practiced hands',

    practice_stats: 'Stats',
    practice_stats_sub: 'Overall performance',
    practice_sessions: 'Sessions',
    practice_sessions_sub: 'Review practiced sessions',

    practice_reports: 'Reports',
    // practice_play_sub: 'Subtitle Dashboard',
    practice_settings: 'Settings',
    // practice_play: 'Play',
    practice_info: 'Info',

    study_dashboard: 'Study',
    study_solutions: 'Solutions',
    study_reports: 'Reports',
    study_lessons: 'Lessons',
    study_graph: 'Graph',
    study_filter: 'Filter',

    analyzer_settings: 'Analyzer settings',
    analyzer_settings_sub: 'Used solutions for HH Analyzer',

    HHanalyzer: 'Analyzer',
    HHanalyzer_sub: 'Customize used solutions for HH Analyzer',
    analyze: 'Analyze',
    analyze_uploads: 'Uploads',
    analyze_hands: 'Hands',
    analyze_replayer: 'Hand replayer',
    analyze_reports: 'Reports',
    analyze_stats: 'Stats',

    study_custom_solutions: 'Custom solutions',
    study_custom_solutions_sub: 'Use AI to solve any spot',

    study_gwizlib_solutions: 'Solutions library',
    study_gwizlib_solutions_sub: 'Browse any spot you want',

    study_solutions_sub: 'Study any spot you want',

    study_reports_sub: 'Study board frequencies',
    study_lessons_sub: 'Learn GTO fundamentals',
    practice_full_hand_sub: 'Play vs. GTO opponent',
    // practice_specific_spot_sub: 'Master specific spot',
    practice_range_builder_sub: 'Practice range construction',
    practice_range_quiz_sub: 'Test your range knowledge',

    analyze_uploads_sub: 'Analyze your game',
    analyze_hands_sub: 'Study analyzed hands',
    analyze_reports_sub: 'Overall stats of your game',
    analyze_stats_sub: 'Overall stats of your game',

    UserAccount: 'Account',
    UserAccount_sub: 'Account details',
    UserSubscription: 'Subscription',
    UserThemes: 'Themes',
    UserAppearance: 'Appearance',
    UserAppearance_sub: 'Customize GTO Wizard',
    UserLanguage: 'Languages',
    UserGameSettings: 'Analyzer settings',
    UserHotkeys: 'Hotkeys',
    UserCredits: 'Credits',
    UserCredits_sub: '{credits_balance} remain',

    my_profile: 'My profile',
    log_out: 'Log out',
    notifications: 'Notifications',
    upload: 'Upload',
    settings: 'Settings',
    tutorial: 'Tutorial',

    more_themes: 'More themes',
    game_settings: 'Game settings',
    open_in_sol_browser: 'Open in solution browser',

    pricing: 'Pricing',
    pricing_sub: 'View pricing plans',
    weekly_coachings_sub: 'Live coaching with pros',
    glossary_sub: 'Explanation of game terms',
    solutions_sub: 'Details about our solutions',
    startcrushing_sub: 'Get staked and crush',
    roadmap_sub: 'See upcoming features',
    blog_sub: 'News about GTO Wizard',
    fairplay: 'Fair Play',
    gto_reports: 'GTO Reports',
    gto_reports_sub: 'Compare yourself to GTO',
    play: 'Play',
  },
  banners: {
    full_hand: {
      title: 'Play vs GTO opponent.',
      what: 'Play hands start to finish.',
      why: 'Recommended for general theoretical practice.',
      help: 'Need help? Watch a tutorial here.',
    },
    specific_spot: {
      title: 'Master GTO in specific situations.',
      what: 'Real time feedback and repetition.',
      why: 'Recommended for mastering uncomfortable spots.',
      help: 'Need help? Watch a tutorial here.',
    },
  },
  tags: {
    best_value: 'Best value',
    queued_plan: 'Queued Plan',
    save_up_to: 'Save {amount}',
  },
  payment: {
    current_plan: 'Current plan',
    in_starter: 'in Starter',
    in_premium: 'in Premium',
    in_elite: 'in Elite',
    upgrade_plan: 'Upgrade plan',
    manage_plan: 'Manage plan',
    get_started: 'Get started',
    credit_card: 'Credit card',
    credit_card_number: 'Card number',
    credit_card_exiration: 'Expiration Date',
    credit_card_cvc: 'Security Code',
    check_out: 'check out',
    safe_secure_checkout: 'Guaranteed safe & secure checkout',
    how_did_you_find_us: 'How did you find out about us?',
    choose_your_payment_method: 'Choose your payment method',
    change_to_yearly_subscription: 'Change to yearly subscription',

    paypal_error: 'PayPal is not available.',
    stripe_error: 'Credit card payment is not available.',
    error: {
      status_UNKNOWN_ERROR: 'Ops. Something went wrong. Please try again or get help via',
      status_stripe_UNKNOWN_ERROR: 'Please check your card details and try again or get help via',
      status_stripe_CARD_DECLINED: 'Card declined. Check your card details.',
      status_stripe_FORM_CREATION_ERROR: `Stripe form creation resulted in Error. <br />Please copy this error and contact us via`,
      status_stripe_failed_to_create_customer:
        'There was an error. Service is temporarily unavailable.',
      status_stripe_update_CARD_DECLINED:
        'Card declined. Please make sure you have enough funds on your card and try again.',
    },
    pay_update_success: 'You have changed your subscription!',
    paypal_sub_update_success: 'Plan change request received.',
    paypal_sub_update_success_subtitle:
      'We will change your plan to <b>{new_tier}</b> for the next billing cycle.',
    paypal_receipt_note: `Your transaction has been completed, and a receipt for your purchase has been emailed to you.
                          Log into your PayPal account to view transaction details.`,
    stripe_sub_upgrade_success: 'You have changed your subscription!',
    stripe_sub_upgrade_success_subtitle: 'Your new plan is now <b>{new_tier}</b>.',
    stripe_sub_downgrade_success: 'You have changed your subscription!',
    stripe_sub_downgrade_success_subtitle:
      'We will change your plan to <b>{new_tier}</b> for the next billing cycle.',

    stripe_card_denied: 'Credit card payment has not been succesfull.',
    stepper_plan_selection: 'Plan selection',
    stepper_payment: 'Payment',
    stepper_payment_update: 'Update overview',
    stepper_confirmation: 'Confirmation',
    updating_subscription: 'Updating subscription to',
    form_loading: 'Loading payment for',
    manual_sub_month: 'Your subscription will be valid for one month.',
    manual_sub_year: 'Your subscription will be valid for 12 months.',
    sub_renew_month: 'Your new subscription will automatically renew every month.',
    sub_renew_year: 'Your new subscription will automatically renew every 12 months.',
    sub_no_renew: 'The new subscription will end <strong>{date}</strong>.',
    manual_will_be_charged: `You will be charged {amount} for the selected term. 
                            After the term ends, your subscription <b>will not automatically renew</b>, and you will <b>need to manually re-subscribe</b> to continue using the service. 
                            If you cancel during the subscription period, previous charges will not be refunded, but you may continue to access the service until the end of the term you paid for.`,
    you_will_be_charged: `You will be charged {amount} on each renewal until you cancel.
                          If you cancel, previous charges will not be refunded,
                          but you may continue to use the service until the end of the term you paid for.`,

    you_will_get_access_instantly_stripe: `You will get access to <b>{new_tier}</b> instantly, and you will be charged an extra <b>{extra_amount}</b>
                                 for the difference in the pricing of your current plan for the rest of your subscription period.`,

    you_will_get_access_paypal: `You will get access to <b>{new_tier}</b> after your current subscription
                                period ends on <b> {subscription_expiration}</b>. If you want to get access to <b>{new_tier}</b> instantly,
                                please contact us via `,

    you_will_get_access_after_expire_stripe: `You will get access to <b>{new_tier}</b> after your current plan
                                              <b>{current_tier}</b> expires on <b> {subscription_expiration}</b>.`,

    you_will_get_access_instantly_free: `You will get access to <b>{new_tier}</b> instantly, and you will be charged <b>{amount}</b>.`,

    downgrade_to_tier: `Your plan will be changed to <b>{new_tier}</b> after your current plan
                        <b>{current_tier}</b> expires on <b>{subscription_expiration}</b>.`,

    downgrade_to_starter_are_you_sure: 'Are you sure? You will lose:',
    downgrade_to_starter_why_not: 'You will lose:',

    aggregation_reports: 'Aggregation reports',
    weekly_coaching: 'Weekly coaching',
    only_50: '{premium_hands_mo} hands to analyze / month',

    manual_checkout_tra01: `If you want to get <b>{new_tier}</b> instantly, please <b> contact us on our Discord or write us on email
                       <a class="link-underline link-underline_hover" href="{mailto}" target="_blank">{email}</a> since we have to do this particular
                      change manually.<b/>`,

    by_clicking_stripe_btn: 'By clicking the "Check out" button above, you are agreeing to',
    by_clicking_continue_btn: 'By clicking the "Continue" button above, you are agreeing to',
    by_clicking_paypal_btn: 'By clicking the "PayPal" button above, you are agreeing to',
    terms_service: 'Terms of Service',

    payment_thanks: 'Thank you for your payment.',
    your_plan_was_updated_to: 'Your plan was updated to',
    starter_boost_line: 'Get ready to elevate your game to the next level!',
    premium_boost_line: 'You are ready to become the ultimate GTO Wizard!',

    reactivation_failed: 'Reactivation was not successfull',
    update_subscription_timed_out:
      'Your subscription update is still processing, it will be upgraded soon, please come back later or contact support via our',

    errors: {
      form_creation: `Payment form creation resulted in error.<br>Please copy this error and contact us on our`,
      copy_error: 'CLICK TO COPY ERROR TEXT',
      error_copied: 'Error text copied to clipboard!',
      create_payment: 'Error creating payment',
      create_form: 'Error creating form',
      no_plan_selected: 'No plan selected',
      invalid_card_number: 'Invalid card number',
      invalid_cvc: 'Invalid CVC',
      invalid_expiry: 'Invalid expiry date',
      upgrade_price: 'Error getting upgrade price',
      unknown_error: 'Ops. Something went wrong!',
      please_refresh:
        'Please refresh the page and try again.<br> If the problem persists, contact us.',
      payment_expired: 'Payment invoice expired. Please try again.',
      payment_error: 'There was an error with your payment. Please try again.',
      no_country_selected: 'Please select a country.',
    },
    btns: {
      use_saved_card: 'USE SAVED CARD',
      add_new_card: 'ADD NEW CARD',
      change_card: 'CHANGE CARD',
      change_to_card: 'CHANGE TO CARD',
      change_payment_method: 'CHANGE PAYMENT METHOD',
      checkout: 'CHECKOUT',
      crypto: 'CRYPTO',
      card: 'CREDIT CARD',
      paypal: 'PAYPAL',
      other: 'OTHER',
    },
    tooltips: {
      pay_with_saved_card: 'Pay with saved card',
      checkout_with_crypto: 'Checkout with crypto',
    },

    crypto: {
      thanks_for_your_payment: 'Thank you for your payment!',
      country_of_purchase: 'Country of purchase',
      search_country: 'Search country...',
      one_time_crypto_payment: 'One-time Crypto Payment',
      please_select_country: 'Please select your country of purchase',
      pay_with_crypto: 'Pay with Crypto',
      crypto_disabled: 'Crypto payments are supported only for yearly subscriptions.',
      payment_protection:
        'Your payment is safe and protected. GTO Wizard uses trusted blockchain technology to ensure secure and transparent transactions.',
      state: {
        loading: 'Loading payment...',
        success: {
          title: 'Payment was successful!',
          subtitle: 'Thank you for your payment!',
          update_subcription:
            'Once your subscription is upgraded, we will we will let you know via email at <span class="text-underline clr-primary">{email}</span>.',
        },
        confirming: {
          title: 'Processing payment...',
          update_subcription_email:
            'Once payment arrives and your subscription is upgraded, <br /> we will we will let you know via email at <span class="text-underline clr-primary">{email}</span>.',
          update_subcription:
            'Your subscription will be upgraded once the payment is confirmed on the blockchain, depending on the cryptocurrency in may take up to 30 minutes.',
        },
      },
      no_refund: {
        title: 'Important Notice',
        text: 'Please be aware that, due to technical limitations, cryptocurrency purchases are final and <strong class="text-underline">cannot be refunded</strong>.<br /><br /> Thank you for your understanding',
      },
      private_relay: 'Due to your email privacy settings, we might not be able to notify you!',
      help_start: 'Need help? Contact us via our',
      help_end: 'or at <a href="mailto:{email} class="clr-primary">{email}</a>',
    },

    straddle: {
      // text_0: 'This tier is for players who play 8max Cash games with straddle + ante.',
      // text_1: 'The ante is 4BB total (0.5BB per player).',
      // text_2: 'All solutions are solved without a rake.  ',
      ante4bb: 'Ante 4BB',
      ante_per_player_05bb: '0.5BB Ante per player',
      no_rake: 'No rake',

      ante06bb: 'Ante 0.6BB',
      ante_per_player_01bb: '0.1BB Anter per player',
      rake_05_bb_cap: 'Rake 5% 0.1BB CAP',
      //  (100BB) (150BB) (200BB)
    },
  },
  hand_counter: {
    plan: 'Plan',
    hands_quota_reset_date: 'Hands quota reset on {date}',
    hands_quota_reset: 'Hands quota for analyzer will reset on  {date}',
  },
  upload: {
    // set_hh_gametype: 'To customize used solutions for HH Analyzer',
    click_paste: 'Click & paste',
    hh_here: 'your Hand History here.',
    supported_sites: 'Currently supported sites:',
    supported_formats: 'Currently supported formats:',
    hh_is_analyzing: 'Your Hand is being analyzed.',
    drag_drop: 'Drag & Drop your HHs here',
    hh_or_files_here: 'or click an option below.',
    upload_members_only: 'Only subscribed users can upload files.',
    help_copy: '<strong>Ctrl(⌘) + C</strong> for Copy',
    help_paste: '<strong>Ctrl(⌘) + V</strong> for Paste',
    help_enter_analyze: '<strong>Enter</strong> to Analyze',
  },
  table_features: {
    all_features: 'All features',

    solutions: {
      title: 'Solutions',
    },

    // ai_solving: 'AI custom solving',
    ai_solving_all: 'AI custom solving (Preflop + Postflop)',
    ai_solving_tooltip: `With AI custom solving you can modify ranges, adjust the stack and pot
    size, add or remove actions, customize the betting tree, and
    automatically simplify and optimize your bet sizes! {link}`,

    dynamic_ev_sizings: 'Dynamic mode to find highest EV sizings',
    dynamic_ev_sizings_tooltip: ` Choose how many bet or raise sizes you want and GTO Wizard will automatically determine the optimal (highest EV) sizings at each decision point. You can also specify what sizes the dynamic algorithm should consider before simplifying.`,

    nodelocking: 'Nodelocking',
    nodelocking_tooltip: ` Nodelocking is a powerful feature that allows you to define player’s strategies and
    craft exploits! You can set strategies by combo, hand category, or action frequency, then compare how the
    response changes!`,

    study: {
      title: 'Study',
      solution_per_day: '{free_solution_per_day} solution / day',

      x_depths: '{num} depths',
      x_varying_stacks: '{num} mixed stacks',

      varying_stacks: 'mixed stacks',
      all_varying_stacks: 'All {num} mixed stacks',

      x_depths_only: '{available_depths} depths only',
      depth_xxx_only: 'Only {available_depths} depth',
      depths_xxx_only: 'Only {available_depths} depths',
      depths_xxx_only_tooltip:
        '{tier} users can study all types of solutions, but only {available_depths}',

      all_depths_xxx: 'All depths {available_depths}',
      all_depths_xxx_tooltip: '',

      all_depths: `All depths`,
      all_xxx_depths: `All {num} depths`,
      all_depths_tooltip: `{tier} users can study all types of solutions <br> and all depths:<br> {available_depths}.`,

      preflop_solutions: 'Preflop solutions', // TODO remove this after translation
      preflop_solutions_tooltip:
        'Study strategy of any preflop solution you want in the Solution browser.',

      postflop_solutions: 'Postflop solutions',
      postflop_solutions_tooltip:
        'Study strategy of any postflop solution you want in the Solution browser.',

      preflop_solutions_mixed_stacks: 'Preflop solutions (mixed stacks)',
      preflop_solutions_mixed_stacks_tooltip:
        'Mixed stacks solutions are solutions where all players have different stack sizes.',

      blockers_score: 'Blockers score',
      blockers_score_tooltip: 'Study blocker effects of each combo in Solution browser.',

      preflop_solutions_xxx: 'Preflop solutions ({solution_depths})',
      postflop_solutions_xxx: 'Postflop solutions ({solution_depths})',

      postflop_solutions_variable: 'Postflop {solution_type} solutions',
      postflop_solutions_variable_depths: 'Postflop {solution_type} solutions ({available_depths})',

      posflop_solutions_varying_stacks_simple: 'Postflop {solution_type} varying solutions',
      posflop_solutions_varying_stacks:
        'Postflop {solution_type} varying solutions <br> ({available_depths})',

      posflop_solutions_mixed_stacks_simple: 'Postflop {solution_type} mixed stacks solutions',
      posflop_solutions_mixed_stacks:
        'Postflop {solution_type} mixed solutions <br> ({available_depths})',

      icm_solutions: 'ICM solutions',
      icm_solutions_all_xxx_situations: 'ICM solutions (All {num} situations)',
      icm_pko_solutions: 'PKO ICM solutions',
      icm_pko_solutions_all_xxx_situations: 'PKO ICM solutions (All {num} situations)',
      all_xxx_situations: 'All {num} situations',

      headsup_solutions: 'Heads-up solutions',

      GTO_lessons: 'GTO lessons',
      GTO_lessons_tooltip:
        'Learn basic and more advanced concepts of GTO. A total of {gto_lessons_num} lessons.',
      aggregated_reports: 'Aggregated reports',
      aggregated_reports_tooltip: `Compare all flops and see how various boards affect player's strategies, equity, and EVs. `,

      copy_ranges: 'Copy ranges',
      copy_ranges_tooltip: 'Copy any range in GTO Wizard with just one click.',
      ranges_comparisons: 'Ranges comparison',
      ranges_comparisons_tooltip: `Visualize and compare both player's ranges and their combos in a unique way using equity buckets and equity chart.`,

      all_preflop_solutions: 'All preflop solutions',
      postflop_6max_8max_straddle_ante: 'Postflop for 6max/8max Straddle+Ante',

      flops_ev_aggregation: 'Flop aggregated reports',
      flop_turn_agg_reports: 'Flop and Turn aggregated reports',

      turns_ev_aggregation: 'Turn aggregated reports',
      turns_ev_aggregation_tooltip:
        'Compare all turn cards and see how each card affects players strategies and EVs.',
      coachings: 'Coaching',
      weekly_coachings: 'Weekly coachings',
      weekly_coachings_tooltip: `Participate in our weekly coaching sessions led by professional players.
      Every week, we offer Cash/MTT or Theory coaching, and you, along with other GTO Wizards, get to vote on the topics covered.
      These coaching sessions are conducted live via Zoom webinars, allowing you to ask questions and interact with the coaches.
      Recordings of the sessions are subsequently published in the GTO Wizard app.
       With a Premium subscription, you can access all past coaching sessions, totaling over 100 hours of high-quality content!`,

      basic_flop: '{basic_flop_num} spots',
      basic_flop_tooltip: 'Starter users can study flop reports in only {basic_flop_num} spots.',
      basic_turn: '{basic_turn_num} spot',
      basic_turn_tooltip: 'Starter users can study turn reports in only {basic_turn_num} spot.',

      study_plans: 'Study plans',
      study_plans_tooltip: `
      Plans include curated content and training drills designed
      to help you master GTO concepts such as range analysis, bet sizing, and balancing your actions.
      These will help you become a more well-rounded and difficult player to exploit,
      giving you a significant edge over your opponents.`,

      icm_events: 'Events',
      icm_events_tooltip:
        'Review iconic final tables, solved with exact chip stacks and prize structures.',
    },
    practice: {
      title: 'Practice',
      // spec_spot_training: 'Specific spot training',
      // spec_spot_training_tooltip: 'Master specific spot. You can select any spot you want to study using various advanced filters.',
      // full_hand_playthrough: 'Full hand playthrough',
      full_hand_playthrough_v1: 'Trainer',
      full_hand_playthrough_tooltip: 'Play vs. GTO opponent hands from start to finish.',
      range_construction: 'Range construction training',
      range_construction_tooltip:
        'Practice range construction with our unique Range builder mode. Instead of practicing with one specific hand, you can train how to play with your whole range.',
      spot_per_day: '{spot_per_day_num} spot / day',
      puzzles_: 'Puzzles',
      puzzles__tooltip:
        'Master your game by competing against our solutions in interactive challenges and puzzles.',
      stats_reports: 'Stats & reports',
      stats_reports_tooltip:
        'Get a report from your hands in the practice mode and see detailed stats of where you deviate from GTO for each position. ',
      hands_10_day: '{hands_10_day_num} hands / day',
      hands_5_mo: '{hands_5_mo_num} hands / month',
      hands_50_mo: '{hands_50_mo_num} hands / month',
      hands_max_mo: '{hands_max_mo_num} hands / month',
    },
    analyze: {
      title: 'Analyze',
      hand_histories: 'Hand histories',
      hand_histories_tooltip:
        'Upload your hands and analyze them to see where you deviate from GTO.',
      GTO_reports: 'GTO Reports',
      GTO_reports_tooltip: `Get reports from your analyzed hands and see where you deviate from GTO for each position with detailed statistics
        (for example, you will find out that you overbet way too much on the turn in BTN vs.BB).`,
      advanced_GTO_reports: 'Advanced GTO Reports',
      advanced_GTO_reports_tooltip: `Elite users will get a more sophisticated version of GTO Reports for their analyzed hands`,

      leak_finder: 'Opponent leak finder',
      leak_finder_tooltip: `We will analyze the actions of your opponents from your uploaded hands.
                           This way, you can find their playing patterns and leaks to crush them even more.`,
    },
    extra: {
      title: 'Extra',
      customer_support: 'Fast customer support',
      customer_support_tooltip: `GTO Wizard is a super user - oriented product.
                                We will always be happy to help you or implement your requested ideas into our product ASAP.`,
      mobile_friendly: 'Mobile friendly',
      mobile_friendly_tooltip: 'GTO Wizard is working flawlessly also on your mobile or tablet.',
      discord_premium: 'premium channel',
      discord_premium_tooltip: 'Get access to our channels on Discord only for subscribed users.',
    },
  },
  subscription: {
    // limited_offer: 'Spin & Go, HU SnG and MTT features are entirely free for a limited time!',

    BACK: 'BACK',
    FAQ: 'FAQ',

    discount_eligible_message: `Enjoy a {value} discount for your first purchase, thanks to - <span class="weight_700">{affiliate_name}</span>.`,
    discount_simple_message: `Enjoy a {value} discount.`,

    activate_sub_role_on_discord_0: 'Activate subscriber role',
    activate_sub_role_on_discord_1: 'on',

    start_crushing_your_competition_0: 'Start crushing',
    start_crushing_your_competition_1: 'your competition.',

    // select_game_to_buy: 'Select desired format',
    select_game_to_buy: 'Please select which format do you want to purchase',

    only_for_subscribed_users_0: '! Only for',
    only_for_subscribed_users_1: 'subscribed users',

    activate_discord_tooltip:
      'Subscribed users get access to premium channels on our Discord server. Without this role, you cannot access weekly coachings.',
    activate_shortly_discord_title: 'We will upgrade your Discord account shortly.',
    discord_tag: 'Discord tag',
    update_discord_title: 'Update tag',
    placeholder_discord_tag01: 'Your Discord nickname',

    crush_competition: 'Start crushing your competition.',
    refund_quarantee: '{refund_quarantee_num} days refund guarantee for any reason.',
    refund_quarantee_short: '{refund_quarantee_num} days refund guarantee',

    selection_no_card_text:
      'Payment with your saved card failed!<br>Please add new card or change payment method.',
    selection_new_card_text: 'Pay with new card',

    faq: 'Frequently asked questions',
    starting_at: 'Starting at',
    month: 'month',

    first_month: '1st month',
    first_year: '1st year',

    first_month_price_tra01: '{price} USD / 1st month',
    first_year_price_tra01: '{price} USD / 1st year',
    then_next_month_price_tra01: 'Then {price} USD / month',
    then_next_year_price_tra01: 'Then {price} USD / year',

    see_all_features: 'See complete feature list',
    choose_your_plan: 'Choose your plan for',
    choose_your_plan_0: 'Choose your',
    choose_your_plan_1: 'game plan for',

    selected_game_plan: 'Selected game plan:',
    testimonial: {
      one: {
        person: 'Shaq',
        bio: 'Mid-High Stakes player',
        text: `I used to solve with PioSolver and have tested some other sites,
  but the interface, simplicity, accuracy, and effectiveness of GTO Wizard is by far the best.`,
      },
      two: {
        person: 'Micro Donk',
        bio: 'Youtuber',
        text: `Developers are very receptive and have rapidly added features based on feedback.
               They have separated themselves from other similar tools and continue to make the product better and better.`,
      },
      three: {
        person: 'Saulo Costa',
        bio: 'BrPC founder, RIO Elite coach',
        text: `With GTO Wizard subscription you get access to an already complete training platform, that is guaranteed to only get better. For anyone serious about improving their game, it's the easiest call of all time.`,
      },
    },
    you_chose: 'You chose:',

    want_to_save_amount_year_tra01: 'Want to save {amount_num} USD / year?',

    already_has_plan: 'You already have this plan.',

    switch_to_yearly: ' Switch to Yearly.',
    year: 'year',
    you_are_ready_wizard: 'You are ready to become the ultimate GTO Wizard!',
    continue_to_dashboard: 'Go to dashboard',
    leave_to_dashboard: 'Leave to dashboard',
    subscription_overview: 'Go to subscription overview',
    ups_wrong: 'Ops. Something went wrong.',
    or_get_help_on_our: 'Or get help via ',
    free: {
      title: 'Free',
      subtitle: 'Basic GTO understanding. ',
      preflop_solutions: 'Preflop solutions',
      basic_preflop_solutions: 'Basic preflop solutions',
      all_preflop_solutions: 'All preflop solutions',
      preflop_solutions_tooltip:
        'Study strategy of any preflop solution you want in the Solution browser without any limits.',
      preflop_solutions_tooltip_basic:
        'Study strategy of basic preflop solutions in the Solution browser without any limits.',
      one_postflop: '{one_postflop_num} postflop solution / day',
      one_postflop_tooltip:
        'Study strategy of any postflop spot you want in the Solution browser. You are limited to {one_postflop_num} spot per day, and the limit resets every 24 hours.',
      day_10_spots: '{day_10_spots_num} hands in each practice mode / day',
      day_10_spots_tooltip:
        'Practice up to {day_10_spots_num} hands in each practice mode for free. The limit resets every 24 hours.',
      // gto_lessons: 'GTO Lessons ',
      // gto_lessons_tooltip:
      //   'Learn basic and more advanced concepts of GTO. A total of {gto_lessons_num} lessons available entirely for free!',
    },
    starter: {
      title: 'Starter',
      subtitle: 'Elevate your game to the next level.',
      everything_in_free: 'Everything in free',
      // unlimited_postflop: 'Unlimited postflop solutions',
      unlimited_postflop_tooltip_tra01:
        'Study any postflop spot you want in the Solution browser! ({solution_depths})',
      unlimited_practice: 'Unlimited spots in practice mode',
      unlimited_practice_tooltip: 'Practice as many hands as you want in both practice modes.',
      unlimited_practice_xxx: 'Unlimited spots in practice mode ({solution_depths})',
      unlimited_practice_tooltip_xxx:
        'Practice as many hands as you want in both practice modes. ({solution_depths})',
      month_50_hands: '{month_50_hands_num} hands / month to analyze',
      month_50_hands_tooltip:
        'You get to upload and analyze {month_50_hands_num} hands you have played each month.',
      hh_reports_tra01: 'GTO Reports',
      hh_reports_tra01_tooltip: `Get reports from your analyzed hands and see where you deviate
                           from GTO for each position with detailed statistics(for example, you will find out that
                           you overbet way too much on the turn in BTN vs.BB).`,

      hh_reports_advanced: 'Advanced GTO Reports',
      hh_reports_advanced_tooltip: `Get reports from your analyzed hands and see where you deviate
                                                from GTO for each position with detailed statistics(for example, you will find out that
                                                you overbet way too much on the turn in BTN vs.BB).`,

      custom_rake_solving: 'Custom Rake solving',
      custom_rake_solving_tooltip: `Use GTO Wizard AI to quickly solve raked postflop spots. Raked GTO solutions work with all of our other features, such as nodelocking, arbitrary ranges and stack depths, using whatever bet sizes you prefer.`,

      basic_aggregated_reports: 'Basic aggregated reports',
      basic_aggregated_reports_tooltip_tra01: `Starter users can study flop reports in only {flop_available_spots} spots.`,
    },
    premium: {
      title: 'Premium',
      subtitle: 'Become the ultimate GTO Wizard.',
      everything_in_starter: 'Everything in Starter',
      month_100000_hands: '{premium_hands_mo_num} hands / month to analyze',
      month_100000_hands_tooltip: `You get to upload and analyze {premium_hands_mo_num} hands you have
                                   played each month.`,
      leak_finder: 'Opponent leak finder',
      leak_finder_tooltip: `We will analyze not only the actions you took but also the actions of your opponents.
                           This way, you can find their playing patterns and leaks to crush them even more.`,

      // TODO remove this
      advanced_aggregated_reports: 'Advanced aggregated reports',
      advanced_aggregated_reports_tooltip: `Compare all flops and also turns and see how
                                           various boards affect player's strategies,
                                          equity, and EVs without any limits.`,
    },
    elite: {
      title: 'Elite',
      subtitle: 'For the best of the best.',
      everything_in_premium: 'Everything in Premium',
      // ai_solving: 'AI custom solving',
      ai_solving_all: 'AI custom solving (Preflop + Postflop)',
      custom_solving_with_icm: 'Custom solving with ICM',
    },
  },
  faqs: {
    contact_us_discord: 'contact us on our Discord',
    tier_overview: {
      item_0: {
        title: 'What are your payment methods?',
        text_0:
          'You can pay with your Credit card or PayPal. If you want to pay with other payment methods, please contact us on our ',
      },
      item_1: {
        title: 'When are you going to release other features?',
        text_0_tra01: 'We are working hard on delivering all the features ASAP. Please ',
        // text_1: 'read this article',
        // text_2: ' to get a better idea or ',
        text_3_tra01: 'check out our roadmap here',
      },
      item_2: {
        title: 'Do you have some deals for stables?',
        text_0_tra01: 'Yes! If you are an owner of a stable, please contact {team_member} on ',
      },
      item_3: {
        title: 'Are there really no limits to browse solutions?',
        text_0: `There are some hidden limits on how many solutions you can view every 24 hours,
  which also acts as security protection.These limits apply only to the Solution browser
        and not to Practice mode or Hand History Analyzer.They are hard to reach, and with normal usage,
  you most likely won't ever hit it.`,
      },
      item_5_updated: {
        title: 'Can I upgrade or cancel my plan as needed?',
        text_0: 'Yes, you can manage your subscription in ',
        text_1: 'My profile',
        text_2: ` If you decide to cancel your plan, you can still use GTO Wizard until your subscription period expires.
                  You won't be charged again on renewal.`,
      },
      item_6: {
        title: 'What is your refund policy?',
        text_0: 'We have seven days refund guarantee for any reason. If you want a refund, please ',
      },
      item_7: {
        title: 'I have a different question, how can I contact you?',
        text_0: 'Please ',
        text_1: 'join our Discord',
        text_2: ` and ask us there. You don't need to make an account to `,
        text_3: 'join Discord',
        text_4:
          ' or install it. It works just in your browser on your desktop or your phone, same as GTO Wizard ',
      },
    },
  },
  footer: {
    terms: 'Terms',
    privacy: 'Privacy',
  },
  langs: {
    lang: 'Language',
    // en: 'English',
    // zh: 'Chinese',
    // pt: 'Portugeuese',
    // es: 'Spanish',
    // ru: 'Russian',
    // fr: 'French',
    // it: 'Italian',
    // th: 'Thai',
    // de: 'German',
    // ro: 'Romanian',
    // ja: 'Japanese',
    // sl: 'Slovenian',
  },
  trainer_quizz: {
    quizz_type: 'Quiz type',
    trainer_questions: 'Num of questions',
    action_types: {
      fold: 'Fold',
      call: 'Call',
      check: 'Check',
      raise: 'Raise',
      bet: 'Bet',
      allin: 'Allin',
    },
    ranges: {
      a: 'A',
      b: 'B',
      c: 'C',
      d: 'D',
      e: 'E',
      f: 'F',
    },
    types: {
      action_frequency: 'Action Frequencies',
      eq: 'Hand EQ',
      solution: 'Ranges',
    },
    questions: {
      action_frequency: 'Guess the frequency of: <span class="uppercase">{action}</span>',
      eq: 'What is the EQ of your hand',
      solution: 'Guess correct solution range',
    },
  },
  trainer: {
    groups_selection: {
      tooltip: `Select which hands you'd like to practice. You will train with hands that are both in your GTO range and the range you've specified.`,
      all: 'All',
      manual: 'Manual',
      hand_class: 'Hand class',
      only_cd: 'Close decisions',
      hand_class_tooltip: `Select a specific hand class to practice.`,
    },
    trainer_result_view: 'Result view',
    swv_trainer_result_grid: 'Default',
    swv_trainer_result_chart: 'Chart',

    sound_btn_title: 'Sound',
    trainer_settings: 'Settings',

    // trainer_manual_combos: 'Manual',
    // trainer_close_decisions: 'Close decisions',
    trainer_hero_stack_type: 'Hero stack size',
    // trainer_hero_stack_type_tooltip: `Practice specific stack sizes relative to the table. Bigstack > 133% of average tournament stack. Shortstack < 66% of average tournament stack`,
    trainer_hero_stack_type_tooltip: `
    <div class="mb-2">Practice specific stack sizes relative to the table.</div>
    <div><b>Bigstack:</b> Above 133% of average tournament stack.</div>
    <div><b>Midstack:</b> Between 133% and 66% of average tournament stack.</div>
    <div><b>Shortstack:</b> Below 66% of average tournament stack.</div>
    `,
    trainer_hero_stack_type_small: 'Shortstack',
    trainer_hero_stack_type_medium: 'Midstack',
    trainer_hero_stack_type_big: 'Bigstack',

    trainer_mode: 'Game mode',
    trainer_mode_tooltip: `
          <div><b>Full hand:</b> Play the hand to showdown, or until someone folds</div>
          <div><b>Street:</b> Practice one street</div>
          <div><b>Spot:</b> Practice one decision point</div>
          `,
    trainer_game_mode: 'Input mode',
    trainer_game_mode_tooltip: `
          <div><b>Actions:</b> Choose one single action</div>
          <div><b>Frequency:</b> Set the frequency of each action separately</div>
    `,
    // trainer_pause_after_mistake: 'Pause after mistake',
    // trainer_pause_after_mistake_tooltip: 'TODO',
    trainer_autoplay: 'Auto new hand',
    trainer_autoplay_tooltip: `
          <div><b>Off:</b> Manually start the next hand when you are ready</div>
          <div><b>Instant:</b> Get dealt the next hand instantly</div>
          <div><b>3s:</b> Get dealt the next hand after 3 seconds</div>
    `,

    trainer_session: 'Session',
    trainer_session_tooltip: `Select how many hands you would like to practice.
                              After you finish, you'll get an overview of your session`,
    trainer_tables: 'Number of Tables',
    trainer_tables_tooltip: `Select how many tables you'd like to play simultaneously.`,

    trainer_timebank: 'Timebank',
    trainer_timebank_tooltip: `Select action timeout. Your hand will be automatically checked or folded if you run out of time.`,

    trainer_game_speed: 'Game speed',
    trainer_game_speed_tooltip: `Speed of animations and delay in opponent decisions`,
    // trainer_real_game: 'Simulate real game',
    // trainer_real_game_tooltip: 'TODO',
    trainer_result: 'Pause game after',
    trainer_result_tooltip: `
            <div><b>Off:</b> See the result of your play after the hand is finished</div>
            <div><b>Mistake:</b> See the result of your play after a mistake </div>
            <div><b>Action:</b> See the result of your play after each decision</div>
            `,

    trainer_grouping: 'Difficulty',
    trainer_grouping_tooltip: `
    <div class="mb-2" style="max-width:24rem">Reduce the number of bet sizes to simplify your training experience. The trainer selects your hand's highest frequency action within the group.</div>
    <div><b>Simple:</b> Choose between bet/check or raise/call/fold</div>
    <div><b>Grouped:</b> Similar bet/raise sizes are grouped together</div>
    <div><b>Standard:</b> All sizing options within the solution are available</div>
    `,

    trainer_learning_mode: 'Learning mode',
    trainer_learning_mode_tooltip: `
            Hides information panel during play, revealing only after you make a move or make a mistake.
            Set <b>Pause game after</b> to <b><i>Mistake</i></b> or <b><i>Action</i></b>  to ensure this setting works as intended`,
    // trainer_learning_mode_tooltip: `
    //         <div><b>Off:</b> Information in the Info panel is shown immediately</div>
    //         <div><b>On:</b> Information in the Info panel is shown when action results are shown (after mistake or action)</div>
    // `,
    trainer_quick_result: 'Show quick results',
    trainer_quick_result_tooltip: `
            Show instant feedback on your play after taking action. <br>
            A banner on the table and a correctness icon in actions selector will be displayed. <br>
            You can also mouse over the action to see frequencies of all actions.
            `,
    trainer_hero_frequency: 'Show hints',
    // trainer_hero_frequency_tooltip: 'Cheat mode - show correct frequencies of actions while you play',
    trainer_hero_frequency_tooltip:
      'Cheat mode - display correct frequencies of actions while you play <span class="keyboardkey_key clr-white text-small">{key}</span>',
    // trainer_opponent_frequency: 'Opponent frequency',
    // trainer_opponent_frequency_tooltip: 'TODO',
    // trainer_replay_from_start: 'Replay game from start',
    // trainer_replay_from_start_tooltip: 'TODO',

    trainer_hero_range: `Show hero's range`,
    trainer_hero_range_tooltip: `Display hero's range in the info panel`,
    trainer_opponent_range: `Show opponent's range`,
    trainer_opponent_range_tooltip: `Display opponent's range in the info panel`,

    trainer_result_chart: 'Show result as a chart',
    trainer_result_chart_tooltip:
      'Always display action result as a chart<br> (Is default for spots with many actions)',

    trainer_equity_chart: 'Show Equity chart',
    trainer_equity_chart_tooltip: 'Display EQ comparison of both players in the info panel',

    trainer_ranges_comparison: 'Show range comparison',
    trainer_ranges_comparison_tooltip:
      'Display comparison of EV, Equity, and Combos of both players in the info panel',
    trainer_hand_strength: 'Show hand info',
    trainer_hand_strength_tooltip:
      'Display strength, equity, and category of your hand in the info panel',
    trainer_total_frequency: 'Show total frequencies',
    trainer_total_frequency_tooltip: 'Display total range frequencies in the info panel',

    trainer_equity_chart_title: 'Equity chart',
    trainer_ranges_comparison_title: 'Range comparison',
    trainer_hand_strength_title: 'Hand info',
    trainer_total_frequency_title: 'Range frequencies',

    trainer_hand_strength_title_tooltip: `
             <div><b>Strength:</b> Shows how strong the hand is in the hero's range (sorted by equity)</div>
             <div><b>Equity:</b> Equity is the percentage of the pot you'll win if a hand is checked down</div>
              `,

    trainer_hero_strategy: `Show hero strategy`,
    trainer_hero_strategy_tooltip: `Display hero's strategy in the info panel`,
    trainer_category_hands: 'Show hand class strategies',
    trainer_category_hands_tooltip:
      'Display the strategy and density for all hand categories within range in the info panel',
    trainer_category_draws: 'Show draw class strategies',
    trainer_category_draws_tooltip:
      'Display the strategy and density for all draw categories within range in the info panel',

    rng: 'RNG mode',
    rng_tooltip_tra01: `
    RNG is a number used by players to mix and randomize their decisions.<br>
    When RNG mode is enabled, the best answer is the action that matches<br>
    the RNG and not the one with the highest frequency.
    {linkText}
    <div class="mt-2"><b>Off:</b> RNG mode is disabled</div>
    <div><b>Low RNG:</b> Use low RNG for aggressive actions</div>
    <div><b>High RNG:</b> Use high RNG for aggressive actions</div>
    `,
    // alternate: 'Alternate',
    alternate_tooltip: `<span class="text-nowrap">Alternate hero position on each hand between</span> selected hero's and opponent's positions`,

    trainer_rng_visible: 'Show RNG icon',
    trainer_rng_visible_tooltip: 'Shows a dice with a random number between 0-100',

    trainer_streak_visible: 'Show winstreak icon',
    trainer_streak_visible_tooltip:
      'Tracks how many consecutive correct or incorrect decisions you make',
    // trainer_hand_frequency: 'Visible hand frequency',
    // trainer_hand_frequency_tooltip: 'TODO',
    // trainer_sounds: 'Play sounds',
    // trainer_sounds_tooltip: 'Plays classic game sounds',

    na: 'N/A',
    well_played: 'Well played',
    perfect: 'Perfect',
    perfect_help: 'GTOW Score above 75',
    // good: 'Good',
    // good_help: 'Gto score below 75 and above 10',
    inaccuracy: 'Inaccuracy',
    inaccuracy_help: 'GTOW Score below 10 and above -10',
    mistake: 'Mistake',
    mistake_help: 'GTOW Score below -10',
  },
  practice_hands: {
    average_ev_loss__avg: 'Avg. EV loss',
    average_ev_loss__sum: 'Avg. EV loss sum',
    average_ev_loss_as_pot__avg: 'AVG pot EV loss',
  },
  trainer_presets: {
    dev_cash_basic: 'DEV only - BASIC',
    dev_cash_basic_sub: 'DEV only - BASIC',
    dev_cash_complex: 'DEV only - COMPLEX',
    dev_cash_complex_sub: 'DEV only - COMPLEX',

    cash_nl50_preflop_to_river: 'Preflop to river',
    cash_nl50_preflop_to_river_sub: 'Play a full hand from preflop to river.',
    cash_nl50_bb_defence: 'BB Defence',
    cash_nl50_bb_defence_sub: 'BB facing RFI. Full hand from preflop to river.',
    cash_nl50_sb_defence: 'SB Defence',
    cash_nl50_sb_defence_sub: 'SB facing UTG-BTN open, full hand. Simple solutions (3bet/fold). ',
    cash_nl50_blind_vs_blind: 'Blind vs Blind',
    cash_nl50_blind_vs_blind_sub: 'SB vs BB. Full hand from preflop to river. Information hidden.',
    cash_nl50_ep_vs_ip_3bet: 'EP vs IP 3bet',
    cash_nl50_ep_vs_ip_3bet_sub:
      'UTG-HJ facing CO-BTN 3bet. Full hand from preflop to river. Information hidden.',
    cash_nl50_ip_vs_oop_3bet: 'IP vs OOP 3bet',
    cash_nl50_ip_vs_oop_3bet_sub:
      'UTG-BTN vs SB-BTN 3bet. Full hand from preflop to river. Information hidden.',
    cash_nl50_btn_vs_bb_srp_cbetting: 'BTN vs BB SRP - cbetting',
    cash_nl50_btn_vs_bb_srp_cbetting_sub:
      'BTN vs BB SRP. Master flop cbets in Single Spot mode. Range frequency hidden.',
    cash_nl50_ip_vs_bb_srp_wet_boards: 'IP vs BB SRP - Wet boards',
    cash_nl50_ip_vs_bb_srp_wet_boards_sub:
      'UTG-BTN vs BB, SRP. Full hand, starting on the flop. Dynamic textures.',
    cash_nl50_ip_vs_bb_srp_dry_boards: 'IP vs BB SRP - Dry boards',
    cash_nl50_ip_vs_bb_srp_dry_boards_sub:
      'UTG-BTN vs BB, SRP. Full hand, starting on the flop. Static textures.',
    cash_nl50_master_rfi: 'Master RFI',
    cash_nl50_master_rfi_sub:
      'Practice your opening ranges. 100bb raise first in. Single spot mode.',
    cash_nl50_late_position_open: 'Late Position Open',
    cash_nl50_late_position_open_sub:
      'BTN/CO RFI, 100bb. Full hand from preflop to river. Simple solutions.',
    cash_nl50_early_position_open: 'Early Position Open',
    cash_nl50_early_position_open_sub:
      'UTG/HJ RFI, 100bb. Full hand from preflop to river. Simple solutions.',
    cash_nl50_mastering_the_btn: 'Mastering the BTN',
    cash_nl50_mastering_the_btn_sub:
      'Practice preflop BTN decisions, either RFI or facing an open. Single Spot mode.',

    cash_nl500_preflop_to_river: 'Preflop to river',
    cash_nl500_preflop_to_river_sub: 'Play a full hand from preflop to river.',
    cash_nl500_bb_defence: 'BB Defence',
    cash_nl500_bb_defence_sub: 'BB facing RFI. Full hand from preflop to river.',
    cash_nl500_sb_defence: 'SB Defence',
    cash_nl500_sb_defence_sub: 'SB facing UTG-BTN open, full hand. Simple solutions (3bet/fold). ',
    cash_nl500_blind_vs_blind: 'Blind vs Blind',
    cash_nl500_blind_vs_blind_sub: 'SB vs BB. Full hand from preflop to river. Information hidden.',
    cash_nl500_ep_vs_ip_3bet: 'EP vs IP 3bet',
    cash_nl500_ep_vs_ip_3bet_sub:
      'UTG-HJ facing CO-BTN 3bet. Full hand from preflop to river. Information hidden.',
    cash_nl500_ip_vs_oop_3bet: 'IP vs OOP 3bet',
    cash_nl500_ip_vs_oop_3bet_sub:
      'UTG-BTN vs SB-BTN 3bet. Full hand from preflop to river. Information hidden.',
    cash_nl500_btn_vs_bb_srp_cbetting: 'BTN vs BB SRP - cbetting',
    cash_nl500_btn_vs_bb_srp_cbetting_sub:
      'BTN vs BB SRP. Master flop cbets in Single Spot mode. Range frequency hidden.',
    cash_nl500_ip_vs_bb_srp_wet_boards: 'IP vs BB SRP - Wet boards',
    cash_nl500_ip_vs_bb_srp_wet_boards_sub:
      'UTG-BTN vs BB, SRP. Full hand, starting on the flop. Dynamic textures.',
    cash_nl500_ip_vs_bb_srp_dry_boards: 'IP vs BB SRP - Dry boards',
    cash_nl500_ip_vs_bb_srp_dry_boards_sub:
      'UTG-BTN vs BB, SRP. Full hand, starting on the flop. Static textures.',
    cash_nl500_master_rfi: 'Master RFI',
    cash_nl500_master_rfi_sub:
      'Practice your opening ranges. 100bb raise first in. Single spot mode.',
    cash_nl500_late_position_open: 'Late Position Open',
    cash_nl500_late_position_open_sub:
      'BTN/CO RFI, 100bb. Full hand from preflop to river. Simple solutions.',
    cash_nl500_early_position_open: 'Early Position Open',
    cash_nl500_early_position_open_sub:
      'UTG/HJ RFI, 100bb. Full hand from preflop to river. Simple solutions.',
    cash_nl500_mastering_the_btn: 'Mastering the BTN',
    cash_nl500_mastering_the_btn_sub:
      'Practice preflop BTN decisions, either RFI or facing an open. Single Spot mode.',

    hucash_nl500_sb_opening: 'SB opening',
    hucash_nl500_sb_opening_sub: 'Play as SB (IP), full hand from preflop to river.',
    hucash_nl500_bb_defence_vs_bb_open: 'BB defence vs SB open',
    hucash_nl500_bb_defence_vs_bb_open_sub:
      'Play as BB facing SB open, full hand from preflop to river.',
    hucash_nl500_srp_wet_boards: 'SRP - Wet Boards',
    hucash_nl500_srp_wet_boards_sub: 'Full hand, starting on the flop. Dynamic textures.',
    hucash_nl500_srp_dry_boards: 'SRP - Dry Boards',
    hucash_nl500_srp_dry_boards_sub: 'Full hand, starting on the flop. Static textures.',

    mtt_preflop_to_river: 'Preflop to river - All stack depths',
    mtt_preflop_to_river_sub:
      'Play a full hand from preflop to river. All stack depths with limps.',
    mtt_bb_defence: 'BB Defence',
    mtt_bb_defence_sub: 'BB vs IP open. Full hand from preflop to river. All stack depths.',
    mtt_blind_vs_blind: 'Blind vs Blind',
    mtt_blind_vs_blind_sub:
      'SB vs BB, all stack depths. Full hand from preflop to river, all stack depths. Information hidden.',
    mtt_ep_10bb_push_fold: 'EP Push/Fold',
    mtt_ep_10bb_push_fold_sub: 'UTG-CO 10bb close push/fold decisions. Single Spot mode.',
    mtt_ip_vs_bb_srp_wet_boards: 'IP vs BB SRP - Wet boards',
    mtt_ip_vs_bb_srp_wet_boards_sub:
      'UTG-BTN vs BB, SRP. Full hand, starting on the flop. Dynamic textures.',
    mtt_ip_vs_bb_srp_dry_boards: 'IP vs BB SRP - Dry boards',
    mtt_ip_vs_bb_srp_dry_boards_sub:
      'UTG-BTN vs BB, SRP. Full hand, starting on the flop. Static textures.',
    mtt_full_hand_deep_stack: 'Full Hand - Deep Stack',
    mtt_full_hand_deep_stack_sub: '60bb+ full hand from preflop to river. Information hidden.',
    mtt_full_hand_mid_stack: 'Full Hand - Mid stack',
    mtt_full_hand_mid_stack_sub: '25-50bb full hand from preflop to river.',
    mtt_full_hand_short_stack: 'Full hand - Short Stack',
    mtt_full_hand_short_stack_sub: '10-20bb full hand from preflop to river.',
    mtt_late_position_open: 'Late Position Open',
    mtt_late_position_open_sub:
      'Hero RFI from CO-BTN, all stack depths. Full hand from preflop to river.',
    mtt_early_position_open: 'Early Position Open',
    mtt_early_position_open_sub:
      'Hero RFI from UTG-HJ, all stack depths. Full hand from preflop to river.',
    mtt_mastering_the_btn: 'Mastering the BTN',
    mtt_mastering_the_btn_sub:
      'Practice preflop BTN decisions, either RFI or facing an open. Single Spot mode.',

    spins_preflop_to_river: 'Preflop to River - All stack depths',
    spins_preflop_to_river_sub: 'Play a full hand from preflop to river. All stack depths.',
    spins_preflop_to_river_deep: 'Preflop to River - 25bb',
    spins_preflop_to_river_deep_sub: 'Play a full hand from preflop to river. 25bb deep.',
    spins_preflop_full_mid_stacks: 'Preflop to River - 16bb',
    spins_preflop_full_mid_stacks_sub: 'Play a full hand from preflop to river. 16bb deep.',
    spins_btn_push_fold_decisions: 'BTN Push/Fold',
    spins_btn_push_fold_decisions_sub: '2-8bb push/fold decisions on the BTN.',
    spins_sb_push_fold_decisions: 'SB Push/Fold',
    spins_sb_push_fold_decisions_sub: '2-8bb push/fold decisions in the SB.',
    spins_bb_defence: 'BB Defence',
    spins_bb_defence_sub:
      'BB facing limp or RFI. All stack depths. Full hand from preflop to river. Information hidden.',
    spins_btn_vs_bb_srp: 'BTN vs BB, SRP',
    spins_btn_vs_bb_srp_sub: 'SB vs BB, SRP 12bb+. Play starts on the flop.',
    spins_sb_vs_bb_srp: 'SB vs BB, SRP',
    spins_sb_vs_bb_srp_sub: 'SB vs BB, SRP 12bb+. Play starts on the flop.',
    spins_bvb_iso: 'SB vs BB ISO',
    spins_bvb_iso_sub: 'SB vs BB, Limp-Raised pots, 12bb+, Play starts on the flop.',
    spins_bvb_limped_pots: 'SB vs BB Limped Pot',
    spins_bvb_limped_pots_sub: 'SB vs BB, Limped pots, 12bb+. Play starts on the flop.',

    husng_sb_preflop_to_river: 'Preflop to River',
    husng_sb_preflop_to_river_sub: 'Play a full hand from  preflop to river. 8bb+ stacks',
    husng_bb_defence: 'BB Defence',
    husng_bb_defence_sub: 'BB facing SB RFI',
    husng_bb_vs_limp: 'BB vs Limp',
    husng_bb_vs_limp_sub:
      'BB facing limp. Play a full hand from preflop to river. 6bb+ stacks. Information hidden.',
    husng_push_fold: 'Push/Fold',
    husng_push_fold_sub: 'SB push/fold, 2-6bb, single spot mode.',
    husng_limped_pots_wet_boards: 'Limped pots - Wet Boards',
    husng_limped_pots_wet_boards_sub:
      'Play a full hand, starts on the flop, limped pot, 10bb+, dynamic textures',
    husng_limped_pots_dry_boards: 'Limped pots - Dry Boards',
    husng_limped_pots_dry_boards_sub:
      'Play a full hand, starts on the flop, limped pot, 10bb+, static textures',
  },
  fairplay: {
    copy_id_to_clipboard: 'Copy ID to clipboard',
    id_copied_to_clipboard: 'ID copied to clipboard',
    copy_email_to_clipboard: 'Copy email to clipboard',
    email_copied_to_clipboard: 'Email copied to clipboard',
    title: 'Fair Play',
    fair: 'Fair',
    play: 'Play',
    choose_cards_first: 'Choose cards first',
    pick_a_date_tooltip: 'Pick a date',
    // 007 add br so one line one message
    // 007 rename to subtitle cos its subtitle
    subtitle: `Join hands in preserving the integrity of the games. <br> Together, let's ensure their purity.`,
    try_button: 'Try Fair Play',
    learn_more: 'Learn more',
    our_actions: 'Our actions and endeavors',
    select_cards: `01.<br>Select cards`,
    nospot: { title: 'NO SPOT FOUND' },
    spot_found: 'Spot found',
    spot_found_subtitle_tra01: `
      If you find <b>multiple results</b> matching the details of hand histories, contact your poker
      room's integrity department. <br>
      Give them the spot IDs and hand histories, and ask them to email us at
      <a
        class="link-underline link-underline_hover"
        href="{mailto}"
        >{email}</a
      >.
    `,
    spot_found_subtitle_note: `Please note that false positives may arise.
      Avoid making judgments until the poker operators complete their investigations.
      Observers might have made these lookups. After connecting with operators, we will do our best to provide assistance when requested.`,
    spot_not_found: 'Spot not found',
    spot_not_found_subtitle: 'There is no match for this spot.',
    id: 'id',
    timestamp: 'Timestamp',
    lookup_limit_exceeded: 'Lookup limit exceeded',
    lookup_limit_exceeded_subtitle: 'You have exceeded the limit of {num} lookups per day.',
    article: `Read more about our {vision} on  <span class='text-nowrap' style='color: var(--clr-primary)'> Fair play </span>`,
    // article: 'Want to know more? Read more about our {vision} on ',
    actions: [
      {
        title: 'Integration with poker sites',
        text: 'We are helping poker operators foster a secure gaming environment that players can trust.',
      },
      {
        title: 'Delays',
        text: 'Our built-in delays prevent users from abusing our platform.',
      },
      {
        title: 'Security protection',
        text: 'We have in-house security measures to make sure that GTO Wizard is used as intended.',
      },
      {
        title: 'Fair Play Check',
        text: 'We are empowering players in our fight against cheating.',
      },
      {
        title: 'No {tooltip} access',
        text: 'Safeguarding our technology to ensure a fair playing field for all.',
        tooltip:
          'Software intermediary that allows two applications to communicate with each other.',
      },
      {
        title: 'Custom GTO reports',
        text: 'Detect superhuman plays with detailed reports from your hand histories.',
      },
    ],
    spot_tooltips: {
      id: 'This is a unique Spot ID referencing the solution.',
      board: 'Board cards solved',
      date: 'Date when solved',
      time: 'Time when solved',
      format: 'Game format',
      stacks: 'Preflop stack sizes from UTG to BB',
      stacks_ai: 'OOP and IP starting stack sizes, (OOP stack + IP stack + Pot)/2',
      pot: 'Pot size at beginning of searched street',
      oop: `Out of position player's seat`,
      ip: `In position player's seat`,
    },
    spot_tooltips_custom:
      'Positions are not displayed for custom solutions created with GTO Wizard AI. User-defined ranges render positional labels unreliable for solutions generated with GTO Wizard AI.',
    // in swiftly identifying and preventing instances of dishonest play and collusion.
    integration: {
      title: 'Integration with poker sites',
      text: `Through our proactive measures and <b style="color:var(--txt-b-clr)">cutting-edge technology</b>, we assist operators
      in swiftly identifying and preventing dishonest play and collusion. <br><br>
      This in-depth approach not only <b style="color:var(--txt-b-clr)">safeguards the game's authenticity</b>, but also nurtures a secure online poker environment
      where players can confidently engage, knowing that the odds are in their favor and the playing field remains level for all.`,
    },
    partners: 'We work with',
    contacts_for_sites: 'Contacts for sites',
    fairplay: {
      title: 'Fair Play Check',
      // text: `<b style="color:var(--txt-b-clr)">Verify whether a particular board has been solved</b> using GTO Wizard <b style="color:var(--txt-b-clr)">within the past 7 days</b>.
      // <br> In case of a match, the exact time of the calculation (in your local time) is provided.`,
      // text: `With this tool, you can verify whether a particular board has been solved using GTO Wizard <b style="color:var(--txt-b-clr)">within the past 7 days</b>.
      text: ` <b style="color:var(--txt-b-clr)">Verify</b> whether a  <b style="color:var(--txt-b-clr)">particular board</b> has been solved using GTO Wizard <b style="color:var(--txt-b-clr)">within the past 7 days</b>.
      <br> In case of a match, the exact time of the calculation (in your local time) is provided.`,
    },
    about: {
      title: 'About GTO Wizard',
      text: `From its inception, <b style="color:var(--txt-b-clr)">GTO Wizard</b> has been dedicated to offering players an efficient method of studying poker. <br>
       Frustrated by the technical knowledge and expensive hardware required for poker study, we took the initiative to develop
       <b style="color:var(--txt-b-clr)">the ultimate all-in-one poker study tool</b> for players of all levels to step up their game. <br> <br>
         In light of the current popularity of GTO Wizard and the substantial financial incentives associated with the abuse of poker
         studying software, we aim to <b style="color:var(--txt-b-clr)"> provide the means to proficiently combat online cheating</b>. <br><br>
         <b style="color:var(--txt-b-clr)">By partnering with online poker operators</b> and through our state-of-the-art technology, we aspire to beneficially impact
          the poker industry and set a precedent for other stakeholders in the poker community.`,
    },
    confirm: 'Confirm',
    reset: 'Reset',
    tooltip: 'Tooltip',
    pick_a_date: `02.<br> Pick a Date`,
    picker_info: 'Find matches within <b>±{minutes} minutes</b> of the selected date and time.',
  },
  coachings: {
    title: 'Coaching',
    our_coaches: 'Our coaches',
    subtitle: 'Weekly coaching with the best pros',
    upcoming_coachings: 'Upcoming coaching',
    // previous_coachings: 'Previous coachings',
    upcoming_coachings_short: 'Upcoming',
    previous_coachings_short: 'Previous',
    time_message: 'Times are in CEST - dates and times are subject to change.',
    link_message: 'Link will be available after countdown',
    link_message_before_start: 'Link will be available before the start.',
  },
  coaches: {
    sergii_levchenko: {
      fullname: `Sergii Levchenko`,
      name_nick: `Sergii Levchenko (Jayser1337)`,
      nick: `Jayser1337`,
      bio: `Sergii started his journey in 2011.
       In 2014, he started playing NL5k cash games and within a few years ascended to nosebleed stakes, playing up to NL40k.
        Remarkably, he earned his first million before the age of 25.
      Since 2015, Sergii has been a sought-after coach, providing expert guidance to both Russian and English-speaking players.
       His deep dedication to the game and strategic acumen have established him as a highly respected figure in the community.`,
    },
    kevin_rabichow: {
      fullname: `Kevin Rabichow`,
      name_nick: `Kevin Rabichow`,
      nick: `Kevin Rabichow`,
      bio: `His journey began in 2005 while earning an economics degree at the University of Chicago. In 2011, he moved to Toronto to play full-time, excelling in high-stakes HU games. Kevin became a RIO Elite coach in 2014, and has played over two million hands online, earning over $1 million in cash game profits and cashing over $5 million in tournaments. From 2015 to 2017, he coached students to achieve over $500k in earnings.`,
    },
    espen_jorstad: {
      fullname: `Espen Jørstad`,
      name_nick: `Espen Jørstad`,
      nick: `Espen Jørstad`,
      bio: `Espen Jørstad is a renowned Norwegian MTT specialist. He marked his place by winning the WSOP Main Event in 2022, securing a $10,000,000 prize.
       His career is distinguished by two WSOP bracelets and by leading position on Norway's all-time money list with live earnings exceeding $15,042,000.
       His triumphs have solidified his status as one of the game's premier talents.`,
    },
    stoyan_obreshkov: {
      fullname: 'Stoyan Obreshkov',
      name_nick: 'Stoyan Obreshkov (Stoyan)',
      nick: 'Stoyan',
      bio: `Stoyan has been playing MTTs since 2015.
            He worked his way up from micro to high stakes both live and online,
            amassing millions in cashes, including a final table of the WSOP Main Event in 2020.
            Stoyan has been coaching for 5 years and is currently a coach in RIO Elite and CNC.
            He employs a practical style that balances theory with the exploitation of
            population tendencies and places high value on the mental game.`,
    },
    manuel_phemo: {
      fullname: `Manuel`,
      name_nick: `Manuel`,
      nick: `Phemo`,
      bio: `Manuel AKA 'Phemo' is a high-stakes MTT player and coach with an M.Sc. in Business Administration,
      utilizes his business insights to employ a data-driven methodology and streamlined GTO strategies.
       This approach ensures his students gain a deep comprehension of the core strategy principles.`,
    },
    thewakko: {
      fullname: `Rene Kuhlman`,
      name_nick: `Rene Kuhlman (TheWakko)`,
      nick: `TheWakko`,
      bio: `Rene is the founder and head coach of one of the biggest cash game programs in the world and a high-stakes cash game player.
           TheWakko specializes in tactical play, seeking to understand the "why" behind GTO through an
           exploitative lens.`,
    },
    poker_giraffe: {
      fullname: `Qing Yang`,
      name_nick: `Qing Yang`,
      nick: `Qing Yang`,
      bio: `QY is a RIO Elite Coach, GTO theory connoisseur, former high stakes cash game player,
           YouTuber, and full-time coach. As of today, he's worked with more than 100 students across all
           formats, and his RIO videos are among the most well-received on the site. QY specializes in
           teaching underlying concepts that drive fundamental theory.`,
    },
    yolan_cohen: {
      fullname: `Yolan Cohen`,
      name_nick: `Yolan Cohen`,
      nick: `Yolan Cohen`,
      bio: `At just 22 years old, Yolan Cohen is one of the world's youngest high-stakes crushers, excelling in live and online arenas.
       Renowned for his extraordinary cognitive abilities, Yolan held a world record in image memorization and an eidetic memory, skills he leverages to dominate the table.
       Yolan's creative coaching style uses theoretical principles to build practical exploitative strategies.`,
    },
    matt_hunt: {
      fullname: `Matt Hunt`,
      name_nick: `Matt Hunt (Matt Hunt)`,
      nick: `Matt Hunt`,
      bio: `Matt Hunt is a seasoned professional and coach based in Las Vegas, with over a decade of experience coaching more than 200 students.
       He specializes in MTTs but also plays cash games. He is a prolific content creator, having authored numerous articles and produced hundreds of hours of strategy videos.
        Matt's coaching approach combines theoretical concepts with practical simplification, particularly for live game.`,
    },
    donk_orleone: {
      fullname: `Sergio`,
      name_nick: `Sergio (Donk Orleone)`,
      nick: `Donk Orleone`,
      bio_tra01: `Sergio, AKA Donk Orleone, is a high-stakes cash game professional with a passion for coaching.
            He combines a deep theoretical knowledge with practical exploits shaped by years of studying solvers
            and mass data analysis.`,
    },
    tombos: {
      fullname: `Tom`,
      name_nick: `Tom (Tombos21)`,
      nick: `Tombos21`,
      bio: `Tombos21 is GTO Wizard's head content creator, best known for his renowned theoretical
           knowledge on 2+2. Tom writes the Daily Dose of GTO, as well as the theory articles and
           YouTube videos. His unique coaching style is informed by the scientific method, as he seeks to
           understand theory through experimentation rather than memorization.`,

      // bio: `Tombos21 is GTO Wizard head content creator, best known for his renowned theoretical
      //      knowledge on 2+2. His unique coaching style is informed by the scientific method, as he seeks to
      //      understand theory through experimentation rather than memorization.`,
    },
    saulo_costa: {
      fullname: `Saulo Costa`,
      name_nick: `Saulo Costa (sauloCosta10)`,
      nick: `sauloCosta10`,
      bio: `Saulo started his career in 2016 and quickly traversed the toughest zoom limits up to NL2K.
            He's a Run It Once Elite NLHE Coach, founder of the biggest Brazilian stable, and head coach of GTO Wizard since 2021.
            `,
    },
    mathias_maasberg: {
      fullname: `Mathias Maasberg`,
      name_nick: `Cashcid Linc (Mathias Maasberg)`,
      nick: `Cashcid Linc`,
      bio: `Mathias (AKA Cashcid Linc) is an experienced professional in the world of multi-table tournaments,
       having achieved consistent success in high-stakes, as well as low and mid-stakes events.
       His coaching approach blends game theory, mindset, ICM, and player tendency analysis.`,
    },
    sido: {
      fullname: `Sido_obc`,
      name_nick: `Sido (Sido_obc)`,
      nick: `Sido`,
      bio: `Sido co-founder and head coach of Team Bas Poker: Spin & Go School,
      is a seasoned poker pro with over a decade of experience, having  already played close to 200,000 spins.
      He currently competes in some of the toughest lineups on a daily basis, specializing in
      deep stat analysis, exploitative play and adaptions vs different recreational player profiles.
      `,
    },
    beldarion: {
      fullname: `Beldarion`,
      name_nick: `Beldarion (Beldarion)`,
      nick: `Beldarion`,
      bio: `Beldarion is co-founder and head coach of Team Bas Poker: Spin & Go School, brings close to two decades of professional
       poker experience and 1500+ hours of Spin & Go coaching worldwide. His expertise lies in GTO Theory, population tendencies,
        and maximizing EV against recreational players.`,
    },
    vanja: {
      fullname: `Vanja`,
      name_nick: `Vanja`,
      nick: `Vanja`,
      bio: `Vanja, a 24-year-old professional player from Germany, has built a strong reputation in the strategy game community.
      Beyond competing, Vanja is passionate about coaching and has contributed to GTO Wizard through insightful articles and active
      engagement in the Discord community. They also played a key role in developing Pairrd Cashgame, showcasing their deep understanding
      of strategy and game theory.`,
    },
  },
  // payouts: {
  //   // ft: '1000 players <span style="font-size:var(--span-size)">(Final table only)</span>',
  //   ft_01: '1000 players',
  //   ft_sub: 'Final table only',
  //   // _2t: '200 players <span style="font-size:var(--span-size)">(Other phases)</span>',
  //   _2t_01: '200 players',
  //   _2t_sub: 'Other phases',
  //   num_way: '{n} way',
  //   pko: 'PKO<br>200 players',
  //   pko_sub: 'All phases',
  //   show_payouts_in: 'Show payouts in:',
  //   p200_mtt: 'MTT<br>200 players',
  //   p1000_mtt: 'MTT<br>1000 players',
  //   p1000_ft: 'MTT - Final table<br>1000 players',
  //   p1000_pko: 'PKO<br>1000 players',
  // },
  payouts_dialog: {
    players200: {
      mtt: 'MTT<br>200 players',
      pko: 'PKO<br>200 players',
    },
    players1000: {
      mtt: 'MTT<br>1000 players',
      pko: 'PKO<br>1000 players',
    },
    show_payouts_in: 'Show payouts in:',
  },
  loading_tips: {
    _1: `Aborting air`,
    _2: `Accelerating all-ins`,
    _3: `Accumulating action cards`,
    _4: `Accumulating average strategy`,
    _5: `Acquiring aggression factor`,
    _6: `Activating all-in strategies`,
    _7: `Actualizing alpha`,
    _8: `Administering advanced strategies`,
    _9: `Advancing adaptive strategies`,
    _10: `Advancing aggressive adjustments`,
    _11: `Amplifying ace-high plays`,
    _12: `Analyzing all-ins`,
    _13: `Analyzing alternative actions`,
    _14: `Analyzing range asymmetries `,
    _15: `Anticipating adjustments`,
    _16: `Assembling abstractions`,
    _17: `Assembling advanced analytics`,
    _18: `Augmenting ante strategies`,
    _19: `Balancing blast-offs`,
    _20: `Balancing blind play`,
    _21: `Banning bad bluffs`,
    _22: `Battling bet sizing errors`,
    _23: `Betting balanced ranges`,
    _24: `Binding backdoors`,
    _25: `Bluffing blockers`,
    _26: `Bolstering big blind defense`,
    _27: `Bolstering blockers`,
    _28: `Boosting bb/100`,
    _29: `Brainstorming bet-sizing`,
    _30: `Brewing balance`,
    _31: `Brewing brilliant bluffs`,
    _32: `Browsing block-bets`,
    _33: `Building back-raise strategies`,
    _34: `Building bluff-catchers`,
    _35: `Bullying blockers`,
    _36: `Bypassing bad beats`,
    _37: `Calculating card removal`,
    _38: `Calibrating cumulative calling ranges`,
    _39: `Cementing continuation bets`,
    _40: `Checking check-calls`,
    _41: `Composing calling ranges`,
    _42: `Comprehending continuation bets`,
    _43: `Conceiving check-raises`,
    _44: `Concocting calls`,
    _45: `Constituting clairvoyant click-backs`,
    _46: `Consulting the wizardly scrolls`,
    _47: `Contacting the oracle`,
    _48: `Contemplating counterfactual regrets`,
    _49: `Contriving community cards`,
    _50: `Cooloring combo draws`,
    _51: `Cracking Aces`,
    _52: `Crafting cold-call ranges`,
    _53: `Creating C-bets`,
    _54: `Crunching combinations`,
    _55: `Cultivating cold-calls`,
    _56: `Curtailing coolers`,
    _57: `Customizing calling frequencies`,
    _58: `Deciphering dominated strategies`,
    _59: `Deciphering double barrels`,
    _60: `Decoding double-barrels`,
    _61: `Deconstructing dicey boards`,
    _62: `Defending drawing hands`,
    _63: `Deleting dominated strategies`,
    _64: `Demystifying dominated hands`,
    _65: `Designing donk bets`,
    _66: `Developing disciplined folds`,
    _67: `Devising delayed bluffs`,
    _68: `Devising drawing hands`,
    _69: `Diminishing downswings`,
    _70: `Discovering dominant draws`,
    _71: `Dissecting down-bets`,
    _72: `Elevating equity denial`,
    _73: `Eliminating exploitable equlibria`,
    _74: `Enforcing effective stacks`,
    _75: `Estimating expected value`,
    _76: `Evaluating equity`,
    _77: `Examining equity realization`,
    _78: `Examining exploits`,
    _79: `Fabricating face cards`,
    _80: `Factoring fold equity`,
    _81: `Filtering out fishy plays`,
    _82: `Fine-tuning floating frequencies`,
    _83: `Fine-tuning flop textures`,
    _84: `Finessing flush draws`,
    _85: `Fixing flop frequencies`,
    _86: `Forging fold equity`,
    _87: `Forging four-flush boards`,
    _88: `Forging full houses`,
    _89: `Forming fixed strategy`,
    _90: `Formulating fast plays`,
    _91: `Formulating flop textures`,
    _92: `Framing fold frequencies`,
    _93: `Gathering game theory insights`,
    _94: `Gauging game-flow factors`,
    _95: `Gauging gutshot probabilities`,
    _96: `Gauging gutshot straights`,
    _97: `Generating game trees`,
    _98: `Generating GTO`,
    _99: `Gloating flop bets`,
    _100: `Grabbing geometric bet size`,
    _101: `Grasping game tree complexity`,
    _102: `Grinding game theory optimal strategies`,
    _103: `Grinding game tree`,
    _104: `Guarding against gutshots`,
    _105: `Handling high card strategy`,
    _106: `Handling hole cards`,
    _107: `Harmonizing heads-up strategies`,
    _108: `Harnessing high card value`,
    _109: `Harvesting hero calls`,
    _110: `Honing heaters`,
    _111: `Hunting high-equity plays`,
    _112: `Hypothesizing hero folds`,
    _113: `Identifying implied odds`,
    _114: `Igniting implied odds`,
    _115: `Implementing ICM pressure`,
    _116: `Incorporating incomplete information`,
    _117: `Inducing bluffs`,
    _118: `Initiating in-position advantage`,
    _119: `Instituting in-position checks`,
    _120: `Intensifying implied odds`,
    _121: `Investigating indifference regions`,
    _122: `Isolating isomorphs`,
    _123: `Judging jam frequencies`,
    _124: `Justifying jams`,
    _125: `Juxtaposing junk cards`,
    _126: `Keeping kickers in check`,
    _127: `Kickstarting kicker considerations`,
    _128: `Kickstarting king-high bluffs`,
    _129: `Launching late position plays`,
    _130: `Launching leads`,
    _131: `Legitimizing laydowns`,
    _132: `Leveraging LAGs`,
    _133: `Leveraging leads`,
    _134: `Leveraging low pairs`,
    _135: `Leveraging positional advantage`,
    _136: `Limiting leaks`,
    _137: `Liquidating loose strategies`,
    _138: `Localizing linear ranges`,
    _139: `Mastering middle pair`,
    _140: `Mastering multi-street maneuvers`,
    _141: `Maximizing minimum defense frequency`,
    _142: `Maximizing monsters`,
    _143: `Measuring M-Ratio`,
    _144: `Merging middle pairs`,
    _145: `Milking middling cards`,
    _146: `Minimizing marginal mistakes`,
    _147: `Minimizing multi-street bluffs`,
    _148: `Mining sets`,
    _149: `Mixing strategies`,
    _150: `Mobilizing made hands`,
    _151: `Moderating mucks`,
    _152: `Nailing nutted hands`,
    _153: `Navigating narrow ranges`,
    _154: `Navigating nitty nuances`,
    _155: `Navigating nodes`,
    _156: `Navigating nut-flush draws`,
    _157: `Negotiating Nash Equilibrium`,
    _158: `Neutralizing negative EV plays`,
    _159: `Neutralizing negative free rolls`,
    _160: `Neutralizing nemesis strategies`,
    _161: `Neutralizing nut advantage`,
    _162: `Normalizing nutted hands`,
    _163: `Nullifying nut flush draws`,
    _164: `Obliterating overpairs`,
    _165: `Optimizing AK`,
    _166: `Optimizing bet sizes`,
    _167: `Optimizing open-enders`,
    _168: `Optimizing overcards`,
    _169: `Orchestrating over-the-top bluffs`,
    _170: `Orchestrating overbets`,
    _171: `Organizing outs`,
    _172: `Outlining optimal plays`,
    _173: `Perceiving positional advantage`,
    _174: `Perfecting pocket pairs`,
    _175: `Perfecting polarized ranges`,
    _176: `Performing passive exploitation`,
    _177: `Playing pocket pairs proficiently`,
    _178: `Polishing payoff matrices`,
    _179: `Pondering pot control`,
    _180: `Preparing pure strategies`,
    _181: `Preserving pot odds`,
    _182: `Propelling positional plays`,
    _183: `Punishing poor plays`,
    _184: `Pushing probe bets`,
    _185: `Qualifying your equity`,
    _186: `Quantifying quads`,
    _187: `Quantifying quality bluffs`,
    _188: `Quashing questionable calls`,
    _189: `Reading river bluffs`,
    _190: `Realizing range advantage`,
    _191: `Recommending reraises`,
    _192: `Reconciling rake`,
    _193: `Rectifying range imbalances`,
    _194: `Redesigning river strategies`,
    _195: `Refining rake calculations`,
    _196: `Refining range assessments`,
    _197: `Reversing implied odds`,
    _198: `Revising river strategies`,
    _199: `Scrutinizing shoves`,
    _200: `Sculpting SPR`,
    _201: `Searching streets`,
    _202: `Setting up subgames`,
    _203: `Shaping showdown value`,
    _204: `Shuffling straddles`,
    _205: `Simplifying betting tree`,
    _206: `Solidifying shortstack strategies`,
    _207: `Solving showdown frequencies`,
    _208: `Spawning semi-bluffs`,
    _209: `Strategizing suited connectors`,
    _210: `Streamlining straights`,
    _211: `Summoning equilibrium`,
    _212: `Tailoring tight-aggressive play`,
    _213: `Taming tilt triggers`,
    _214: `Taming top pairs`,
    _215: `Terminating tells`,
    _216: `Testing tilt triggers`,
    _217: `Tip - Check out our study plans to learn GTO`,
    _218: `Tip - Compare hand classes using the ranges tab`,
    _219: `Tip - Group aggregate flops by high card to easily analyze data`,
    _220: `Tip - Open Strategy+EV view to see EV of actions with hands`,
    _221: `Tip - Premium members get access to weekly coaching with pros`,
    _222: `Tip - Press 'B' to draw on GTO Wizard`,
    _223: `Tip - Press 'F' to enter focus mode`,
    _224: `Tip - Press 'G' to reset the hand history`,
    _225: `Tip - Press 'J' to open shortcuts`,
    _226: `Tip - Press 'M' to open saved spots`,
    _227: `Tip - Press 'P' to clear filters`,
    _228: `Tip - Press 'Q' to go fullscreen`,
    _229: `Tip - Press 'S' to group actions together`,
    _230: `Tip - Press 'Shift + Arrow' to change board cards`,
    _231: `Tip - Press 'Space + Shift' to toggle EV in bb and pot share`,
    _232: `Tip - Press 'Spacebar' to toggle bb and % pot`,
    _233: `Tip - Press Up or Down arrows to switch solutions`,
    _234: `Tip - Select Preflop Only cash ranges to see many different rake structures`,
    _235: `Tip - Select the practice mode icon to practice this spot`,
    _236: `Tip - Sort the summary tab by EV to find nutted hands`,
    _237: `Tip - Use '1234' hotkeys to switch between strategy tabs`,
    _238: `Tip - Use aggregate reports to find bet sizing trends`,
    _239: `Tip - Use filtering to analyze range construction`,
    _240: `Tip - Use horizontal view to see suits more easily`,
    _241: `Tip - Use the blockers tab to see card removal effects`,
    _242: `Tip - Use the breakdown tab to analyze value thresholds`,
    _243: `Tip - Use the compare EV function to see what actions are preferred`,
    _244: `Tip - You can change the stack depth with custom solving`,
    _245: `Tip - You can copy ranges from the ranges tab`,
    _246: `Tip - You can customize your colors in settings`,
    _247: `Tip - You can edit nodes with custom solving`,
    _248: `Tip - You can edit ranges with custom solving`,
    _249: `Tip - You can modify bet sizes with custom solving`,
    _250: `Tip - You can optimize bet sizes with custom solving`,
    _251: `Tip - You can use dynamic mode to automatically optimize bet sizes`,
    _252: `Tip - You can use turn reports to analyze runouts`,
    _253: `Transforming textures`,
    _254: `Trapping turned trips`,
    _255: `Traversing terminal nodes`,
    _256: `Triple-range-merging`,
    _257: `Tuning tournament structures`,
    _258: `Tuning trembling hand perfect equilibrium`,
    _259: `Tweaking top-pair decisions`,
    _260: `Uncovering uncapped ranges`,
    _261: `Uncovering utility functions`,
    _262: `Unearthing unexploitable folds`,
    _263: `Unleashing unexpected check-raises`,
    _264: `Unloading underpairs`,
    _265: `Unraveling unique equilibriums`,
    _266: `Unveiling unblockers`,
    _267: `Utilizing unexploitable strategies`,
    _268: `Utilizing utility theory`,
    _269: `Validating value bets`,
    _270: `Verifying variance`,
    _271: `Vetting value bets`,
    _272: `Visualizing variance`,
    _273: `Warding off weak strategies`,
    _274: `Withstanding wet boards`,
    _275: `Working wheel draws`,
  },
  hhv3: {
    tooltips: {
      played_at: 'The date range the hand was played.', // Date
      total_pot: 'Maximum pot size reached during the hand.', // Pot
      game_format: 'Type of game (e.g. Cash, MTT, Spin & Go).', // Game format
      player_hand: `Filter hands by selecting a specific range of hero's hole cards.`,
      site: 'The poker site where the hand was played.', // Site
      blinds: 'Filter by the size of the blinds.', // Blinds
      game_table: 'Filter by the number of players dealt into the hand, e.g. HU, 6-max, 9-max.', // Game table
      pot_type: 'Filter hands based on the amount of preflop raising.', // Preflop action
      big_blind: 'The size of the big blind.', // Big blind - dev only filter
      player_relative_position: 'Filter hands by whether Hero is in or out of position postflop.',
      tournament_id: 'Filter hands by the ID of the tournament you played in.',
      relative_position: 'Filter hands by whether Hero is in or out of position postflop.',
      opponent_position: 'Filter hands by the position of the opponent.',
      player_aggression_preflop: 'Indicates whether Hero was the preflop raiser or caller.',
      hero_went_postflop:
        'True if Hero voluntarily put money into the pot (VPIP), and saw the flop.',
      player_nickname: `The player's username on the site, AKA their nickname.`, // Nickname
      alias: `The player's username on the site, AKA their nickname.`,
      player_position: 'The seat of the player from UTG to BB.',
      total_ev_loss:
        'The total EV loss in big blinds per hand, compared to playing GTO.<br/>{linkText}', // EV Loss (bb)
      player_winloss: 'The actual amount of big blinds won or lost in the hand.<br/>{linkText}', // Win/Loss (bb)
      avg_gto_score: 'The average GTOW score of all hero actions in the hand.<br/>{linkText}', // GTO Result
      total_ev_loss_as_pot:
        'The total EV loss divided by the maximum size of the pot.<br/>{linkText}', // EV Loss (Pot%)
      avg_frequency_difference:
        'A higher number indicates you’re taking low-frequency lines more often.<br/>{linkText}', // Frequency difference%
      hand_correctness:
        'The least accurate move made in the hand, ranked from blunder to best move.<br/>{linkText}', // GTO Score%
      solution_status:
        'Use this to filter out hands that couldn’t be analyzed properly.<br/>{linkText}', // Status
      file_original_name:
        'The file or folder name used for the upload. This typically corresponds to a specific session or tournament.', // File name
      source: 'The source of which the hand was analyzed from.', // Source
      color_hex: 'A color tag that is picked by you to highlight and organize your hands!',
      flop_action_sequence: 'The sequence of actions taken on the flop.', // Flop Line - Actions Sequence:
      turn_action_sequence: 'The sequence of actions taken on the turn.', // Turn Line - Actions Sequence:
      river_action_sequence: 'The sequence of actions taken on the river.', // River Line - Actions Sequence:
      preflop_game_depth: `Player's preflop effective stack used in solution`,
      manage_columns: 'Manage columns',
      add_filters: 'Add filters',
      show: 'Show',
      hide: 'Hide',
      drag: 'Drag',
      view_these_hands: 'View these hands',
    },
    table_head: {
      actions_with_correctness: 'Actions',
      avg_ev_loss:
        '<span class="text-nowrap">Avg. EV</span> <span class="text-nowrap">loss (bb)</span>',
      avg_ev_loss_as_pot: '<span class="text-nowrap">EV loss</span> pot%',
      avg_frequency_difference: 'Frequency difference%',
      avg_gto_score: 'GTO Score%',
      big_blind: 'Big blind',
      blinds: 'Blinds',
      boards: 'Board',
      file_original_name: 'File name',
      game_format: 'Game format',
      game_rake: 'Rake',
      game_table: 'Game table',
      hand_correctness: 'GTO Result',
      hero_hand: 'Hero hand',
      played_at: 'Date',
      player_nickname: 'Nickname',
      player_position: 'Player position',
      player_winloss: 'Win/Loss (bb)',
      pot_type: 'Preflop action',
      site: 'Site',
      small_blind: 'Small blind',
      solution_status: 'Status',
      total_pot: 'Pot',
      player_hand: 'Hand',
      player_aggression_preflop: 'Aggression preflop (Hero)',
      hero_went_postflop: 'Hero went postflop',
      tournament_id: 'Tournament ID',
      player_relative_position: 'Relative position',
      opponent_position: 'Opponent position',
      total_ev_loss: 'EV Loss(BB)',
      total_ev_loss_as_pot: 'EV Loss(Pot%)',
      file_id: 'Filename',
      source: 'Source',
      color_hex: 'Color tags',
      flop_action_sequence: 'Flop Line',
      turn_action_sequence: 'Turn Line',
      river_action_sequence: 'River Line',
      preflop: 'Pre-flop',
      preflop_game_depth: 'Preflop depth',
      flop: 'Flop',
      turn: 'Turn',
      river: 'River',
    },
    filter_management_title: 'Set Your Filter Bar',
    search_filter: 'Search filter',
    statuses: {
      OK: 'Fully Solved',
      SPOT_NOT_SUPPORTED: 'Spot not supported',
      STACK_NOT_SUPPORTED: 'Stack not supported',
      NO_GTO_SOLUTION: 'No solution',
      UNSUPPORTED_PLAYERS: 'Unsupported players',
      ZERO_PERCENT_ACTION: 'Zero percent action',
      ERROR: 'Error',
      LIMIT_REACHED: 'Limit reached',
      PROCESSING: 'Processing',
    },
    filter: {
      boolean: {
        true: 'Yes',
        false: 'No',
      },
      actions_sequence: {
        title: 'Action Sequence:',
        import: {
          title: 'Import Action Sequence',
          label: 'Action Sequence',
          success: 'Action Sequence imported successfully!',
          error: 'Invalid Action Sequence!',
        },
        export: {
          title: 'Export Action Sequence',
          message: 'Copied Action Sequence to clipboard!',
        },
        repeat_from: 'Repeat from {street}',
        repeat_on: 'Repeat on {street}',
        clear: 'Clear filter content',
        ANY: 'Any',
        CHECK: 'Check',
        FOLD: 'Fold',
        CALL: 'Call',
        RAISE: 'Raise',
        BET: 'Bet',
        B_ANY: '{bet_type} <span class="text-smallest">Any</span>',
        B_SMALL: '{bet_type} <span class="text-smallest">Small</span>',
        B_MEDIUM: '{bet_type} <span class="text-smallest">Medium</span>',
        B_LARGE: '{bet_type} <span class="text-smallest">Large</span>',
        B_OVERBET: '{bet_type} <span class="text-smallest">Overbet</span>',
        btn_line: {
          ANY: 'Any',
          CHECK: 'X',
          FOLD: 'F',
          CALL: 'C',
          BET: '{bet_type}  <span class="text-smallest">Any</span>',
          SMALL: '{bet_type} <span class="text-smallest">S</span>',
          MEDIUM: '{bet_type} <span class="text-smallest">M</span>',
          LARGE: '{bet_type} <span class="text-smallest">L</span>',
          OVERBET: 'OB',
        },
        selected_items: {
          ANY: '?',
          CHECK: 'X',
          FOLD: 'F',
          CALL: 'C',
          BET: '{bet_type}',
          SMALL: '{bet_type}S',
          MEDIUM: '{bet_type}M',
          LARGE: '{bet_type}L',
          OVERBET: 'OB',
        },
      },
    },
    filter_bar: {
      flop_action_sequence: 'Flop Line - Actions Sequence:',
      turn_action_sequence: 'Turn Line - Actions Sequence:',
      river_action_sequence: 'River Line - Actions Sequence:',
    },
    find_report: 'Find Report',
    add_table: 'Add Table',
    all_streets: 'All streets',
    preflop: 'Preflop',
    flop: 'Flop',
    turn: 'Turn',
    river: 'River',
    score_breakdown_count_moves: 'Score Breakdown - Count moves',
    moves: 'Moves',
    remove_filter: 'Remove filter',
    add_filter: 'Add filter',
    add_filters: 'Add filters',
    add_to_saved_reports: 'Add to saved reports',
    save_changes: 'Save Changes',
    manage_columns: 'Manage columns',
    manage_filters: 'Manage filters',
    filters: 'Filters',
    columns: 'Columns',
    create_new_report: 'Create New Report',
    new_report: 'New Report',
    rename_report: 'Rename Report',
    report_name: 'Report Name',
    tag: 'Tag',
    reports: 'Reports',
    name: 'Description',
    last_viewed: 'Last Viewed',
    tags: 'Tags',
    details: 'Details',
    gto_score: 'GTO Score',
    top_num_player: 'Top {num}% player',
    avg_ev_loss: 'Avg EV Loss',
    per_num_hands: 'per {num} hands',
    per_num_mistakes: 'per {num} mistakes',
    xxx_moves: '{num} moves',
    ev_mistake_note: 'per {num} hands',
    frequency_diff: 'Frequency Diff',
    insight: 'Insight Ipsum',
    num_moves: '{num} Moves',
    column_management: 'Column Management',
    filter_management: {
      no_filters: 'No filters found',
      no_filters_sub: `You’ve filtered all your filters. <br>
      Try typing something else to the search box.`,
    },
    delete_hands_dialog: {
      title: `Delete hands`,
      text: `You're about to delete your hands`,
      delete_text: 'Delete {n} hand | Delete {n} hands',
      delete_all_text: 'Delete all {num} hands',
      delete_all_text_prompt:
        'You’re about to delete all of {num} hands. <br> This action is permanent!',
    },
    delete_reports_dialog: {
      title: `Delete reports`,
      text: `You're about to delete your reports`,
      delete_text: 'Delete {n} report | Delete {n} reports',
    },
    stats_chart: {
      perfect: 'Perfect',
      good: 'Good',
      innacurate: 'Inaccurate',
      mistake: 'Mistake',
      blunder: 'Blunder',
    },
    stats_table: {
      head: {
        total: 'Total',
        perfect: 'Perfect',
        good: 'Good',
        innacurate: 'Inaccurate',
        mistake: 'Mistake',
        blunder: 'Blunder',
      },
      situation_street: {
        all_streets: 'All streets',
        preflop: 'Preflop',
        flop: 'Flop',
        turn: 'Turn',
        river: 'River',
      },
      pot_type: {
        all_types: 'All types',
        startofhand: 'StartOfHand',
        srp: 'SRP',
        threebet: '3bet',
        fourbet: '4bet',
        limp: 'Limp',
        iso: 'ISO',
        fivebet: '5bet',
        rfi: 'RFI',
        vssrp: 'vsSRP',
        vsthreebet: 'vs3bet',
        vsfourbet: 'vs4bet',
        vsfivebet: 'vs5bet',
        vslimp: 'vsLimp',
        vsiso: 'vsIso',
        squeeze: 'Squeeze',
        possiblesqueeze: 'vs Raise-Call',

        vssqueeze: 'vs Squeeze',
      },
      player_position: {
        all_positions: 'All positions',
        utg: 'UTG',
        'utg+1': 'UTG1',
        'utg+2': 'UTG2',
        'utg+3': 'UTG3',
        utg1: 'UTG1',
        utg2: 'UTG2',
        utg3: 'UTG3',
        lj: 'LJ',
        hj: 'HJ',
        co: 'CO',
        btn: 'BTN',
        sb: 'SB',
        bb: 'BB',
        str: 'STR',
        ip: 'IP',
        oop: 'OOP',
        mp: 'MP',
      },
      player_aggression_preflop: {
        all: 'All',
        aggressor: 'Preflop Raiser',
        defender: 'Preflop Caller',
      },
      moves_by_street: {
        title: 'Street',
        text: 'Betting rounds:<br/> Preflop, Flop, Turn, River',
      },
      preflop_actions_table: {
        title: 'Preflop Action',
        text: 'Preflop action:<br/> Limp, Iso, SRP, 3BP, 4BP, 5BP',
      },
      positions_table: {
        title: 'Position',
        text: `Hero's Seat: UTG-BB`,
      },
      aggressor_defender_table: {
        title: 'Preflop Aggression',
        text: 'Hero Preflop Aggression:<br/> Preflop Raiser, Preflop Caller',
      },
    },
    sources: {
      file_upload: 'File Upload',
      text_upload: 'Text Upload',
      table_wizard: 'Table Wizard',
      practice: 'Practice',
      poker_wizard: 'Play Mode',
      poker_mode: 'Play Mode',
    },
    colorNote: {
      enter_note_text: 'Enter note text',
      hand_note_updated: 'Hand note updated successfully!',
      hand_note_update_failed: 'Hand note update failed!',
      hand_color_tag_updated: 'Hand color tag updated successfully!',
      hand_color_tag_update_failed: 'Hand color tag update failed!',
    },
  },
  icm_calc: {
    title: 'ICM Calculator',
    subtitle: 'Calculate ICM equity for a given stack distribution',
    stacks: 'Stacks',
    prizes: 'Prizes',
  },
}

export default en
